export type Maybe<T> = T | null
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  _Any: any
  DateTime: any
  Date: any
  ISO8601DateTime: any
  DateTimeWithZone: any
  JSON: any
  Email: any
  Upload: any
}

export type _Entity = User | Invoice | UserPrescription | Subscription

/**
 * The sdl representing the federated service capabilities. Includes federation
 * directives, removes federation types, and includes rest of full schema after
 * schema directives have been applied
 */
export type _Service = {
  __typename?: "_Service"
  sdl?: Maybe<Scalars["String"]>
}

export type AcceptDowngradeOfferParams = {
  productIds: Array<Scalars["Int"]>
  variant: Scalars["String"]
}

export type AcceptStartQuizAgreementsParams = {
  journeyKind: JourneyKindEnum
}

export enum ActionEnum {
  CreateCoveLead = "create_cove_lead",
  CreateCoveUserPendingCheckout = "create_cove_user_pending_checkout",
  CreateCoveUserPendingAcceptLegals = "create_cove_user_pending_accept_legals",
  CreateCoveUserPendingQuiz = "create_cove_user_pending_quiz",
  CreateCoveUserPendingTreatmentApproval = "create_cove_user_pending_treatment_approval",
  CreateCoveUserPendingAnnualRenewal = "create_cove_user_pending_annual_renewal",
  CreateCoveUserWithSubscriptions = "create_cove_user_with_subscriptions",
  CreateKeepsUserWithSubscription = "create_keeps_user_with_subscription"
}

export enum AcuteMedicationTakenTimeframeEnum {
  HalfHour = "half_hour",
  Hour = "hour",
  MoreThanHour = "more_than_hour",
  NotTaken = "not_taken"
}

export type Address = {
  __typename?: "Address"
  city?: Maybe<Scalars["String"]>
  id: Scalars["Int"]
  state?: Maybe<Scalars["String"]>
  streetAddress1?: Maybe<Scalars["String"]>
  streetAddress2?: Maybe<Scalars["String"]>
  zipCode?: Maybe<Scalars["String"]>
}

export type AddressParams = {
  streetAddress1?: Maybe<Scalars["String"]>
  streetAddress2?: Maybe<Scalars["String"]>
  city?: Maybe<Scalars["String"]>
  state?: Maybe<Scalars["String"]>
  zipCode?: Maybe<Scalars["String"]>
}

export enum AgreementNameEnum {
  PrivacyPolicy = "privacy_policy",
  TermsOfUse = "terms_of_use",
  KeepsMgpNoticePrivacy = "keeps_mgp_notice_privacy",
  InformedConsent = "informed_consent",
  KeepsMgpSelfPayAgreement = "keeps_mgp_self_pay_agreement",
  SubscriptionAgreementOld = "subscription_agreement_old",
  TexasNConcerningComplaints = "texas_n_concerning_complaints",
  ReturnsPolicyOld = "returns_policy_old",
  ReturnsPolicy = "returns_policy",
  SubscriptionAgreement = "subscription_agreement"
}

export enum AlternativeUsedMedicationsEnum {
  Ibgard = "ibgard",
  Fdgard = "fdgard",
  PeppermintOil = "peppermint_oil",
  CarawayOil = "caraway_oil",
  Melatonin = "melatonin",
  CbdOrMarijuana = "cbd_or_marijuana",
  Acupuncture = "acupuncture",
  DietaryRestrictions = "dietary_restrictions",
  Aromatherapy = "aromatherapy",
  Hypotherapy = "hypotherapy",
  PsychologistOrTherapist = "psychologist_or_therapist",
  PhysicalTherapy = "physical_therapy",
  Yoga = "yoga",
  BakingSoda = "baking_soda",
  Chamomile = "chamomile",
  GingerRoot = "ginger_root",
  MarshmallowRoot = "marshmallow_root",
  SlipperyElm = "slippery_elm",
  None = "none",
  Other = "other"
}

export enum AmountTypeEnum {
  Count = "count",
  Oz = "oz",
  Gm = "gm",
  Ml = "ml"
}

export type AnalyticsEvent = {
  __typename?: "AnalyticsEvent"
  email?: Maybe<Scalars["String"]>
  event: Scalars["String"]
  id: Scalars["Int"]
  payload: Scalars["String"]
  userId?: Maybe<Scalars["String"]>
}

export type ApproveTreatmentParams = {
  journeyKind: JourneyKindEnum
}

export enum AssociationsWithAuraEnum {
  SymptomsLastLongerThanHour = "symptoms_last_longer_than_hour",
  SymptomsContinueAfterHeadache = "symptoms_continue_after_headache",
  SymptomsThatIncludeMotorWeakness = "symptoms_that_include_motor_weakness",
  ExperiencedAuraDifferentThanPrevious = "experienced_aura_different_than_previous",
  OccurredFirstTimeWhenUsedOralContraceptivePill = "occurred_first_time_when_used_oral_contraceptive_pill",
  None = "none"
}

export enum AurasBuildInEnum {
  FewSeconds = "few_seconds",
  SeveralMinutes = "several_minutes",
  AnHourOrLonger = "an_hour_or_longer"
}

export enum BackPainDescriptionEnum {
  Sharp = "sharp",
  Dull = "dull",
  Throbbing = "throbbing",
  Other = "other"
}

export enum BackPainLocationEnum {
  UpperRight = "upper_right",
  UpperLeft = "upper_left",
  LowerRight = "lower_right",
  LowerLeft = "lower_left",
  Center = "center",
  AlongSpine = "along_spine",
  Neck = "neck"
}

export enum BackPainSymptomsEnum {
  BowelControl = "bowel_control",
  LegNumbness = "leg_numbness",
  BackSurgery = "back_surgery",
  FeverOrWeightloss = "fever_or_weightloss",
  RecentTrauma = "recent_trauma",
  None = "none"
}

export enum CancellationReasonEnum {
  /** 5th order test */
  FifthOrderTest = "fifth_order_test",
  /** Annual Rx Renewal - General */
  AnnualRxRenewalGeneral = "annual_rx_renewal_general",
  /** Annual Rx Renewal - NJ */
  AnnualRxRenewalNj = "annual_rx_renewal_nj",
  /** Annual Rx exRenewal - OOS */
  AnnualRxRenewalOos = "annual_rx_renewal_oos",
  /** Auto-Subscription */
  AutoSubscription = "auto_subscription",
  /** Bad service */
  BadService = "bad_service",
  /** Canceled after free order */
  CanceledAfterFreeOrder = "canceled_after_free_order",
  /** Changed Mind */
  ChangedMind = "changed_mind",
  /** Consultation Drop Off */
  ConsultationDropOff = "consultation_drop_off",
  /** Competitor */
  Competitor = "competitor",
  /** Different Treatment */
  DifferentTreatment = "different_treatment",
  /** Dispute */
  Dispute = "dispute",
  /** Effectiveness */
  Effectiveness = "effectiveness",
  /** Habit */
  Habit = "habit",
  /** Hesitant about Cove */
  HesitantAboutCove = "hesitant_about_cove",
  /** Get-started offer confusion */
  GetStartedOfferConfusion = "get_started_offer_confusion",
  /** In-Person Doctor */
  InPersonDoctor = "in_person_doctor",
  /** Insurance */
  Insurance = "insurance",
  /** Medical */
  Medical = "medical",
  /** Moved */
  Moved = "moved",
  /** Non-cancel */
  NonCancel = "non_cancel",
  /** Not Eligible */
  NotEligible = "not_eligible",
  /** Order Complication */
  OrderComplication = "order_complication",
  /** Our Offering */
  OurOffering = "our_offering",
  /** Out Of State */
  OutOfState = "out_of_state",
  /** Photo Drops */
  PhotoDrops = "photo_drops",
  /** Price */
  Price = "price",
  /** Quiz Not Finished */
  QuizNotFinished = "quiz_not_finished",
  /** Rx Depleted */
  RxDepleted = "rx_depleted",
  /** Surplus */
  Surplus = "surplus",
  /** Technical Issue */
  TechnicalIssue = "technical_issue",
  /** Other */
  CancelOther = "cancel_other",
  /** Think It Over */
  ThinkItOver = "think_it_over",
  /** Unsure About Treatment */
  UnsureAboutTreatment = "unsure_about_treatment",
  /** Video Drop* */
  VideoDrop = "video_drop",
  /** User Cancelled */
  UserCancelled = "user_cancelled",
  /** User Cancelled from Site */
  UserCancelledFromSite = "user_cancelled_from_site",
  /** Rx Transfer */
  RxTransfer = "rx_transfer",
  /** Reason Not Provided */
  ReasonNotProvided = "reason_not_provided",
  /** Bad Service: CX */
  BadServiceCx = "bad_service_cx",
  /** Bad Service: Doctor */
  BadServiceDoctor = "bad_service_doctor",
  /** Bad Service: Other */
  BadServiceOther = "bad_service_other",
  /** Bad Service: Shipping */
  BadServiceShipping = "bad_service_shipping",
  /** Bad Service: Website */
  BadServiceWebsite = "bad_service_website",
  /** Didn’t Complete Consultation */
  DidntCompleteConsultation = "didnt_complete_consultation",
  /** Duplicate */
  Duplicate = "duplicate",
  /** Effectiveness: Happy with Results */
  EffectivenessHappyWithResults = "effectiveness_happy_with_results",
  /** Effectiveness: Not Seeing Results */
  EffectivenessNotSeeingResults = "effectiveness_not_seeing_results",
  /** Medical: Concerned About Side Effects */
  MedicalConcernedAboutSideEffects = "medical_concerned_about_side_effects",
  /** Medical: Doc In Person */
  MedicalDocInPerson = "medical_doc_in_person",
  /** Medical: Doc Recommended */
  MedicalDocRecommended = "medical_doc_recommended",
  /** Medical: Donate Blood */
  MedicalDonateBlood = "medical_donate_blood",
  /** Medical: Fertility */
  MedicalFertility = "medical_fertility",
  /** Medical: Having Side Effects */
  MedicalHavingSideEffects = "medical_having_side_effects",
  /** Moving: Country */
  MovingCountry = "moving_country",
  /** Moving: Military */
  MovingMilitary = "moving_military",
  /** Moving: State */
  MovingState = "moving_state",
  /** Name/DOB Discrepancy */
  NameDobDiscrepancy = "name_dob_discrepancy",
  /** None Provided */
  NoneProvided = "none_provided",
  /** Other Cancellation Reason */
  OtherCancellationReason = "other_cancellation_reason",
  /** Price: Insurance */
  PriceInsurance = "price_insurance",
  /** Price: Temporary Hardship */
  PriceTemporaryHardship = "price_temporary_hardship",
  /** Price: Too Expensive */
  PriceTooExpensive = "price_too_expensive",
  /** Subscription: 5th order */
  Subscription_5thOrder = "subscription_5th_order",
  /** Subscription: Auto Renewal */
  SubscriptionAutoRenewal = "subscription_auto_renewal",
  /** Subscription: Trial Only */
  SubscriptionTrialOnly = "subscription_trial_only",
  /** Supply: Running Out */
  SupplyRunningOut = "supply_running_out",
  /** Supply: Surplus */
  SupplySurplus = "supply_surplus",
  /** Use: No Longer Wants To Treat Hair Loss */
  UseChangedMind = "use_changed_mind",
  /** Use: Cosmetic Concern */
  UseCosmeticConcern = "use_cosmetic_concern",
  /** Use: Different Treatment */
  UseDifferentTreatment = "use_different_treatment",
  /** Use: Habit */
  UseHabit = "use_habit",
  /** Plan adjustment - Admin */
  PlanAdjustmentAdmin = "plan_adjustment_admin",
  /** Product Swap */
  ProductSwap = "product_swap",
  /** Treatment Adjusted */
  TreatmentAdjusted = "treatment_adjusted"
}

export type CancelProductSubscriptionParams = {
  productId: Scalars["Int"]
  cancellationReason: Scalars["String"]
  cancellationReasonDetails?: Maybe<Scalars["String"]>
}

export type CheckoutParams = {
  nameOnCard?: Maybe<Scalars["String"]>
  stripeToken?: Maybe<Scalars["String"]>
  productIds?: Maybe<Array<Scalars["Int"]>>
  journeyKind?: Maybe<JourneyKindEnum>
  expectedPrice?: Maybe<Scalars["Float"]>
  cancelledProducts?: Maybe<Array<CancelProductSubscriptionParams>>
}

export type ClaimCheck = {
  __typename?: "ClaimCheck"
  requestId: Scalars["String"]
}

export enum CohortEnum {
  NoDiscount = "no_discount",
  FreeVisit = "free_visit",
  Reduced = "reduced"
}

export type Collection = {
  __typename?: "Collection"
  metadata?: Maybe<Metadata>
  objects?: Maybe<Array<Record<string, any>>>
}

export enum CommonSymptomsEnum {
  Heartburn = "heartburn",
  SpittingUpOfStomachContents = "spitting_up_of_stomach_contents",
  SourOrAcidicTasteInYourMouth = "sour_or_acidic_taste_in_your_mouth",
  BurningChestPain = "burning_chest_pain",
  DullSharpOrStabbingChestPain = "dull_sharp_or_stabbing_chest_pain",
  SoreThroat = "sore_throat",
  FeelingLumpInTheBackOfYourThroat = "feeling_lump_in_the_back_of_your_throat",
  PainWhenSwallowing = "pain_when_swallowing",
  DifficultySwallowing = "difficulty_swallowing",
  Nausea = "nausea",
  ExcessiveBelching = "excessive_belching",
  PersistentVomiting = "persistent_vomiting",
  GasBloatingOrUpsetStomach = "gas_bloating_or_upset_stomach",
  UnexplainedWeightLoss = "unexplained_weight_loss",
  LightheadednessDizzinessSweatingOrShortnessBreath = "lightheadedness_dizziness_sweating_or_shortness_breath",
  None = "none",
  Other = "other"
}

export type CompleteConsultationParams = {
  consultationId: Scalars["Int"]
  doctorNotes?: Maybe<Scalars["String"]>
}

export enum ConditionTypeEnum {
  StomachPain = "stomach_pain",
  Uti = "uti",
  EyeInfection = "eye_infection",
  BackPain = "back_pain",
  Uri = "uri"
}

export type Consultation = {
  __typename?: "Consultation"
  activeDoctorSelectedProducts: Array<Product>
  activeDoctorSelectedProductsCount: Scalars["Int"]
  activeUserSelectedProductEntries: Array<ProductEntry>
  activeUserSelectedProducts: Array<Product>
  awaitingCxMessage: Scalars["Boolean"]
  awaitingPatientMessage: Scalars["Boolean"]
  canDiagnose?: Maybe<Scalars["Boolean"]>
  caseClaimedAt?: Maybe<Scalars["ISO8601DateTime"]>
  caseCompletedAt?: Maybe<Scalars["DateTime"]>
  cohort?: Maybe<CohortEnum>
  completed: Scalars["Boolean"]
  consultationEvents?: Maybe<Array<ConsultationEvent>>
  consultationMessages: Array<ConsultationMessage>
  currentCoveConsultationsJourney?: Maybe<CoveConsultationsJourney>
  currentKeepsConsultationsJourney?: Maybe<KeepsConsultationsJourney>
  cxConsultationMessages: Array<CxConsultationMessage>
  declinedConsultationMessage?: Maybe<ConsultationMessage>
  diagnosis?: Maybe<DiagnosisEnum>
  diagnosisComment?: Maybe<Scalars["String"]>
  doctor?: Maybe<Doctor>
  doctorId: Scalars["Int"]
  doctorInState: Scalars["Boolean"]
  /** The consultation message displayed to a user in the treatment plan page. */
  doctorMessageDisplayed?: Maybe<ConsultationMessage>
  doctorMessagesCount: Scalars["Int"]
  doctorNotes?: Maybe<Scalars["String"]>
  doctorPaidAt?: Maybe<Scalars["Date"]>
  doseSpotMedId?: Maybe<Scalars["String"]>
  dosespotIframeUrl?: Maybe<Scalars["String"]>
  draftConsultationMessage?: Maybe<ConsultationMessage>
  eCommerceSelectedTreatment?: Maybe<DoctorTreatmentEnum>
  hairlineId?: Maybe<Scalars["Int"]>
  hasActiveAddTreatmentJourney: Scalars["Boolean"]
  hasActivePurchaseJourney: Scalars["Boolean"]
  hasActiveRenewalJourney: Scalars["Boolean"]
  hasActiveUpdateTreatmentJourney: Scalars["Boolean"]
  hasDoctorAssigned: Scalars["Boolean"]
  id: Scalars["Int"]
  incomplete: Scalars["Boolean"]
  keepsConsultationsJourneys: Array<KeepsConsultationsJourney>
  keepsPrescribeConsultationsJourneys: Array<KeepsConsultationsJourney>
  keepsRefillConsultationsJourneys?: Maybe<Array<KeepsConsultationsJourney>>
  mediaState: Scalars["String"]
  needsDosespotPrescription: Scalars["Boolean"]
  newMedia: Scalars["Boolean"]
  notAMatch: Scalars["Boolean"]
  notEligibleReason?: Maybe<NotEligibleReasonEnum>
  originalDoctor?: Maybe<Doctor>
  originalDoctorId?: Maybe<Scalars["Int"]>
  paid: Scalars["Boolean"]
  paidAt?: Maybe<Scalars["Date"]>
  phoneCallStatus: PhoneCallStatusEnum
  pinnedForDoctor: Scalars["Boolean"]
  prescribableProducts: Array<Product>
  prescribeMessageEverExisted: Scalars["Boolean"]
  prescribed: Scalars["Boolean"]
  prescriptions?: Maybe<Array<Prescription>>
  progressImages: Array<ProgressImage>
  refillPending: Scalars["Boolean"]
  requiresPhoneCall: Scalars["Boolean"]
  retakeMediaPrompted: Scalars["Boolean"]
  returningUserHash?: Maybe<Scalars["String"]>
  site: SiteEnum
  status: StatusEnum
  treatment?: Maybe<DoctorTreatmentEnum>
  treatmentMessageFromDoctor?: Maybe<Scalars["String"]>
  treatmentPlan?: Maybe<Scalars["String"]>
  unreadCxMessages: Scalars["Boolean"]
  unreadDoctorMessagesCount: Scalars["Int"]
  unreadPatientMessages: Scalars["Boolean"]
  user: User
  userId: Scalars["Int"]
  userRefillPending: Scalars["Boolean"]
  userSelectedProductEntries: Array<ProductEntry>
  userSelectedProducts: Array<Product>
  vertexId?: Maybe<Scalars["Int"]>
  videos: Array<Video>
  waitTime: Scalars["Int"]
}

export type ConsultationConsultationMessagesArgs = {
  newestFirst?: Maybe<Scalars["Boolean"]>
}

export type ConsultationAttributes = {
  userId?: Maybe<Scalars["Int"]>
  doctorId?: Maybe<Scalars["Int"]>
  originalDoctorId?: Maybe<Scalars["Int"]>
  status?: Maybe<StatusEnum>
  treatmentPlan?: Maybe<Scalars["String"]>
  doctorNotes?: Maybe<Scalars["String"]>
  doctorPaidAt?: Maybe<Scalars["ISO8601DateTime"]>
  caseCompletedAt?: Maybe<Scalars["ISO8601DateTime"]>
  caseClaimedAt?: Maybe<Scalars["ISO8601DateTime"]>
  paid?: Maybe<Scalars["Boolean"]>
  doseSpotMedId?: Maybe<Scalars["String"]>
  cohort?: Maybe<CohortEnum>
  eCommerceSelectedTreatment?: Maybe<DoctorTreatmentEnum>
  diagnosis?: Maybe<DiagnosisEnum>
  treatment?: Maybe<DoctorTreatmentEnum>
  doctorInState?: Maybe<Scalars["Boolean"]>
  vertexId?: Maybe<Scalars["Int"]>
  hairlineId?: Maybe<Scalars["Int"]>
  activeUserSelectedProducts?: Maybe<Array<Scalars["Int"]>>
  canDiagnose?: Maybe<Scalars["Boolean"]>
  diagnosisComment?: Maybe<Scalars["String"]>
}

export type ConsultationEvent = {
  __typename?: "ConsultationEvent"
  consultation: Consultation
  eventType: EventEnum
  id: Scalars["Int"]
}

export type ConsultationMessage = {
  __typename?: "ConsultationMessage"
  activeProducts: Array<Product>
  approvedByUser: Scalars["Boolean"]
  authorName: Scalars["String"]
  authorType: ConsultationMessageFromEnum
  body: Scalars["String"]
  createdAt: Scalars["DateTime"]
  doctor?: Maybe<Doctor>
  draft: Scalars["Boolean"]
  from: ConsultationMessageFromEnum
  id: Scalars["Int"]
  prescriptionStatus: ConsultationMessagePrescriptionStatusEnum
  unreadForDoctor: Scalars["Boolean"]
  unreadForPatient: Scalars["Boolean"]
}

export enum ConsultationMessageFromEnum {
  User = "user",
  Doctor = "doctor",
  SystemAsDoctor = "system_as_doctor"
}

export enum ConsultationMessagePrescriptionStatusEnum {
  NotAMatch = "not_a_match",
  Prescribe = "prescribe",
  Message = "message",
  MessageRenewalInitial = "message_renewal_initial",
  MessageRenewalFollowup = "message_renewal_followup",
  MessageRenewalFinal = "message_renewal_final",
  MessageOnboarding = "message_onboarding",
  MessageContinuousCare_6mo = "message_continuous_care_6mo"
}

export enum ContentTypeEnum {
  Mp4 = "mp4",
  Webm = "webm",
  Mov = "mov",
  Unknown = "unknown"
}

export type CoveConsultationsJourney = {
  __typename?: "CoveConsultationsJourney"
  consultation: Consultation
  coveQuizResponse: CoveQuizResponse
  flowType: CoveJourneyFlowTypeEnum
  id: Scalars["Int"]
  imagesFinishedAt?: Maybe<Scalars["DateTime"]>
  leadFinishedAt?: Maybe<Scalars["DateTime"]>
  mediaSet?: Maybe<MediaSet>
  paymentFinishedAt?: Maybe<Scalars["DateTime"]>
  prescribedAt?: Maybe<Scalars["DateTime"]>
  quizFinishedAt?: Maybe<Scalars["DateTime"]>
  refillNumber: Scalars["Int"]
  registrationFinishedAt?: Maybe<Scalars["DateTime"]>
  skippedImages?: Maybe<Scalars["Boolean"]>
}

export enum CoveJourneyFlowTypeEnum {
  Onboarding = "onboarding",
  Ecommerce = "ecommerce",
  Refill = "refill"
}

export type CoveMigraineEvent = {
  __typename?: "CoveMigraineEvent"
  acuteMedicationTakenTimeframe?: Maybe<AcuteMedicationTakenTimeframeEnum>
  additionalNotes?: Maybe<Scalars["String"]>
  endedAt?: Maybe<Scalars["ISO8601DateTime"]>
  id: Scalars["Int"]
  medicationEffective?: Maybe<Scalars["Boolean"]>
  ongoing: Scalars["Boolean"]
  painIntencity?: Maybe<Scalars["String"]>
  pastTwoDays?: Maybe<Array<PastTwoDaysEnum>>
  sideEffects?: Maybe<Scalars["Boolean"]>
  sideEffectsNotes?: Maybe<Scalars["String"]>
  startedAt?: Maybe<Scalars["ISO8601DateTime"]>
  user: User
}

export type CoveQuizMultiSelectMedicationResponse = {
  __typename?: "CoveQuizMultiSelectMedicationResponse"
  additionalNotes?: Maybe<Scalars["String"]>
  doctorPrescribe?: Maybe<DoctorPrescribeEnum>
  dosage?: Maybe<Scalars["String"]>
  drugName: MultiSelectMedicationsEnum
  effectiveness?: Maybe<EffectivenessEnum>
  id: Scalars["Int"]
  lastTimeUsed?: Maybe<LastTimeUsedEnum>
  sideEffects?: Maybe<SideEffectsEnum>
  sideEffectsNotes?: Maybe<Scalars["String"]>
  startedTaking?: Maybe<Scalars["String"]>
}

export type CoveQuizResponse = {
  __typename?: "CoveQuizResponse"
  additionalNotes?: Maybe<Scalars["String"]>
  allergicReactionNotes?: Maybe<Scalars["String"]>
  allergies: Array<Scalars["String"]>
  associationsWithAura: Array<AssociationsWithAuraEnum>
  aurasBuildIn?: Maybe<AurasBuildInEnum>
  bloodPressure?: Maybe<Scalars["Boolean"]>
  bloodPressureHigh?: Maybe<Scalars["Int"]>
  bloodPressureLow?: Maybe<Scalars["Int"]>
  bloodTestNotes?: Maybe<Scalars["String"]>
  diagnosisFromDoctor: Array<DiagnosisFromDoctorEnum>
  diagnosisFromDoctorOther?: Maybe<Scalars["String"]>
  emergencyRoomReason: Array<EmergencyRoomReasonEnum>
  emergencyRoomReasonOther?: Maybe<Scalars["String"]>
  environmentalTriggers: Array<EnvironmentalTriggersEnum>
  environmentalTriggersOther?: Maybe<Scalars["String"]>
  everTriedMedication?: Maybe<Scalars["Boolean"]>
  experiencedTypesOfHeadache: Array<ExperiencedTypesOfHeadacheEnum>
  experiencingNewSideEffects?: Maybe<Scalars["Boolean"]>
  experiencingNewSideEffectsNotes?: Maybe<Scalars["String"]>
  eyeExamNotes?: Maybe<Scalars["String"]>
  familyMembersWithHeadaches: Array<FamilyMembersWithHeadachesEnum>
  familyMembersWithHeadachesNotes?: Maybe<Scalars["String"]>
  gender?: Maybe<GendersEnum>
  hadSurgeriesOrInjuries?: Maybe<Scalars["Boolean"]>
  hadTests?: Maybe<Scalars["Boolean"]>
  happyWithExistingTreatment?: Maybe<Scalars["Boolean"]>
  hasAdditionalNotes?: Maybe<Scalars["Boolean"]>
  hasAllergies?: Maybe<Scalars["Boolean"]>
  hasDepression?: Maybe<Scalars["Boolean"]>
  hasOtherHealthConditions?: Maybe<Scalars["Boolean"]>
  hasPulse?: Maybe<Scalars["Boolean"]>
  hasQuestionForDoctor?: Maybe<Scalars["Boolean"]>
  hasQuestionForDoctorNotes?: Maybe<Scalars["String"]>
  headacheAttacksCount?: Maybe<HeadacheAttacksCountEnum>
  headacheFreeBetweenAttacks?: Maybe<Scalars["Boolean"]>
  headacheGoesToMaximumIn?: Maybe<HeadacheGoesToMaximumInEnum>
  headacheStartsAfter: Array<HeadacheStartsAfterEnum>
  headacheSymptoms: Array<HeadacheSymptomsEnum>
  headachesChangedInLastMonths?: Maybe<Scalars["Boolean"]>
  headachesChangedInLastMonthsNotes?: Maybe<Scalars["String"]>
  headachesDuration?: Maybe<HeadachesDurationEnum>
  headachesDurationNote?: Maybe<Scalars["String"]>
  headachesFrequency?: Maybe<HeadachesFrequencyEnum>
  headachesIntensity?: Maybe<Scalars["Int"]>
  headachesLocation: Array<HeadachesLocationEnum>
  headachesLocationOther?: Maybe<Scalars["String"]>
  headachesWakeUpAtNight?: Maybe<Scalars["Boolean"]>
  healthConditions: Array<HealthConditionsEnum>
  height?: Maybe<Scalars["Int"]>
  id: Scalars["Int"]
  imagingNotes?: Maybe<Scalars["String"]>
  lastBloodPressureTakenTime?: Maybe<LastTestedTimeEnum>
  lastDoctorVisitedTime?: Maybe<LastDoctorVisitedTimeEnum>
  lastPulseTakenTime?: Maybe<LastTestedTimeEnum>
  lifestyleChoices: Array<LifestyleChoicesEnum>
  lifestyleChoicesNotes?: Maybe<Scalars["String"]>
  lifestyleTriggers: Array<LifestyleTriggersEnum>
  lifestyleTriggersOther?: Maybe<Scalars["String"]>
  majorHealthOrLifestyleChange?: Maybe<Scalars["Boolean"]>
  majorHealthOrLifestyleChangeNotes?: Maybe<Scalars["String"]>
  medicationsOrSupplements: Array<Scalars["String"]>
  multiSelectMedicationResponses: Array<CoveQuizMultiSelectMedicationResponse>
  multiSelectMedications: Array<MultiSelectMedicationsEnum>
  newMedicationOrAllergiesOrMedicalConditions?: Maybe<Scalars["Boolean"]>
  newMedicationOrAllergiesOrMedicalConditionsNotes?: Maybe<Scalars["String"]>
  notTakingMedicationOrUnsatisfiedNotes?: Maybe<Scalars["String"]>
  otherHealthConditions: Array<Scalars["String"]>
  otherHealthConditionsDiagnosedRecently?: Maybe<Scalars["Boolean"]>
  otherHealthConditionsDiagnosedRecentlyNotes?: Maybe<Scalars["String"]>
  otherTestNotes?: Maybe<Scalars["String"]>
  otherTreatmentWays: Array<OtherTreatmentWaysEnum>
  otherTreatmentWaysEffective?: Maybe<Scalars["Boolean"]>
  otherTreatmentWaysEffectiveNotes?: Maybe<Scalars["String"]>
  otherTreatmentWaysOther?: Maybe<Scalars["String"]>
  otherUsedMedicationsNotes?: Maybe<Scalars["String"]>
  painDescription: Array<PainDescriptionEnum>
  painDescriptionOther?: Maybe<Scalars["String"]>
  pregnancyOrTryingPregnantOrBreastfeeding?: Maybe<Scalars["Boolean"]>
  pulse?: Maybe<Scalars["Int"]>
  relativesMedicalHistory: Array<RelativesMedicalHistoryEnum>
  satisfiedTreatment?: Maybe<Scalars["Boolean"]>
  spinalTapNotes?: Maybe<Scalars["String"]>
  stillTakingTreatmentFromDoctor?: Maybe<Scalars["Boolean"]>
  stopTreatmentReason?: Maybe<Scalars["String"]>
  stressfulEvents: Array<StressfulEventsEnum>
  stressfulEventsOther?: Maybe<Scalars["String"]>
  surgeriesOrInjuries?: Maybe<Scalars["String"]>
  takingMedicationConsistentlyAndIsSatisfied?: Maybe<Scalars["Boolean"]>
  takingMedicationsOrSupplements?: Maybe<Scalars["Boolean"]>
  tests: Array<TestsEnum>
  timeOfDayWhenHeadachesCome: Array<TimeOfDayWhenHeadachesComeEnum>
  treatmentFromDoctor: Array<Scalars["String"]>
  triedRxMedicationBefore?: Maybe<Scalars["Boolean"]>
  usedMedicationResponses: Array<CoveQuizUsedMedicationResponse>
  usedMedications: Array<UsedMedicationsEnum>
  usedProducts: Array<UsedProductsEnum>
  user: User
  visitedHealthcareDoctor: Array<VisitedHealthcareDoctorEnum>
  weight?: Maybe<Scalars["Int"]>
}

export type CoveQuizUsedMedicationResponse = {
  __typename?: "CoveQuizUsedMedicationResponse"
  additionalNotes?: Maybe<Scalars["String"]>
  dosage?: Maybe<Scalars["String"]>
  drugName: UsedMedicationsEnum
  effectiveness?: Maybe<EffectivenessEnum>
  id: Scalars["Int"]
  lastTimeUsed?: Maybe<LastTimeUsedEnum>
  sideEffects?: Maybe<SideEffectsEnum>
  sideEffectsNotes?: Maybe<Scalars["String"]>
  useAgain?: Maybe<Scalars["Boolean"]>
}

export enum Covid19SymptomsEnum {
  Covid19Exposure = "covid19_exposure",
  DryCough = "dry_cough",
  Chills = "chills",
  DifficultyBreathing = "difficulty_breathing",
  Fatigue = "fatigue",
  LossOfSmellTaste = "loss_of_smell_taste",
  DiarrheaVomiting = "diarrhea_vomiting",
  None = "none"
}

export type CreateAnalyticsEventParams = {
  event: Scalars["String"]
  userId?: Maybe<Scalars["String"]>
  email?: Maybe<Scalars["String"]>
  payload?: Maybe<Scalars["String"]>
}

export type CreateCoveMigraineEventParams = {
  startedAt: Scalars["ISO8601DateTime"]
  endedAt?: Maybe<Scalars["ISO8601DateTime"]>
  ongoing?: Maybe<Scalars["Boolean"]>
  acuteMedicationTakenTimeframe: AcuteMedicationTakenTimeframeEnum
  painIntencity: Scalars["String"]
  medicationEffective: Scalars["Boolean"]
  sideEffects: Scalars["Boolean"]
  sideEffectsNotes?: Maybe<Scalars["String"]>
  pastTwoDays: Array<PastTwoDaysEnum>
  additionalNotes?: Maybe<Scalars["String"]>
}

export type CreateEmailListParams = {
  email: Scalars["String"]
}

export type CreateEvensRefluxEventParams = {
  status: EventStatusEnum
  symptomsStart: Scalars["ISO8601DateTime"]
  symptomsEnd?: Maybe<Scalars["ISO8601DateTime"]>
  symptomsOngoing?: Maybe<Scalars["String"]>
  symptomsIntensity?: Maybe<Scalars["String"]>
  symptomsLocation?: Maybe<Scalars["String"]>
  symptomsAssociations?: Maybe<Array<Scalars["String"]>>
  symptomsAssociationsMoreInformation?: Maybe<Scalars["String"]>
  symptomsAssociationsOther?: Maybe<Scalars["String"]>
  triedMedication?: Maybe<Scalars["String"]>
  medicationTaken?: Maybe<Array<Scalars["String"]>>
  medicationTakenOther?: Maybe<Scalars["String"]>
  whenMedicationTaken?: Maybe<Scalars["String"]>
  wasMedicationEffective?: Maybe<Scalars["String"]>
  medicationMoreInformation?: Maybe<Scalars["String"]>
  medicationSideEffects?: Maybe<Scalars["String"]>
  medicationSideEffectsMoreInformation?: Maybe<Scalars["String"]>
  otherSymptoms?: Maybe<Scalars["String"]>
  otherTreatment?: Maybe<Scalars["String"]>
  otherInformation?: Maybe<Scalars["String"]>
}

export type CreateGiftCardParams = {
  gifterName: Scalars["String"]
  gifterEmail: Scalars["String"]
  gifterBillingZip: Scalars["String"]
  gifterMessage: Scalars["String"]
  ageVerified: Scalars["Boolean"]
  recipientName: Scalars["String"]
  recipientEmail: Scalars["String"]
  recipientSex: Scalars["String"]
  recipientState: Scalars["String"]
  recipientAppearence: Scalars["String"]
  stripeToken: Scalars["String"]
  giftAmountId: Scalars["String"]
}

export type CreatePharmacyParams = {
  name: Scalars["String"]
  addressAttributes?: Maybe<AddressParams>
  externalId: Scalars["String"]
  externalType: PharmacyExternalTypeEnum
  phoneNumber?: Maybe<Scalars["String"]>
  faxNumber?: Maybe<Scalars["String"]>
}

export type CreateQuizResponseParams = {
  content: Scalars["JSON"]
  configName: Scalars["String"]
  configVersion: Scalars["Int"]
  finalize?: Maybe<Scalars["Boolean"]>
  result?: Maybe<Scalars["JSON"]>
}

export type CreateQuizResponseResponse = {
  __typename?: "CreateQuizResponseResponse"
  error?: Maybe<QuizResponseError>
  quizResponse?: Maybe<QuizResponse>
}

export type CreateSubscriptionParams = {
  couponCode?: Maybe<Scalars["String"]>
  electronicInfo?: Maybe<Scalars["Boolean"]>
  nameOnCard?: Maybe<Scalars["String"]>
  stripeToken?: Maybe<Scalars["String"]>
  plan?: Maybe<Scalars["String"]>
  updatePlan?: Maybe<Scalars["Boolean"]>
  productIds?: Maybe<Array<Scalars["Int"]>>
}

export type CreateUserAddressParams = {
  state: Scalars["String"]
}

export type CreateUserConsultationParams = {
  plan: Scalars["String"]
}

export type CreateUserParams = {
  email: Scalars["Email"]
  firstName: Scalars["String"]
  lastName: Scalars["String"]
  password?: Maybe<Scalars["String"]>
  eCommerceUser: Scalars["Boolean"]
  address?: Maybe<CreateUserAddressParams>
  profile?: Maybe<CreateUserProfileParams>
  consultation?: Maybe<CreateUserConsultationParams>
  hash?: Maybe<Scalars["String"]>
}

export type CreateUserProfileParams = {
  gender: Scalars["String"]
  dob: Scalars["Date"]
  termsAccepted: Scalars["Boolean"]
}

export type CxConsultationMessage = {
  __typename?: "CxConsultationMessage"
  authorName: Scalars["String"]
  authorType: CxConsultationMessageFromEnum
  body: Scalars["String"]
  createdAt: Scalars["DateTime"]
  id: Scalars["Int"]
  unreadForDoctor: Scalars["Boolean"]
}

export enum CxConsultationMessageFromEnum {
  AdminUser = "admin_user",
  Doctor = "doctor"
}

export type CypressActionParams = {
  drugTypes?: Maybe<Array<DrugTypeEnum>>
  invoiceStatus?: Maybe<Scalars["String"]>
  invoiceCharged?: Maybe<Scalars["Boolean"]>
}

export type DeclineConsultationParams = {
  consultationId: Scalars["Int"]
  diagnosisComment?: Maybe<Scalars["String"]>
  journeyKind?: Maybe<JourneyKindEnum>
  doctorNotes?: Maybe<Scalars["String"]>
}

export enum DiagnosisEnum {
  MalePatternBaldness = "male_pattern_baldness",
  Other = "other",
  UnableToDiagnose = "unable_to_diagnose",
  OtherHairLoss = "other_hair_loss"
}

export enum DiagnosisFromDoctorEnum {
  ClusterHeadache = "cluster_headache",
  TensionHeadache = "tension_headache",
  Migraine = "migraine",
  None = "none",
  DontRemember = "dont_remember",
  Other = "other"
}

export type Doctor = {
  __typename?: "Doctor"
  canClaimCove: Scalars["Boolean"]
  canClaimEvens: Scalars["Boolean"]
  canClaimKeeps: Scalars["Boolean"]
  canClaimPicnic: Scalars["Boolean"]
  canClaimUrgentCare: Scalars["Boolean"]
  consultation?: Maybe<Consultation>
  consultations: Array<Consultation>
  consultationsActionRequired: Array<Consultation>
  consultationsActionRequiredCount: Scalars["Int"]
  consultationsPatientCaseFiles: Array<Consultation>
  consultationsPatientCaseFilesCount: Scalars["Int"]
  consultationsPinned: Array<Consultation>
  consultationsPinnedCount: Scalars["Int"]
  consultationsUnclaimed: Array<Consultation>
  consultationsUnclaimedCount: Scalars["Int"]
  doseSpotId?: Maybe<Scalars["Int"]>
  email: Scalars["String"]
  firstName: Scalars["String"]
  fullName: Scalars["String"]
  id: Scalars["Int"]
  lastName: Scalars["String"]
  licenseType?: Maybe<Scalars["String"]>
  medicalSchool?: Maybe<Scalars["String"]>
  messageTemplate?: Maybe<Scalars["String"]>
  photoUrl?: Maybe<Scalars["String"]>
  prescribableProducts: Array<Product>
  qualification?: Maybe<Scalars["String"]>
  residency?: Maybe<Scalars["String"]>
  signInCount?: Maybe<Scalars["Int"]>
  siteLicenses: Array<SiteEnum>
  undergraduate?: Maybe<Scalars["String"]>
}

export type DoctorConsultationArgs = {
  id?: Maybe<Scalars["Int"]>
  userId?: Maybe<Scalars["Int"]>
}

export type DoctorConsultationsActionRequiredArgs = {
  site?: Maybe<SiteEnum>
  offset?: Maybe<Scalars["Int"]>
  limit?: Maybe<Scalars["Int"]>
  consultationTag?: Maybe<FilterTagEnum>
  userId?: Maybe<Scalars["Int"]>
}

export type DoctorConsultationsActionRequiredCountArgs = {
  site?: Maybe<SiteEnum>
  consultationTag?: Maybe<FilterTagEnum>
}

export type DoctorConsultationsPatientCaseFilesArgs = {
  site?: Maybe<SiteEnum>
  offset?: Maybe<Scalars["Int"]>
  limit?: Maybe<Scalars["Int"]>
  consultationTag?: Maybe<FilterTagEnum>
  productId?: Maybe<Scalars["Int"]>
  userId?: Maybe<Scalars["Int"]>
}

export type DoctorConsultationsPatientCaseFilesCountArgs = {
  site?: Maybe<SiteEnum>
  consultationTag?: Maybe<FilterTagEnum>
  userId?: Maybe<Scalars["Int"]>
}

export type DoctorConsultationsPinnedArgs = {
  site?: Maybe<SiteEnum>
  offset?: Maybe<Scalars["Int"]>
  limit?: Maybe<Scalars["Int"]>
}

export type DoctorConsultationsPinnedCountArgs = {
  site?: Maybe<SiteEnum>
}

export type DoctorConsultationsUnclaimedArgs = {
  site?: Maybe<SiteEnum>
  offset?: Maybe<Scalars["Int"]>
  limit?: Maybe<Scalars["Int"]>
}

export type DoctorConsultationsUnclaimedCountArgs = {
  site?: Maybe<SiteEnum>
}

export type DoctorMessageTemplateArgs = {
  site: SiteEnum
  userId: Scalars["Int"]
  productIds?: Maybe<Array<Scalars["Int"]>>
  ableToDiagnose: Scalars["Boolean"]
  hairlineId?: Maybe<Scalars["Int"]>
  vertexId?: Maybe<Scalars["Int"]>
  refill?: Maybe<Scalars["Boolean"]>
}

export type DoctorPrescribableProductsArgs = {
  site: SiteEnum
}

export enum DoctorPrescribeEnum {
  Yes = "yes",
  No = "no",
  Unsure = "unsure"
}

export enum DoctorTreatmentEnum {
  FinasterideMinoxidil = "finasteride_minoxidil",
  Finasteride = "finasteride",
  Minoxidil = "minoxidil",
  Other = "other",
  None = "none",
  ConsultALocalDoctor = "consult_a_local_doctor"
}

export enum DosageTypeEnum {
  ChewableMg = "chewable_mg",
  CapsuleMg = "capsule_mg",
  PillMg = "pill_mg",
  PercentSolution = "percent_solution",
  OdtMg = "odt_mg",
  PowderMg = "powder_mg",
  SprayMl = "spray_ml",
  DropsOz = "drops_oz",
  SprayOz = "spray_oz",
  SprayMg = "spray_mg",
  SprayMcg = "spray_mcg",
  InjectableMg = "injectable_mg"
}

export enum DrugCategoryEnum {
  Acute = "acute",
  Preventative = "preventative",
  AntiNausea = "anti_nausea",
  Otc = "otc",
  Shampoo = "shampoo",
  HairLoss = "hair_loss",
  OralAntihistamine = "oral_antihistamine",
  IntraNasalSpray = "intra_nasal_spray",
  EyeDrops = "eye_drops",
  SoothingOption = "soothing_option",
  Decongestant = "decongestant"
}

export enum DrugClassEnum {
  NsaiDs = "NSAIDs",
  Triptan = "triptan",
  AntiNausea = "anti_nausea",
  BetaBlocker = "beta_blocker",
  Anticonvulsant = "anticonvulsant",
  Antidepressant = "antidepressant",
  DrugPackage = "drug_package",
  Ppi = "ppi",
  H2Blocker = "h2_blocker",
  Antacid = "antacid",
  Supplement = "supplement",
  Device = "device",
  Shampoo = "shampoo",
  Topical = "topical",
  DhtBlocker = "dht_blocker",
  AntiCgrp = "anti_cgrp",
  RxMedication = "rx_medication",
  OtcMedication = "otc_medication",
  OtherTreatment = "other_treatment"
}

export enum DrugSymptomsEnum {
  Congestion = "congestion",
  RunnyItchyNose = "runny_itchy_nose",
  Sneezing = "sneezing",
  PostNasalDrip = "post_nasal_drip",
  ItchyThroat = "itchy_throat",
  ItchyWateryEyes = "itchy_watery_eyes",
  RedEyes = "red_eyes",
  Headaches = "headaches",
  NasalDryness = "nasal_dryness"
}

export enum DrugTypeEnum {
  Finasteride = "finasteride",
  Minoxidil = "minoxidil",
  Ketoconazole = "ketoconazole",
  GenericMinoxidil = "generic_minoxidil",
  MinoxidilFoam = "minoxidil_foam",
  Metoclopramide = "metoclopramide",
  Naproxen = "naproxen",
  Rizatriptan = "rizatriptan",
  Sumatriptan = "sumatriptan",
  Topiramate = "topiramate",
  Amitriptyline = "amitriptyline",
  Metoprolol = "metoprolol",
  Propranolol = "propranolol",
  Magnesium = "magnesium",
  Riboflavin = "riboflavin",
  MigraineRelief = "migraine_relief",
  PainRelief = "pain_relief",
  PainAndPreventative = "pain_and_preventative",
  CovePackageFree = "cove_package_free",
  Legacy = "legacy",
  Esomeprazole = "esomeprazole",
  Omeprazole = "omeprazole",
  Ranitidine = "ranitidine",
  CalciumCarbonate = "calcium_carbonate",
  Ondansetron = "ondansetron",
  Naratriptan = "naratriptan",
  Eletriptan = "eletriptan",
  Nortriptyline = "nortriptyline",
  Zolmitriptan = "zolmitriptan",
  Coq10 = "coq10",
  MedicalFee = "medical_fee",
  Nerivio = "nerivio",
  Pantoprazole = "pantoprazole",
  Rabeprazole = "rabeprazole",
  Rimegepant = "rimegepant",
  Diclofenac = "diclofenac",
  RxMedication = "rx_medication",
  OtcMedication = "otc_medication",
  OtherTreatment = "other_treatment",
  Cetirizine = "cetirizine",
  Fexofenadine = "fexofenadine",
  Loratadine = "loratadine",
  Desloratadine = "desloratadine",
  Diphenhydramine = "diphenhydramine",
  Fluticasone = "fluticasone",
  Mometasone = "mometasone",
  AzelastineNasalSpray = "azelastine_nasal_spray",
  AzelastineEyeDrops = "azelastine_eye_drops",
  SalineNasalSpray = "saline_nasal_spray",
  CetiriD = "cetiri_d",
  Pseudoephedrine = "pseudoephedrine",
  Dymista = "dymista",
  Levocetirizine = "levocetirizine",
  Bundle = "bundle",
  GalcanezumabGnlm = "galcanezumab_gnlm",
  Beam = "beam"
}

export enum DurationEnum {
  LessThanOneYear = "less_than_one_year",
  OneToTwoYears = "one_to_two_years",
  ThreeToFourYears = "three_to_four_years",
  MoreThanFiveYears = "more_than_five_years"
}

export type EagleOrder = {
  __typename?: "EagleOrder"
  address?: Maybe<Address>
  createdAt: Scalars["Date"]
  id: Scalars["Int"]
  latestShipmentDate?: Maybe<Scalars["Date"]>
  permittedEvents?: Maybe<Array<Scalars["String"]>>
  pharmacyShipmentConfirmations?: Maybe<Array<EagleShipmentConfirmation>>
  productEntries?: Maybe<Array<ProductEntry>>
  remoteStatus: RemoteStatusEnum
  shipmentDates: Array<Scalars["Date"]>
  shippingType?: Maybe<ShippingMethodEnum>
  shippingTypeOverride?: Maybe<ShippingMethodEnum>
}

export type EagleShipmentConfirmation = {
  __typename?: "EagleShipmentConfirmation"
  id: Scalars["Int"]
  patientShippingAddressLine1?: Maybe<Scalars["String"]>
  patientShippingAddressLine2?: Maybe<Scalars["String"]>
  patientShippingCity?: Maybe<Scalars["String"]>
  patientShippingState?: Maybe<Scalars["String"]>
  patientShippingZip?: Maybe<Scalars["String"]>
  trackingId?: Maybe<Scalars["String"]>
}

export enum EffectivenessEnum {
  Always = "always",
  Sometimes = "sometimes",
  Rarely = "rarely",
  Never = "never"
}

export type EmailList = {
  __typename?: "EmailList"
  email: Scalars["String"]
  id: Scalars["Int"]
}

export enum EmergencyRoomReasonEnum {
  RanOutOfExistingAcutePainMedication = "ran_out_of_existing_acute_pain_medication",
  LackOfPainReliefWithHomeMedications = "lack_of_pain_relief_with_home_medications",
  NauseaOrVomiting = "nausea_or_vomiting",
  FearOfSomeDangerousCondition = "fear_of_some_dangerous_condition",
  WorseningOrNewTypeOfHeadache = "worsening_or_new_type_of_headache",
  DontHaveAnyOtherDoctor = "dont_have_any_other_doctor",
  Other = "other"
}

export enum EnvironmentalTriggersEnum {
  WeatherChanges = "weather_changes",
  CertainOdors = "certain_odors",
  Noise = "noise",
  BrightOrFlickeringLights = "bright_or_flickering_lights",
  Motion = "motion",
  Other = "other",
  None = "none"
}

export enum ErrorTypeEnum {
  NotFound = "not_found",
  NotEditable = "not_editable",
  Invalid = "invalid",
  ConfigNotFound = "config_not_found"
}

export enum EvensDiagnosisFromDoctorEnum {
  GastroesophagealRefluxDisease = "gastroesophageal_reflux_disease",
  BarrettsEsophagus = "barretts_esophagus",
  Esophagitis = "esophagitis",
  EosinophilicEsophagitis = "eosinophilic_esophagitis",
  EsophagealStrictures = "esophageal_strictures",
  StrictureIrSchatzkisRing = "stricture_ir_schatzkis_ring",
  LaryngopharyngealReflux = "laryngopharyngeal_reflux",
  Gastritis = "gastritis",
  NonAcidRefluxDisease = "non_acid_reflux_disease",
  FunctionalHeartburn = "functional_heartburn",
  HiatalHernia = "hiatal_hernia",
  IrritableBowelSyndrome = "irritable_bowel_syndrome",
  DontRemember = "dont_remember",
  None = "none",
  Other = "other"
}

export enum EvensGendersEnum {
  Male = "male",
  Female = "female"
}

export enum EvensHealthConditionsEnum {
  OsteopeniaOrOsteoporosis = "osteopenia_or_osteoporosis",
  ClostridiumDifficileInfection = "clostridium_difficile_infection",
  VitaminOrMineralDeficiencies = "vitamin_or_mineral_deficiencies",
  KidneyDisease = "kidney_disease",
  PulmonaryDisease = "pulmonary_disease",
  HeartArrhythmiasOrElectricalHeartAbnormality = "heart_arrhythmias_or_electrical_heart_abnormality",
  MicroscopicColitis = "microscopic_colitis",
  HiatalHernia = "hiatal_hernia",
  ImmunosuppressedState = "immunosuppressed_state",
  Cancer = "cancer",
  IronDeficiencyAnemia = "iron_deficiency_anemia",
  None = "none"
}

export enum EvensLifestyleEnum {
  MoreThanFiveAlcoholicDrinksPerWeek = "more_than_five_alcoholic_drinks_per_week",
  SmokeCigarettesOrUseNicotineReplacementTherapies = "smoke_cigarettes_or_use_nicotine_replacement_therapies",
  UseRecreationalDrugs = "use_recreational_drugs",
  None = "none"
}

export type EvensQuizResponse = {
  __typename?: "EvensQuizResponse"
  acidRefluxOnPregnancy?: Maybe<Scalars["Boolean"]>
  additionalNotes?: Maybe<Scalars["String"]>
  allergies: Array<Scalars["String"]>
  alternativeUsedMedications: Array<AlternativeUsedMedicationsEnum>
  alternativeUsedMedicationsNotes?: Maybe<Scalars["String"]>
  alternativeUsedMedicationsOther?: Maybe<Scalars["String"]>
  caffeineTimesPerWeek?: Maybe<Scalars["Int"]>
  carbonatedBeveragesTimesPerWeek?: Maybe<Scalars["Int"]>
  chocolateTimesPerWeek?: Maybe<Scalars["Int"]>
  combinedMedicationsAdditionalNotes?: Maybe<Scalars["String"]>
  combinedMedicationsDoctorPrescribe?: Maybe<UsedMedicationsDoctorPrescribeEnum>
  combinedMedicationsDosage?: Maybe<Scalars["String"]>
  combinedMedicationsEffectiveness?: Maybe<UsedMedicationsEffectivenessEnum>
  combinedMedicationsLastTimeUsed?: Maybe<UsedMedicationsLastTimeUsedEnum>
  combinedMedicationsSideEffects?: Maybe<UsedMedicationsSideEffectsEnum>
  combinedMedicationsSideEffectsNotes?: Maybe<Scalars["String"]>
  commonSymptoms: Array<CommonSymptomsEnum>
  commonSymptomsOther?: Maybe<Scalars["String"]>
  diagnosisFromDoctor: Array<EvensDiagnosisFromDoctorEnum>
  diagnosisFromDoctorOther?: Maybe<Scalars["String"]>
  duration?: Maybe<DurationEnum>
  fattyFoodsTimesPerWeek?: Maybe<Scalars["Int"]>
  frequency?: Maybe<FrequencyEnum>
  gender?: Maybe<EvensGendersEnum>
  hadTests?: Maybe<Scalars["Boolean"]>
  hasOtherHealthConditions?: Maybe<Scalars["Boolean"]>
  healthConditions: Array<EvensHealthConditionsEnum>
  heartburnSymptoms: Array<HeartburnSymptomsEnum>
  heartburnWakeUpAtNight?: Maybe<HeartburnWakeUpAtNightEnum>
  height?: Maybe<Scalars["Int"]>
  id: Scalars["Int"]
  lessCommonSymptoms: Array<LessCommonSymptomsEnum>
  lessCommonSymptomsOther?: Maybe<Scalars["String"]>
  lifestyle: Array<EvensLifestyleEnum>
  lifestyleOther?: Maybe<Scalars["String"]>
  medicationsOrSupplements: Array<Scalars["String"]>
  otherHealthConditionsDiagnosedRecently?: Maybe<Scalars["Boolean"]>
  otherHealthConditionsDiagnosedRecentlyNotes?: Maybe<Scalars["String"]>
  peppermintTimesPerWeek?: Maybe<Scalars["Int"]>
  pregnancyOrTryingPregnantOrBreastfeeding?: Maybe<Scalars["Boolean"]>
  pregnancyTrimester?: Maybe<PregnancyTrimesterEnum>
  relativesHealthCondition?: Maybe<EvensRelativesMedicalHistoryEnum>
  satisfiedTreatment?: Maybe<Scalars["String"]>
  spicyFoodsTimesPerWeek?: Maybe<Scalars["Int"]>
  symptomsAtNight?: Maybe<SymptomsAtNightEnum>
  symptomsFrequencyWithMeal?: Maybe<SymptomsFrequencyWithMealEnum>
  symptomsWorseAtLyingDown?: Maybe<SymptomsWorseAtLyingDownEnum>
  tests: Array<EvensTestsEnum>
  testsOther?: Maybe<Scalars["String"]>
  treatmentFromDoctor: Array<TreatmentsFromDoctorEnum>
  treatmentFromDoctorOther?: Maybe<Scalars["String"]>
  usedMedicationResponses: Array<EvensQuizUsedMedicationResponse>
  usedMedications: Array<UsedMedicationsDrugsEnum>
  usedMedicationsOther?: Maybe<Scalars["String"]>
  user: User
  visitedHealthcareDoctor: Array<EvensVisitedHealthcareDoctorEnum>
  weight?: Maybe<Scalars["Int"]>
}

export type EvensQuizUsedMedicationResponse = {
  __typename?: "EvensQuizUsedMedicationResponse"
  additionalNotes?: Maybe<Scalars["String"]>
  doctorPrescribe?: Maybe<UsedMedicationsDoctorPrescribeEnum>
  dosage?: Maybe<Scalars["String"]>
  drugName: UsedMedicationsDrugsEnum
  drugNameOther?: Maybe<Scalars["String"]>
  effectiveness?: Maybe<UsedMedicationsEffectivenessEnum>
  lastTimeUsed?: Maybe<UsedMedicationsLastTimeUsedEnum>
  sideEffects?: Maybe<UsedMedicationsSideEffectsEnum>
  sideEffectsNotes?: Maybe<Scalars["String"]>
}

export type EvensRefluxEvent = {
  __typename?: "EvensRefluxEvent"
  id: Scalars["Int"]
  medicationMoreInformation?: Maybe<Scalars["String"]>
  medicationSideEffects?: Maybe<Scalars["String"]>
  medicationSideEffectsMoreInformation?: Maybe<Scalars["String"]>
  medicationTaken: Array<Scalars["String"]>
  medicationTakenOther?: Maybe<Scalars["String"]>
  otherInformation?: Maybe<Scalars["String"]>
  otherSymptoms?: Maybe<Scalars["String"]>
  otherTreatment?: Maybe<Scalars["String"]>
  status: EventStatusEnum
  symptomsAssociations: Array<Scalars["String"]>
  symptomsAssociationsMoreInformation?: Maybe<Scalars["String"]>
  symptomsAssociationsOther?: Maybe<Scalars["String"]>
  symptomsEnd?: Maybe<Scalars["ISO8601DateTime"]>
  symptomsIntensity?: Maybe<Scalars["String"]>
  symptomsLocation?: Maybe<Scalars["String"]>
  symptomsOngoing?: Maybe<Scalars["String"]>
  symptomsStart: Scalars["ISO8601DateTime"]
  triedMedication?: Maybe<Scalars["String"]>
  wasMedicationEffective?: Maybe<Scalars["String"]>
  whenMedicationTaken?: Maybe<Scalars["String"]>
}

export enum EvensRelativesMedicalHistoryEnum {
  Yes = "yes",
  No = "no",
  NotSure = "not_sure"
}

export enum EvensTestsEnum {
  Imaging = "imaging",
  UpperEndoscopy = "upper_endoscopy",
  Colonoscopy = "colonoscopy",
  PhMonitoring = "ph_monitoring",
  EsophagealManometry = "esophageal_manometry",
  BloodWork = "blood_work",
  Other = "other"
}

export enum EvensVisitedHealthcareDoctorEnum {
  PrimaryCareDoctor = "primary_care_doctor",
  GastroenterologistOrHepatologist = "gastroenterologist_or_hepatologist",
  UrgentCareEmergencyRoom = "urgent_care_emergency_room",
  OtherHealthcareProfessional = "other_healthcare_professional",
  No = "no"
}

export enum EventEnum {
  QuestionsAnswered = "questions_answered",
  ClaimedByDoctor = "claimed_by_doctor",
  ConsultationCompleted = "consultation_completed",
  TreatmentChangeRequested = "treatment_change_requested",
  FollowedUp = "followed_up",
  FollowUpRequested = "follow_up_requested"
}

export enum EventStatusEnum {
  Draft = "draft",
  Completed = "completed",
  Edited = "edited"
}

export enum ExperiencedTypesOfHeadacheEnum {
  IntenseWithinSeconds = "intense_within_seconds",
  Morning = "morning",
  ProgressiveConsistent = "progressive_consistent",
  WithPosturalChanges = "with_postural_changes",
  None = "none"
}

export enum EyeInfectionPainDescriptionEnum {
  Sharp = "sharp",
  Dull = "dull",
  Irritation = "irritation",
  Other = "other"
}

export enum EyeInfectionSideEnum {
  Left = "left",
  Right = "right",
  Both = "both"
}

export enum EyeInfectionSymptomsEnum {
  Bloodshot = "bloodshot",
  Itch = "itch",
  Watery = "watery",
  Pus = "pus",
  None = "none"
}

export enum FamilyMedicalHistoryEnum {
  Parents = "parents",
  Siblings = "siblings",
  FathersSide = "fathers_side",
  MothersSide = "mothers_side",
  None = "none",
  NotSure = "not_sure"
}

export enum FamilyMembersWithHeadachesEnum {
  Parents = "parents",
  Siblings = "siblings",
  AuntsOrUncles = "aunts_or_uncles",
  Grandparents = "grandparents",
  Other = "other",
  None = "none"
}

export enum FilterTagEnum {
  Incomplete = "incomplete",
  Completed = "completed",
  UnreadPatientMessages = "unread_patient_messages",
  UnreadCxMessages = "unread_cx_messages",
  AwaitingPatientMessage = "awaiting_patient_message",
  AwaitingCxMessage = "awaiting_cx_message",
  Prescribed = "prescribed",
  NotAMatch = "not_a_match",
  RefillPending = "refill_pending",
  PendingPhoneRetry = "pending_phone_retry"
}

export type FinishQuizParams = {
  journeyKind: JourneyKindEnum
}

export type FlipperFlag = {
  __typename?: "FlipperFlag"
  disableAddressValidation: Scalars["Boolean"]
  isEnabled: Scalars["Boolean"]
  renewalJourneyFlowFrontend: Scalars["Boolean"]
}

export type FlipperFlagIsEnabledArgs = {
  flag: Scalars["String"]
}

export enum FlowTypeEnum {
  Default = "default",
  ECommerce = "e_commerce",
  Ltdd = "ltdd"
}

export enum FrequencyEnum {
  LessThanOncePerWeek = "less_than_once_per_week",
  OneToTwoPerWeek = "one_to_two_per_week",
  ThreeToFourPerWeek = "three_to_four_per_week",
  FiveToSixPerWeek = "five_to_six_per_week",
  EveryDay = "every_day"
}

export enum GendersEnum {
  Male = "male",
  Female = "female"
}

/** Generic message object */
export type GenericMessage = ConsultationMessage | CxConsultationMessage

export type GetStartedOffer = {
  __typename?: "GetStartedOffer"
  initialProduct: Product
  trialProduct: Product
}

export type GiftCard = {
  __typename?: "GiftCard"
  amountRefunded: Scalars["Float"]
  couponCode?: Maybe<Scalars["String"]>
  giftAmount?: Maybe<Scalars["Float"]>
  giftDurationInMonths?: Maybe<Scalars["Int"]>
  giftMonthsRemaining?: Maybe<Scalars["Int"]>
  gifterBillingZip?: Maybe<Scalars["String"]>
  gifterEmail?: Maybe<Scalars["String"]>
  gifterMessage?: Maybe<Scalars["String"]>
  gifterName?: Maybe<Scalars["String"]>
  id: Scalars["Int"]
  recipient?: Maybe<User>
  recipientAppearence?: Maybe<Scalars["String"]>
  recipientEmail?: Maybe<Scalars["String"]>
  recipientEmailSentAt?: Maybe<Scalars["DateTime"]>
  recipientName?: Maybe<Scalars["String"]>
  recipientState?: Maybe<Scalars["String"]>
  refundDate?: Maybe<Scalars["DateTime"]>
  refundReason: Scalars["String"]
  stripeChargeId?: Maybe<Scalars["String"]>
}

export enum HairLossLocEnum {
  Hairline = "hairline",
  Crown = "crown",
  HairlineAndCrown = "hairline_and_crown",
  Patchy = "patchy"
}

export enum HairLossTimeFrameEnum {
  Within_6Months = "within_6_months",
  From_6To_12Months = "from_6_to_12_months",
  From_1To_2Years = "from_1_to_2_years",
  Over_2Years = "over_2_years"
}

export enum HeadacheAttacksCountEnum {
  OnlyOne = "only_one",
  TwoThree = "two_three",
  MoreThanThree = "more_than_three"
}

export enum HeadacheGoesToMaximumInEnum {
  WithinSeconds = "within_seconds",
  UpToOneHour = "up_to_one_hour",
  MoreThanOneHour = "more_than_one_hour"
}

export enum HeadachesDurationEnum {
  LessThanThreeMonths = "less_than_three_months",
  FourToTwelveMonths = "four_to_twelve_months",
  MoreThanOneYear = "more_than_one_year"
}

export enum HeadachesFrequencyEnum {
  OneToThreePerMonth = "one_to_three_per_month",
  FourToEightPerMonth = "four_to_eight_per_month",
  NineToFourteenPerMonth = "nine_to_fourteen_per_month",
  MoreThanFifteenPerMonth = "more_than_fifteen_per_month"
}

export enum HeadachesLocationEnum {
  LeftTemple = "left_temple",
  RightTemple = "right_temple",
  Neck = "neck",
  TopOfMyHead = "top_of_my_head",
  LeftEye = "left_eye",
  RightEye = "right_eye",
  Forehead = "forehead",
  BackOfTheHead = "back_of_the_head",
  Other = "other"
}

export enum HeadacheStartsAfterEnum {
  HeadOfNeckTrauma = "head_of_neck_trauma",
  EmotionalTrauma = "emotional_trauma",
  Assault = "assault",
  Surgery = "surgery",
  MajorIllnessOrInfection = "major_illness_or_infection",
  HormonalChange = "hormonal_change",
  ChangedMedication = "changed_medication",
  OtherSignificantEvent = "other_significant_event",
  None = "none"
}

export enum HeadacheSymptomsEnum {
  Aura = "aura",
  Fever = "fever",
  NauseaOrVomiting = "nausea_or_vomiting",
  ExtremeDrowsiness = "extreme_drowsiness",
  Confusion = "confusion",
  DecreasedBalance = "decreased_balance",
  DecreasedMemory = "decreased_memory",
  DifficultySpeaking = "difficulty_speaking",
  LossOfVision = "loss_of_vision",
  RoomSpinning = "room_spinning",
  RingingInYourEyes = "ringing_in_your_eyes",
  LightHeading = "light_heading",
  InabilityToControlPartsOfYourBody = "inability_to_control_parts_of_your_body",
  WeaknessOfBody = "weakness_of_body",
  NumbnessOfBody = "numbness_of_body",
  NumbnessOrTingling = "numbness_or_tingling",
  SensitivityToLight = "sensitivity_to_light",
  NoiseSensitivity = "noise_sensitivity",
  EyelidDrooping = "eyelid_drooping",
  NasalCongestion = "nasal_congestion",
  TearingOfTheEye = "tearing_of_the_eye",
  None = "none"
}

export enum HealthConditionsEnum {
  HighBloodPressure = "high_blood_pressure",
  LiverOrKidneyDisease = "liver_or_kidney_disease",
  CardiovascularCondition = "cardiovascular_condition",
  NeurologicalDisease = "neurological_disease",
  Diabetes = "diabetes",
  Cancer = "cancer",
  ImmunosuppressedState = "immunosuppressed_state",
  None = "none"
}

export enum HealthConditionsHowLongEnum {
  LessThan_24Hours = "less_than_24_hours",
  OneToThreeDays = "one_to_three_days",
  MoreThanThreeDays = "more_than_three_days"
}

export enum HealthConditionsLastTimeEnum {
  LessThanThreeMonths = "less_than_three_months",
  ThreeToSixMonths = "three_to_six_months",
  SixToTwelveMonths = "six_to_twelve_months",
  MoreThanOneYear = "more_than_one_year"
}

export enum HealthConditionsStartTimeEnum {
  LessThan_12Hours = "less_than_12_hours",
  From_12To_24Hours = "from_12_to_24_hours",
  MoreThan_24Hours = "more_than_24_hours"
}

export enum HeartburnSymptomsEnum {
  AbdominalSwellingOrDistention = "abdominal_swelling_or_distention",
  JaundiceYellowingOfTheSkin = "jaundice_yellowing_of_the_skin",
  ConstipationDiarrheaOrChangeInBowelHabits = "constipation_diarrhea_or_change_in_bowel_habits",
  GastrointestinalBleeding = "gastrointestinal_bleeding",
  DeepPressureAtBaseNeck = "deep_pressure_at_base_neck",
  GettingFullVeryQuicklyAfterMeal = "getting_full_very_quickly_after_meal",
  UnexplainedWeightLoss = "unexplained_weight_loss",
  None = "none"
}

export enum HeartburnWakeUpAtNightEnum {
  Yes = "yes",
  No = "no"
}

export enum ImageTypeEnum {
  Global = "global",
  Crown = "crown",
  Hairline = "hairline",
  UpperBody = "upper_body",
  Eye = "eye",
  Identification = "identification"
}

export type Insurance = {
  __typename?: "Insurance"
  bin: Scalars["String"]
  cardholderFirstName?: Maybe<Scalars["String"]>
  cardholderId: Scalars["String"]
  cardholderLastName?: Maybe<Scalars["String"]>
  groupNumber?: Maybe<Scalars["String"]>
  id: Scalars["Int"]
  pcn?: Maybe<Scalars["String"]>
  personCode?: Maybe<Scalars["String"]>
  relationshipCode?: Maybe<Scalars["String"]>
  user?: Maybe<User>
}

export type Invoice = {
  __typename?: "Invoice"
  amountCharged?: Maybe<Scalars["Int"]>
  createdAt: Scalars["DateTime"]
  discount: Scalars["Int"]
  id: Scalars["Int"]
  lineItems: Array<LineItem>
  nextChargeAttemptAt?: Maybe<Scalars["DateTime"]>
  offers?: Maybe<Array<Offer>>
  paidAt?: Maybe<Scalars["DateTime"]>
  refunds?: Maybe<Array<Refund>>
  shipping: Scalars["Int"]
  status: Scalars["String"]
  subtotal: Scalars["Int"]
  subtotalWithDiscount: Scalars["Int"]
  total: Scalars["Int"]
  totalWithDiscount: Scalars["Int"]
  trackingInfo: Array<TrackingInfo>
  userCredit?: Maybe<UserCredit>
}

export type Journey = {
  __typename?: "Journey"
  copayInvoice?: Maybe<Invoice>
  coveQuizResponse?: Maybe<CoveQuizResponse>
  createdAt: Scalars["Date"]
  doctorProducts: Array<Product>
  evensQuizResponse?: Maybe<EvensQuizResponse>
  finalProducts: Array<Product>
  flowType: FlowTypeEnum
  id: Scalars["Int"]
  keepsQuizResponse?: Maybe<KeepsQuizResponse>
  kind: JourneyKindEnum
  mediaSet?: Maybe<MediaSet>
  nextActions: Array<NextActionEnum>
  pricing: Pricing
  site: SiteEnum
  status: Scalars["String"]
  urgentCareQuizResponse?: Maybe<UrgentCareQuizResponse>
  user: User
  userProducts: Array<Product>
}

export enum JourneyKindEnum {
  KeepsRefillInState = "keeps_refill_in_state",
  KeepsAddTreatment = "keeps_add_treatment",
  KeepsPurchase = "keeps_purchase",
  KeepsUpdateTreatment = "keeps_update_treatment",
  KeepsRenewal = "keeps_renewal",
  KeepsCancellation = "keeps_cancellation",
  EvensECommerce = "evens_e_commerce",
  EvensBuyNow = "evens_buy_now",
  EvensPurchase = "evens_purchase",
  CoveECommerce = "cove_e_commerce",
  CoveLtdd = "cove_ltdd",
  CovePurchase = "cove_purchase",
  CoveUpdateTreatment = "cove_update_treatment",
  CoveRenewal = "cove_renewal",
  UrgentCarePurchase = "urgent_care_purchase",
  PicnicPurchase = "picnic_purchase"
}

export type KeepsConsultationsJourney = {
  __typename?: "KeepsConsultationsJourney"
  consultation: Consultation
  flowType: KeepsJourneyFlowTypeEnum
  id: Scalars["Int"]
  imagesFinishedAt?: Maybe<Scalars["DateTime"]>
  keepsQuizResponse: KeepsQuizResponse
  leadFinishedAt?: Maybe<Scalars["DateTime"]>
  mediaSet?: Maybe<MediaSet>
  paymentFinishedAt?: Maybe<Scalars["DateTime"]>
  prescribedAt?: Maybe<Scalars["DateTime"]>
  quizFinishedAt?: Maybe<Scalars["DateTime"]>
  refillNumber: Scalars["Int"]
  registrationFinishedAt?: Maybe<Scalars["DateTime"]>
  skippedImages?: Maybe<Scalars["Boolean"]>
}

export enum KeepsJourneyFlowTypeEnum {
  Normal = "normal",
  Ecommerce = "ecommerce",
  Refill = "refill",
  RefillOutOfState = "refill_out_of_state"
}

export type KeepsQuizResponse = {
  __typename?: "KeepsQuizResponse"
  additionalNotes?: Maybe<Scalars["String"]>
  allergies?: Maybe<Array<Scalars["String"]>>
  allergiesNotes?: Maybe<Scalars["String"]>
  changesInLife?: Maybe<Scalars["String"]>
  currentSection?: Maybe<Scalars["String"]>
  erectileDysfunction?: Maybe<NestedQuestionEnum>
  familyHistory?: Maybe<Array<FamilyMedicalHistoryEnum>>
  hairLossLoc?: Maybe<HairLossLocEnum>
  hairLossTimeFrame?: Maybe<HairLossTimeFrameEnum>
  hasAdditionalNotes?: Maybe<NestedQuestionEnum>
  hasAllergies?: Maybe<NestedQuestionEnum>
  hasChangesInLife?: Maybe<Scalars["Boolean"]>
  hasHealthConditions?: Maybe<NestedQuestionEnum>
  hasSideEffects?: Maybe<Scalars["Boolean"]>
  healthConditions?: Maybe<Array<Scalars["String"]>>
  healthConditionsNotes?: Maybe<Scalars["String"]>
  id: Scalars["Int"]
  keepsConsultationsJourney: KeepsConsultationsJourney
  lifestyle?: Maybe<Array<LifestyleEnum>>
  lifestyleNotes?: Maybe<Scalars["String"]>
  medicationsOrSupplements?: Maybe<Array<Scalars["String"]>>
  pastResultsNotes?: Maybe<Scalars["String"]>
  pastResultsSatisfaction?: Maybe<NestedQuestionEnum>
  pastTreatments?: Maybe<Array<PastTreatmentsEnum>>
  priorHealthcareProfessional?: Maybe<PriorHealthcareProfessionalEnum>
  satisfiedWithKeeps?: Maybe<Scalars["Boolean"]>
  satisfiedWithKeepsNotes?: Maybe<Scalars["String"]>
  shedding?: Maybe<Array<SheddingEnum>>
  sideEffects?: Maybe<Scalars["String"]>
  stressEvents?: Maybe<Array<StressEventsEnum>>
  stressEventsOther?: Maybe<Scalars["String"]>
  symptoms?: Maybe<Array<SymptomsEnum>>
  takesMedicationsOrSupplements?: Maybe<NestedQuestionEnum>
  treatmentProductNotes?: Maybe<Scalars["String"]>
  treatmentProducts?: Maybe<Array<TreatmentProductsEnum>>
  treatmentProductsOther?: Maybe<Scalars["String"]>
  usedTreatmentProducts?: Maybe<NestedQuestionEnum>
  user: User
}

export enum KmgMessageTypeEnum {
  Cx = "Cx",
  Patient = "Patient",
  Prescribe = "Prescribe",
  NotAMatch = "NotAMatch"
}

export enum LastDoctorVisitedTimeEnum {
  LessThanThreeMonths = "less_than_three_months",
  ThreeToSixMonths = "three_to_six_months",
  SixToTwelveMonths = "six_to_twelve_months",
  MoreThanOneYear = "more_than_one_year"
}

export enum LastTestedTimeEnum {
  LessThanThreeMonths = "less_than_three_months",
  MoreThanThreeMonths = "more_than_three_months"
}

export enum LastTimeUsedEnum {
  CurrentlyTaking = "currently_taking",
  LessThanOneMonthAgo = "less_than_one_month_ago",
  OneToFiveMonthsAgo = "one_to_five_months_ago",
  SixToTwelveMonthsAgo = "six_to_twelve_months_ago",
  OverTwelveMonthsAgo = "over_twelve_months_ago"
}

export type Legal = {
  __typename?: "Legal"
  accepted: Scalars["Boolean"]
  agreementName: AgreementNameEnum
  id: Scalars["Int"]
}

export enum LessCommonSymptomsEnum {
  VocalHoarsenessScratchyVoiceWithNeedToClearYourThroatFrequently = "vocal_hoarseness_scratchy_voice_with_need_to_clear_your_throat_frequently",
  LongLastingCough = "long_lasting_cough",
  Asthma = "asthma",
  Laryngitis = "laryngitis",
  DentalErosions = "dental_erosions",
  None = "none",
  Other = "other"
}

export enum LifestyleChoicesEnum {
  DrinkAlcoholInExcess = "drink_alcohol_in_excess",
  SmokeCigarettesOrUseNicotineReplacementTherapies = "smoke_cigarettes_or_use_nicotine_replacement_therapies",
  HaveAHighlyRestrictiveDiet = "have_a_highly_restrictive_diet",
  OftenGetVeryLittleSleep = "often_get_very_little_sleep",
  UseRecreationalDrugs = "use_recreational_drugs",
  FeelStressed = "feel_stressed",
  ConsumeLargeAmountsOfCaffeine = "consume_large_amounts_of_caffeine",
  None = "none"
}

export enum LifestyleEnum {
  ExcessAlcohol = "excess_alcohol",
  Cigarettes = "cigarettes",
  ExcessSun = "excess_sun",
  RestrictiveDiet = "restrictive_diet",
  WorkoutExtremeIntensity = "workout_extreme_intensity",
  None = "none"
}

export enum LifestyleTriggersEnum {
  TooMuchSleep = "too_much_sleep",
  TooLittleSleep = "too_little_sleep",
  SkippedMeals = "skipped_meals",
  CertainFoods = "certain_foods",
  StressfulSituations = "stressful_situations",
  Alcohol = "alcohol",
  Menstruation = "menstruation",
  Exercise = "exercise",
  Other = "other",
  None = "none"
}

export type LineItem = {
  __typename?: "LineItem"
  amount: Scalars["Float"]
  amountWithDiscount: Scalars["Float"]
  description: Scalars["String"]
  group: Scalars["Int"]
  isDiscount: Scalars["Boolean"]
  kind: LineItemKindEnum
  product?: Maybe<Product>
}

export enum LineItemKindEnum {
  Product = "product",
  Shipping = "shipping",
  Consultation = "consultation",
  Offer = "offer",
  Gift = "gift",
  Credit = "credit",
  Custom = "custom"
}

export type MediaSet = {
  __typename?: "MediaSet"
  coveConsultationsJourney?: Maybe<CoveConsultationsJourney>
  createdAt: Scalars["DateTime"]
  id: Scalars["Int"]
  journey?: Maybe<Journey>
  keepsConsultationsJourney?: Maybe<KeepsConsultationsJourney>
  progressImages: Array<ProgressImage>
  setType: MediaSetTypeEnum
  user: User
  videos: Array<Video>
}

export enum MediaSetTypeEnum {
  KeepsConsultationPhotos = "keeps_consultation_photos",
  KeepsProgressPhotos = "keeps_progress_photos",
  CoveConsultationMedia = "cove_consultation_media",
  EvensConsultationPhotos = "evens_consultation_photos",
  UrgentCareConsultationPhotos = "urgent_care_consultation_photos",
  PicnicConsultationPhotos = "picnic_consultation_photos"
}

export enum MediaUploadActionTypeEnum {
  Append = "append",
  Replace = "replace"
}

export type Metadata = {
  __typename?: "Metadata"
  objectCount?: Maybe<Scalars["Int"]>
}

export enum MultiSelectMedicationsEnum {
  AcetaminophenTylenol = "acetaminophen_tylenol",
  Aimovig = "aimovig",
  Ajovy = "ajovy",
  AlmotriptanAxert = "almotriptan_axert",
  AmitriptylineElavil = "amitriptyline_elavil",
  Aspirin = "aspirin",
  AspirinAcetaminophenCaffeine = "aspirin_acetaminophen_caffeine",
  Botox = "botox",
  Cafergot = "cafergot",
  ChlorpromazineThorazine = "chlorpromazine__thorazine",
  Codeine = "codeine",
  DexamethasoneDecadron = "dexamethasone_decadron",
  DiclofenacCataflam = "diclofenac_cataflam",
  DihydroergotamineMigranal = "dihydroergotamine_migranal",
  EletriptanRelpax = "eletriptan_relpax",
  Emgality = "emgality",
  ExcedrinExtraStrength = "excedrin__extra__strength",
  ExcedrinMigraine = "excedrin__migraine",
  ExcedrinPmHeadache = "excedrin__pm__headache",
  ExcedrinTensionHeadache = "excedrin__tension__headache",
  Fioricet = "fioricet",
  Fiorinal = "fiorinal",
  FrovatriptanFrova = "frovatriptan_frova",
  IbuprofenAdvil = "ibuprofen_advil",
  LisinoprilZestril = "lisinopril_zestril",
  MetoclopramideReglan = "metoclopramide_reglan",
  MetoprololLopressor = "metoprolol_lopressor",
  Migergot = "migergot",
  NaproxenAleve = "naproxen_aleve",
  NaratriptanAmerge = "naratriptan_amerge",
  NortriptylinePamelor = "nortriptyline_pamelor",
  OccipitalNerveInjections = "occipital__nerve__injections",
  OndansetronZofran = "ondansetron_zofran",
  Prednisone = "prednisone",
  ProchlorperazineCompazine = "prochlorperazine_compazine",
  PropranololInderal = "propranolol_inderal",
  RizatriptanMaxalt = "rizatriptan_maxalt",
  SumatriptanImitrex = "sumatriptan_imitrex",
  TimololBetimol = "timolol_betimol",
  TopiramateTopamax = "topiramate_topamax",
  ValproateDepacon = "valproate_depacon",
  VenlafaxineEffexorXr = "venlafaxine_effexor__xr",
  VerapamilCalanVerelan = "verapamil_calan_verelan",
  ZolmitriptanZomig = "zolmitriptan_zomig"
}

export type Mutation = {
  __typename?: "Mutation"
  acceptDowngradeOffer: User
  acceptStartQuizAgreements: User
  adminEndPayPeriod?: Maybe<Array<Subscription>>
  adminSendCxConsultationMessage: Consultation
  adminSignIn?: Maybe<User>
  adminSubscriptionUpdateNextBillingDate?: Maybe<Array<Subscription>>
  applyOffer: Array<Subscription>
  approveTreatment: Array<Subscription>
  cancelEvensSubscription?: Maybe<User>
  cancelInvoices: Array<Invoice>
  cancelSubscriptions?: Maybe<Array<Subscription>>
  changePassword?: Maybe<User>
  checkout: User
  claimConsultation: Consultation
  completeConsultation: Consultation
  consultationsCompletePhoneCall: Consultation
  consultationsMarkPhoneCallForRetry: Consultation
  createAnalyticsEvent: AnalyticsEvent
  createCoveMigraineEvent: CoveMigraineEvent
  createEmailList: EmailList
  createEvensRefluxEvent: User
  createGiftCard: GiftCard
  createMediaSet: MediaSet
  createQuizResponse: CreateQuizResponseResponse
  createSubscription: Array<Subscription>
  createUser: User
  declineConsultation: Consultation
  findOrCreateEligibleMediaSet: MediaSet
  finishQuiz: User
  finishRetakeMedia?: Maybe<MediaSet>
  insuranceUpdate: Insurance
  keepsSwapMinoxidilFoam: Subscription
  kmgClaimConsultation: Consultation
  kmgCompleteConsultation: Consultation
  kmgDeclineConsultation: Consultation
  kmgPrescribeConsultation: Consultation
  kmgPromptRetakeMedia: Consultation
  kmgReadMessage: Consultation
  kmgSendMessage: Consultation
  kmgUnclaimConsultation: Consultation
  kmgUpdatePrescriptionStatus: Consultation
  pharmacyAttach: Pharmacy
  pharmacyCreate: Pharmacy
  pillpackClaimCheck: ClaimCheck
  pinConsultation: Consultation
  prescribeConsultation: Consultation
  promptRetakeMedia?: Maybe<Consultation>
  queueConsultationForSync: Consultation
  readCxMessages: Consultation
  readDoctorMessages: Consultation
  readUserMessages: Consultation
  refundInvoices: Array<Invoice>
  registerUser: User
  removeOffer: Array<Subscription>
  retryInvoicesPayment?: Maybe<Array<Invoice>>
  runCypressAction?: Maybe<User>
  sendConsultationMessage: Consultation
  sendCxConsultationMessage: Consultation
  sendResetPasswordInstructions?: Maybe<User>
  setCurrentVanityUrl: VanityUrl
  signIn?: Maybe<User>
  signInViaReturningHash?: Maybe<User>
  signOut: Response
  startJourney: User
  startQuizInJourney: User
  submitConsultationForRefill: Consultation
  submitForCxInJourney: User
  subscriptionUpdate?: Maybe<Array<Subscription>>
  triggerEagleOrderEvent: EagleOrder
  updateConsultation: Consultation
  updateCoveActiveProducts?: Maybe<User>
  updateCoveMigraineEvent: CoveMigraineEvent
  updateCoveQuizResponse: CoveQuizResponse
  updateEagleOrder: EagleOrder
  updateEvensPassword?: Maybe<User>
  updateEvensQuizResponse: EvensQuizResponse
  updateEvensRefluxEvent: User
  updateEvensSubscription?: Maybe<User>
  updateKeepsConsultationsJourney: KeepsConsultationsJourney
  updateKeepsQuizResponse: KeepsQuizResponse
  updateLegals: Array<Legal>
  updatePassword?: Maybe<User>
  updatePatient: User
  updatePrescriptionStatus: Array<Prescription>
  updateProductEntry: ProductEntry
  updateQuizResponse: UpdateQuizResponseResponse
  updateQuizResponseInJourney: User
  updateRefillOutOfStateSubscription?: Maybe<Subscription>
  updateSubscription: Subscription
  updateSubscriptions: User
  updateUrgentCareQuizResponse: UrgentCareQuizResponse
  updateUser: User
  updateUserProducts: User
  uploadProgressImage: ProgressImage
  uploadVideo: Video
}

export type MutationAcceptDowngradeOfferArgs = {
  params: AcceptDowngradeOfferParams
}

export type MutationAcceptStartQuizAgreementsArgs = {
  params?: Maybe<AcceptStartQuizAgreementsParams>
}

export type MutationAdminEndPayPeriodArgs = {
  subscriptionIds: Array<Scalars["Int"]>
}

export type MutationAdminSendCxConsultationMessageArgs = {
  consultationId: Scalars["Int"]
  body: Scalars["String"]
}

export type MutationAdminSignInArgs = {
  email: Scalars["Email"]
  password: Scalars["String"]
  security?: Maybe<Scalars["String"]>
}

export type MutationAdminSubscriptionUpdateNextBillingDateArgs = {
  subscriptionIds: Array<Scalars["Int"]>
  nextBillingDate: Scalars["DateTime"]
}

export type MutationApplyOfferArgs = {
  userId: Scalars["Int"]
  offerId: Scalars["Int"]
  subscriptionIds: Array<Scalars["Int"]>
  activationsRemaining?: Maybe<Scalars["Int"]>
}

export type MutationApproveTreatmentArgs = {
  params?: Maybe<ApproveTreatmentParams>
}

export type MutationCancelEvensSubscriptionArgs = {
  subscriptionId: Scalars["Int"]
}

export type MutationCancelInvoicesArgs = {
  invoiceIds: Array<Scalars["Int"]>
}

export type MutationCancelSubscriptionsArgs = {
  subscriptionIds: Array<Scalars["Int"]>
  cancellationReason: CancellationReasonEnum
  cancellationDetails?: Maybe<Scalars["String"]>
}

export type MutationChangePasswordArgs = {
  password: Scalars["String"]
  resetPasswordToken: Scalars["String"]
}

export type MutationCheckoutArgs = {
  params: CheckoutParams
}

export type MutationClaimConsultationArgs = {
  consultationId: Scalars["Int"]
}

export type MutationCompleteConsultationArgs = {
  params: CompleteConsultationParams
}

export type MutationConsultationsCompletePhoneCallArgs = {
  id: Scalars["Int"]
}

export type MutationConsultationsMarkPhoneCallForRetryArgs = {
  id: Scalars["Int"]
}

export type MutationCreateAnalyticsEventArgs = {
  analyticsEvent: CreateAnalyticsEventParams
}

export type MutationCreateCoveMigraineEventArgs = {
  response: CreateCoveMigraineEventParams
}

export type MutationCreateEmailListArgs = {
  emailList: CreateEmailListParams
}

export type MutationCreateEvensRefluxEventArgs = {
  event: CreateEvensRefluxEventParams
}

export type MutationCreateGiftCardArgs = {
  giftCard: CreateGiftCardParams
}

export type MutationCreateMediaSetArgs = {
  setType: MediaSetTypeEnum
}

export type MutationCreateQuizResponseArgs = {
  params: CreateQuizResponseParams
}

export type MutationCreateSubscriptionArgs = {
  params: CreateSubscriptionParams
}

export type MutationCreateUserArgs = {
  user: CreateUserParams
}

export type MutationDeclineConsultationArgs = {
  params: DeclineConsultationParams
}

export type MutationFindOrCreateEligibleMediaSetArgs = {
  setType: MediaSetTypeEnum
}

export type MutationFinishQuizArgs = {
  params?: Maybe<FinishQuizParams>
}

export type MutationFinishRetakeMediaArgs = {
  mediaSetId: Scalars["Int"]
}

export type MutationInsuranceUpdateArgs = {
  insurance: UpdateInsuranceParams
}

export type MutationKmgClaimConsultationArgs = {
  userId: Scalars["Int"]
}

export type MutationKmgCompleteConsultationArgs = {
  userId: Scalars["Int"]
}

export type MutationKmgDeclineConsultationArgs = {
  userId: Scalars["Int"]
  diagnosisComment: Scalars["String"]
}

export type MutationKmgPrescribeConsultationArgs = {
  userId: Scalars["Int"]
  prescribeMessage: Scalars["String"]
  productIds: Array<Scalars["Int"]>
  doctorNotes?: Maybe<Scalars["String"]>
}

export type MutationKmgPromptRetakeMediaArgs = {
  userId: Scalars["Int"]
  mediaTypes: Array<Scalars["String"]>
}

export type MutationKmgReadMessageArgs = {
  userId: Scalars["Int"]
  type: KmgMessageTypeEnum
}

export type MutationKmgSendMessageArgs = {
  userId: Scalars["Int"]
  body: Scalars["String"]
  type: KmgMessageTypeEnum
  productIds?: Maybe<Array<Scalars["Int"]>>
}

export type MutationKmgUnclaimConsultationArgs = {
  userId: Scalars["Int"]
}

export type MutationKmgUpdatePrescriptionStatusArgs = {
  userId: Scalars["Int"]
  doseSpotId?: Maybe<Scalars["String"]>
  completeCase?: Maybe<Scalars["Boolean"]>
}

export type MutationPharmacyAttachArgs = {
  outsidePharmacyId: Scalars["Int"]
}

export type MutationPharmacyCreateArgs = {
  pharmacy: CreatePharmacyParams
}

export type MutationPillpackClaimCheckArgs = {
  userId: Scalars["Int"]
  productId: Scalars["Int"]
}

export type MutationPinConsultationArgs = {
  consultationId: Scalars["Int"]
  pinned: Scalars["Boolean"]
}

export type MutationPrescribeConsultationArgs = {
  params: PrescribeConsultationParams
}

export type MutationPromptRetakeMediaArgs = {
  consultationId: Scalars["Int"]
  mediaTypes: Array<Scalars["String"]>
}

export type MutationQueueConsultationForSyncArgs = {
  consultationId: Scalars["Int"]
}

export type MutationReadCxMessagesArgs = {
  consultationId: Scalars["Int"]
}

export type MutationReadDoctorMessagesArgs = {
  consultationId: Scalars["Int"]
}

export type MutationReadUserMessagesArgs = {
  consultationId: Scalars["Int"]
}

export type MutationRefundInvoicesArgs = {
  invoiceIds: Array<Scalars["Int"]>
  amountRefundedInCents: Scalars["Int"]
  refundReason?: Maybe<Scalars["String"]>
}

export type MutationRegisterUserArgs = {
  user: RegisterUserParams
  hash?: Maybe<Scalars["String"]>
  plan?: Maybe<Scalars["String"]>
  eCommerceUser?: Maybe<Scalars["Boolean"]>
}

export type MutationRemoveOfferArgs = {
  subscriptionIds: Array<Scalars["Int"]>
}

export type MutationRetryInvoicesPaymentArgs = {
  invoiceIds: Array<Scalars["Int"]>
}

export type MutationRunCypressActionArgs = {
  action: ActionEnum
  params?: Maybe<CypressActionParams>
}

export type MutationSendConsultationMessageArgs = {
  consultationId: Scalars["Int"]
  body: Scalars["String"]
  from: ConsultationMessageFromEnum
  doctorNotes?: Maybe<Scalars["String"]>
}

export type MutationSendCxConsultationMessageArgs = {
  consultationId: Scalars["Int"]
  body: Scalars["String"]
}

export type MutationSendResetPasswordInstructionsArgs = {
  email: Scalars["Email"]
}

export type MutationSetCurrentVanityUrlArgs = {
  id: Scalars["Int"]
}

export type MutationSignInArgs = {
  email: Scalars["Email"]
  password: Scalars["String"]
}

export type MutationSignInViaReturningHashArgs = {
  returningHash: Scalars["String"]
}

export type MutationStartJourneyArgs = {
  kind: JourneyKindEnum
  quizConfig?: Maybe<Scalars["String"]>
  quizVersion?: Maybe<Scalars["Int"]>
}

export type MutationStartQuizInJourneyArgs = {
  params: StartQuizInJourneyParams
}

export type MutationSubmitForCxInJourneyArgs = {
  params: SubmitForCxParams
}

export type MutationSubscriptionUpdateArgs = {
  subscriptions: Array<SubscriptionUpdateParams>
}

export type MutationTriggerEagleOrderEventArgs = {
  id: Scalars["Int"]
  event: Scalars["String"]
}

export type MutationUpdateConsultationArgs = {
  id: Scalars["Int"]
  attributes: ConsultationAttributes
}

export type MutationUpdateCoveActiveProductsArgs = {
  productIds: Array<Scalars["Int"]>
}

export type MutationUpdateCoveMigraineEventArgs = {
  response: UpdateCoveMigraineEventParams
}

export type MutationUpdateCoveQuizResponseArgs = {
  response: UpdateCoveQuizResponseParams
  journeyKind?: Maybe<JourneyKindEnum>
}

export type MutationUpdateEagleOrderArgs = {
  id: Scalars["Int"]
  shippingTypeOverride?: Maybe<ShippingMethodEnum>
}

export type MutationUpdateEvensPasswordArgs = {
  params: UpdateEvensPasswordParams
}

export type MutationUpdateEvensQuizResponseArgs = {
  response: UpdateEvensQuizResponseParams
  journeyKind?: Maybe<JourneyKindEnum>
}

export type MutationUpdateEvensRefluxEventArgs = {
  event: UpdateEvensRefluxEventParams
}

export type MutationUpdateEvensSubscriptionArgs = {
  subscription: UpdateEvensSubscriptionParams
}

export type MutationUpdateKeepsConsultationsJourneyArgs = {
  flags: UpdateKeepsConsultationsJourneyParams
}

export type MutationUpdateKeepsQuizResponseArgs = {
  response: UpdateKeepsQuizResponseParams
  journeyKind?: Maybe<JourneyKindEnum>
}

export type MutationUpdateLegalsArgs = {
  agreementNames: Array<AgreementNameEnum>
  accepted: Scalars["Boolean"]
}

export type MutationUpdatePasswordArgs = {
  params: UserUpdatePasswordParams
}

export type MutationUpdatePatientArgs = {
  userId: Scalars["Int"]
  params: UpdatePatientParams
}

export type MutationUpdatePrescriptionStatusArgs = {
  consultationId: Scalars["Int"]
}

export type MutationUpdateProductEntryArgs = {
  id: Scalars["Int"]
  active: Scalars["Boolean"]
}

export type MutationUpdateQuizResponseArgs = {
  params: UpdateQuizResponseParams
}

export type MutationUpdateQuizResponseInJourneyArgs = {
  params: UpdateJourneyQuizResponseParams
}

export type MutationUpdateSubscriptionArgs = {
  productIds: Array<Scalars["Int"]>
}

export type MutationUpdateSubscriptionsArgs = {
  expectedPrice: Scalars["Int"]
}

export type MutationUpdateUrgentCareQuizResponseArgs = {
  response: UpdateUrgentCareQuizResponseParams
}

export type MutationUpdateUserArgs = {
  user: UpdateUserParams
  stripeToken?: Maybe<Scalars["String"]>
}

export type MutationUpdateUserProductsArgs = {
  params: UpdateUserProductsParams
}

export type MutationUploadProgressImageArgs = {
  file?: Maybe<Scalars["Upload"]>
  fileUrl?: Maybe<Scalars["String"]>
  imageType: ImageTypeEnum
  mediaSetId: Scalars["Int"]
  actionType: MediaUploadActionTypeEnum
  quizUpload: Scalars["Boolean"]
  journeyKind?: Maybe<JourneyKindEnum>
}

export type MutationUploadVideoArgs = {
  file?: Maybe<Scalars["Upload"]>
  videoUrl?: Maybe<Scalars["String"]>
  videoType: VideoTypeEnum
  contentType?: Maybe<ContentTypeEnum>
  mediaSetId: Scalars["Int"]
  actionType: MediaUploadActionTypeEnum
  quizUpload: Scalars["Boolean"]
  journeyKind?: Maybe<JourneyKindEnum>
}

export enum NestedQuestionEnum {
  Yes = "yes",
  No = "no",
  None = "none"
}

export enum NextActionEnum {
  UpdateUserProducts = "update_user_products",
  Checkout = "checkout",
  AcceptLegals = "accept_legals",
  StartQuiz = "start_quiz",
  UpdatePhoto = "update_photo",
  UpdateVideo = "update_video",
  UpdateQuizResponse = "update_quiz_response",
  SubmitForCx = "submit_for_cx",
  SubmitForConsultation = "submit_for_consultation",
  SuggestTreatment = "suggest_treatment",
  ApproveTreatment = "approve_treatment",
  Prescribe = "prescribe",
  Cancel = "cancel",
  CancelConsultation = "cancel_consultation",
  Fail = "fail",
  DeclineConsultation = "decline_consultation",
  CompleteConsultation = "complete_consultation"
}

export enum NotEligibleReasonEnum {
  Underage = "underage",
  Woman = "woman",
  OutOfState = "out_of_state"
}

/** Objects that can be returned by find query */
export type Object = Subscription | User

export type Offer = {
  __typename?: "Offer"
  checkoutSentence?: Maybe<Scalars["String"]>
  defaultActivationsRemaining: Scalars["Int"]
  discountPercentage?: Maybe<Scalars["Float"]>
  id: Scalars["Int"]
  name: Scalars["String"]
  promoSentence?: Maybe<Scalars["String"]>
  shippingPrice: Scalars["Int"]
  topBannerText?: Maybe<Scalars["String"]>
}

export enum OtherTreatmentWaysEnum {
  CbdOrMarijuana = "cbd_or_marijuana",
  Acupuncture = "acupuncture",
  DietRestrictions = "diet_restrictions",
  Aromatherapy = "aromatherapy",
  PsychologistOrTherapist = "psychologist_or_therapist",
  PhysicalTherapy = "physical_therapy",
  Yoga = "yoga",
  ChiropracticTherapy = "chiropractic_therapy",
  Other = "other",
  None = "none"
}

export enum PainDescriptionEnum {
  Throbbing = "throbbing",
  Stabbing = "stabbing",
  Aching = "aching",
  Pressure = "pressure",
  Pulsating = "pulsating",
  Dull = "dull",
  Other = "other"
}

export enum PastTreatmentsEnum {
  MinoxidilFoam = "minoxidil_foam",
  MinoxidilTopical = "minoxidil_topical",
  Finasteride = "finasteride",
  KetoconazoleShampoo = "ketoconazole_shampoo",
  None = "none"
}

export enum PastTwoDaysEnum {
  LessSleepThanUsual = "less_sleep_than_usual",
  StressAtWork = "stress_at_work",
  StressAtHome = "stress_at_home",
  ExcessiveDrinking = "excessive_drinking",
  HardExcercise = "hard_excercise",
  MoreLessCaffeine = "more_less_caffeine",
  Menstruation = "menstruation",
  LoudNoises = "loud_noises",
  BrightLights = "bright_lights",
  Diet = "diet",
  Other = "other"
}

export enum PauseReasonEnum {
  TooExpensive = "too_expensive",
  Unpaid = "unpaid",
  PendingRefill = "pending_refill",
  PendingRefillPostCharge = "pending_refill_post_charge",
  NewSubscriptionAwaitingRx = "new_subscription_awaiting_rx",
  AdminPaused = "admin_paused",
  UserStripeCustomerIdMissing = "user_stripe_customer_id_missing",
  FifthOrderNotPossible = "fifth_order_not_possible"
}

export type Pharmacy = {
  __typename?: "Pharmacy"
  address?: Maybe<Address>
  externalId: Scalars["String"]
  externalType: PharmacyExternalTypeEnum
  faxNumber?: Maybe<Scalars["String"]>
  id: Scalars["Int"]
  name?: Maybe<Scalars["String"]>
  phoneNumber?: Maybe<Scalars["String"]>
  user?: Maybe<User>
}

export enum PharmacyExternalTypeEnum {
  Google = "google",
  Dosespot = "dosespot",
  Pillpack = "pillpack"
}

export type PharmacyIdConstants = {
  __typename?: "PharmacyIdConstants"
  eagle: Scalars["String"]
  pillpack: Scalars["String"]
}

export type Phone = {
  __typename?: "Phone"
  id: Scalars["Int"]
  phoneAreaCode?: Maybe<Scalars["String"]>
  phoneNumber?: Maybe<Scalars["String"]>
}

export enum PhoneCallStatusEnum {
  NotApplicable = "not_applicable",
  Required = "required",
  PendingRetry = "pending_retry",
  Completed = "completed"
}

export type PhoneParams = {
  phoneAreaCode?: Maybe<Scalars["String"]>
  phoneNumber?: Maybe<Scalars["String"]>
}

export enum PregnancyTrimesterEnum {
  FirstTrimester = "first_trimester",
  SecondTrimester = "second_trimester",
  ThirdTrimester = "third_trimester",
  NotCurrentlyPregnant = "not_currently_pregnant"
}

export type PrescribeConsultationParams = {
  consultationId: Scalars["Int"]
  productIds?: Maybe<Array<Scalars["Int"]>>
  vertexId?: Maybe<Scalars["Int"]>
  hairlineId?: Maybe<Scalars["Int"]>
  messageBody?: Maybe<Scalars["String"]>
  bypassInteractionsValidation?: Maybe<Scalars["Boolean"]>
  journeyKind?: Maybe<JourneyKindEnum>
  doctorNotes?: Maybe<Scalars["String"]>
}

export type Prescription = {
  __typename?: "Prescription"
  consultation: Consultation
  createdAt: Scalars["DateTime"]
  doctor: Doctor
  dosespotDisplayName?: Maybe<Scalars["String"]>
  dosespotMedicationStatus?: Maybe<Scalars["String"]>
  dosespotQuantity?: Maybe<Scalars["String"]>
  dosespotRefills?: Maybe<Scalars["String"]>
  id: Scalars["Int"]
  products: Array<Product>
  status: RxStatusEnum
  statusUnsent: Scalars["Boolean"]
}

export type Pricing = {
  __typename?: "Pricing"
  consultation?: Maybe<Scalars["Float"]>
  discount: Scalars["Float"]
  lineItems: Array<LineItem>
  products: Array<Product>
  shipping: Scalars["Float"]
  subtotal: Scalars["Float"]
  subtotalWithDiscount: Scalars["Float"]
  total: Scalars["Float"]
  totalWithDiscount: Scalars["Float"]
}

export type PricingConsultationArgs = {
  journeyKind?: Maybe<JourneyKindEnum>
}

export type PricingConstants = {
  __typename?: "PricingConstants"
  keepsGiftingSixMonth: Scalars["Float"]
  keepsGiftingThreeMonth: Scalars["Float"]
  keepsGiftingTwelveMonth: Scalars["Float"]
  shipping: Scalars["Float"]
}

export enum PriorHealthcareProfessionalEnum {
  PrimaryCare = "primary_care",
  Dermatologist = "dermatologist",
  Other = "other",
  None = "none"
}

export type Product = {
  __typename?: "Product"
  activeIngredients?: Maybe<Scalars["String"]>
  allergistAdvice?: Maybe<Scalars["String"]>
  amountType?: Maybe<AmountTypeEnum>
  amountValue?: Maybe<Scalars["Int"]>
  bundledProducts: Array<Product>
  buyNow: Scalars["Boolean"]
  /** @deprecated Replaced by supplyInDays field */
  cycleDuration?: Maybe<Scalars["Int"]>
  daysUntilFirstRefill: Scalars["Int"]
  description?: Maybe<Scalars["String"]>
  displayedAmount?: Maybe<Scalars["String"]>
  displayedCadence?: Maybe<Scalars["String"]>
  displayedDosage?: Maybe<Scalars["String"]>
  displayedDrugType?: Maybe<Scalars["String"]>
  displayedName: Scalars["String"]
  displayedPrice?: Maybe<Scalars["String"]>
  doctorSelectable?: Maybe<Scalars["Boolean"]>
  dosageType?: Maybe<DosageTypeEnum>
  dosageValue?: Maybe<Scalars["Float"]>
  drugCategory?: Maybe<DrugCategoryEnum>
  drugClass?: Maybe<DrugClassEnum>
  drugFactsPath?: Maybe<Scalars["String"]>
  drugType: DrugTypeEnum
  genericName?: Maybe<Scalars["String"]>
  howItWorks?: Maybe<Scalars["String"]>
  id: Scalars["Int"]
  inStock?: Maybe<Scalars["Boolean"]>
  instructions?: Maybe<Scalars["String"]>
  internalName: Scalars["String"]
  isBundle: Scalars["Boolean"]
  ndc?: Maybe<Scalars["String"]>
  needsPrescription: Scalars["Boolean"]
  price?: Maybe<Scalars["Int"]>
  priceDisplayText?: Maybe<Scalars["String"]>
  recurringProduct?: Maybe<Product>
  rxCui?: Maybe<Scalars["String"]>
  site: Scalars["String"]
  subheader?: Maybe<Scalars["String"]>
  supplyInDays?: Maybe<Scalars["Int"]>
  supplyInformation?: Maybe<Scalars["String"]>
  symptoms?: Maybe<Array<DrugSymptomsEnum>>
  trialProduct?: Maybe<Product>
  userInitialPurchaseSelectable: Scalars["Boolean"]
  userSelectable?: Maybe<Scalars["Boolean"]>
  variations: Array<Product>
}

export type ProductEntry = {
  __typename?: "ProductEntry"
  active: Scalars["Boolean"]
  amountType?: Maybe<AmountTypeEnum>
  amountValue?: Maybe<Scalars["Int"]>
  createdAt: Scalars["Date"]
  deactivatedAt?: Maybe<Scalars["Date"]>
  displayedAmount?: Maybe<Scalars["String"]>
  displayedDosage?: Maybe<Scalars["String"]>
  displayedDrugType?: Maybe<Scalars["String"]>
  displayedName: Scalars["String"]
  dosageType?: Maybe<DosageTypeEnum>
  dosageValue?: Maybe<Scalars["Int"]>
  drugType?: Maybe<Scalars["String"]>
  id: Scalars["Int"]
  internalName: Scalars["String"]
  product: Product
}

export type Profile = {
  __typename?: "Profile"
  additionalNotes?: Maybe<Scalars["String"]>
  allergies?: Maybe<Scalars["String"]>
  allergiesNotes?: Maybe<Scalars["String"]>
  completed?: Maybe<Scalars["Boolean"]>
  createdAt: Scalars["String"]
  dob?: Maybe<Scalars["Date"]>
  eligible?: Maybe<Scalars["Boolean"]>
  erectileDysfunction?: Maybe<Scalars["String"]>
  familyHistoryChoice?: Maybe<Scalars["String"]>
  gender?: Maybe<Scalars["String"]>
  hairLossLoc?: Maybe<Scalars["String"]>
  hairLossTimeFrame?: Maybe<Scalars["String"]>
  healthConditions?: Maybe<Scalars["String"]>
  healthConditionsNotes?: Maybe<Scalars["String"]>
  hearAboutUs?: Maybe<Scalars["String"]>
  id: Scalars["Int"]
  lifestyleChoices?: Maybe<Scalars["String"]>
  lifestyleNotes?: Maybe<Scalars["String"]>
  medicationsOrSupplements?: Maybe<Scalars["String"]>
  noMedications?: Maybe<Scalars["Boolean"]>
  pastResultsNotes?: Maybe<Scalars["String"]>
  pastResultsSatisfaction?: Maybe<Scalars["String"]>
  pastTreatments?: Maybe<Scalars["String"]>
  priorHealthcareProfessional?: Maybe<Scalars["String"]>
  shedding?: Maybe<Scalars["String"]>
  stressEvents?: Maybe<Scalars["String"]>
  symptoms?: Maybe<Scalars["String"]>
  termsAccepted?: Maybe<Scalars["Boolean"]>
  treatmentProductNotes?: Maybe<Scalars["String"]>
  treatmentProducts?: Maybe<Scalars["String"]>
  updatedAt: Scalars["String"]
  userId?: Maybe<Scalars["Int"]>
}

export type ProfileParams = {
  dob?: Maybe<Scalars["Date"]>
  gender?: Maybe<Scalars["String"]>
  termsAccepted?: Maybe<Scalars["Boolean"]>
  hearAboutUs?: Maybe<Scalars["String"]>
}

export type ProgressImage = {
  __typename?: "ProgressImage"
  consultation?: Maybe<Consultation>
  createdAt: Scalars["DateTimeWithZone"]
  id: Scalars["Int"]
  imageType: ImageTypeEnum
  mediaSet?: Maybe<MediaSet>
  mediumImageUrl: Scalars["String"]
  originalImageUrl: Scalars["String"]
  series?: Maybe<Scalars["Int"]>
  seriesCreatedAt?: Maybe<Scalars["Date"]>
  updatedAt: Scalars["DateTimeWithZone"]
  user?: Maybe<User>
}

export type Query = {
  __typename?: "Query"
  _entities: Array<Maybe<_Entity>>
  _service: _Service
  allowedStates: Array<State>
  consultation?: Maybe<Consultation>
  currentAdmin?: Maybe<User>
  currentDoctor?: Maybe<Doctor>
  currentLead?: Maybe<User>
  currentOffer?: Maybe<Offer>
  currentUser?: Maybe<User>
  currentVanityUrl?: Maybe<VanityUrl>
  displayedProducts: Array<Product>
  eagleOrder?: Maybe<EagleOrder>
  flipperFlags: FlipperFlag
  invoice?: Maybe<Invoice>
  kmgEnqueueDoctor: Doctor
  kmgEnqueuePatient: User
  legacyPricing: Pricing
  legals: Scalars["String"]
  nearbyPharmacies: Array<Pharmacy>
  pharmacyIdConstants: PharmacyIdConstants
  pillpackAllowedStates: Array<State>
  pricing: Pricing
  pricingConstants: PricingConstants
  products: Array<Product>
  productsFromPlan: Array<Product>
  signedUrl?: Maybe<Scalars["String"]>
  states: Array<State>
  subscription?: Maybe<Subscription>
  subscriptions?: Maybe<Collection>
  user?: Maybe<User>
  users?: Maybe<Collection>
  vanityUrls: Array<VanityUrl>
}

export type Query_EntitiesArgs = {
  representations: Array<Scalars["_Any"]>
}

export type QueryConsultationArgs = {
  id: Scalars["Int"]
}

export type QueryEagleOrderArgs = {
  id: Scalars["Int"]
}

export type QueryInvoiceArgs = {
  id: Scalars["Int"]
}

export type QueryLegacyPricingArgs = {
  plan: Scalars["String"]
  couponCode?: Maybe<Scalars["String"]>
}

export type QueryLegalsArgs = {
  path: Scalars["String"]
}

export type QueryNearbyPharmaciesArgs = {
  radius?: Maybe<Scalars["Int"]>
  searchAddress: Scalars["String"]
}

export type QueryPricingArgs = {
  productIds?: Maybe<Array<Scalars["Int"]>>
  journeyKind?: Maybe<JourneyKindEnum>
}

export type QueryProductsArgs = {
  userSelectable?: Maybe<Scalars["Boolean"]>
  doctorSelectable?: Maybe<Scalars["Boolean"]>
  productIds?: Maybe<Array<Scalars["Int"]>>
  drugType?: Maybe<Array<Scalars["String"]>>
}

export type QueryProductsFromPlanArgs = {
  plan: Scalars["String"]
}

export type QuerySubscriptionArgs = {
  id: Scalars["Int"]
}

export type QuerySubscriptionsArgs = {
  offset?: Maybe<Scalars["Int"]>
  limit?: Maybe<Scalars["Int"]>
  subscriptionIds?: Maybe<Array<Scalars["Int"]>>
}

export type QueryUserArgs = {
  id: Scalars["Int"]
}

export type QueryUsersArgs = {
  limit?: Maybe<Scalars["Int"]>
  offset?: Maybe<Scalars["Int"]>
  firstName?: Maybe<Scalars["String"]>
  lastName?: Maybe<Scalars["String"]>
  email?: Maybe<Scalars["String"]>
  phoneNumber?: Maybe<Scalars["String"]>
  phoneAreaCode?: Maybe<Scalars["String"]>
  dob?: Maybe<Scalars["Date"]>
}

export type QuizResponse = {
  __typename?: "QuizResponse"
  configName: Scalars["String"]
  configVersion: Scalars["Int"]
  content: Scalars["JSON"]
  createdAt: Scalars["String"]
  draft: Scalars["Boolean"]
  id: Scalars["Int"]
  result?: Maybe<Scalars["JSON"]>
  site: SiteEnum
  updatedAt: Scalars["String"]
  userId: Scalars["Int"]
}

/** An error fulfilling a quiz response operation */
export type QuizResponseError = {
  __typename?: "QuizResponseError"
  errors?: Maybe<Array<QuizResponseValidationError>>
  message?: Maybe<Scalars["String"]>
  type: ErrorTypeEnum
}

/** A quiz response field validation error */
export type QuizResponseValidationError = {
  __typename?: "QuizResponseValidationError"
  /** Which field value is incorrect */
  field: Scalars["String"]
  /** The expected schema */
  schema: Scalars["JSON"]
}

export type Refund = {
  __typename?: "Refund"
  adminUserId?: Maybe<Scalars["Int"]>
  amountInCents: Scalars["Int"]
  createdAt: Scalars["DateTime"]
  id: Scalars["Int"]
  invoiceId: Scalars["Int"]
  refundDate: Scalars["DateTime"]
  refundReason: Scalars["String"]
  site?: Maybe<Scalars["String"]>
  stripeRefundId: Scalars["String"]
  updatedAt: Scalars["DateTime"]
  verified: Scalars["Boolean"]
}

export type RegisterUserParams = {
  firstName?: Maybe<Scalars["String"]>
  lastName?: Maybe<Scalars["String"]>
  email?: Maybe<Scalars["Email"]>
  password: Scalars["String"]
  addressAttributes?: Maybe<AddressParams>
  phoneAttributes?: Maybe<PhoneParams>
  profileAttributes?: Maybe<ProfileParams>
}

export enum RelativesMedicalHistoryEnum {
  RelativeWithHeartDisease = "relative_with_heart_disease",
  RelativeWithRupturedAneurysm = "relative_with_ruptured_aneurysm",
  TakingBirthControl = "taking_birth_control",
  UsingAsthmaInhaler = "using_asthma_inhaler",
  UsingImplantableDevice = "using_implantable_device",
  None = "none"
}

export enum RemoteStatusEnum {
  PendingRx = "pending_rx",
  Initialized = "initialized",
  CreatePatientEnqueued = "create_patient_enqueued",
  PatientCreated = "patient_created",
  OnHold = "on_hold",
  DeliveryEnqueued = "delivery_enqueued",
  DeliveryInProgress = "delivery_in_progress",
  DeliverySuccessStatusPending = "delivery_success_status_pending",
  DeliveryFailure = "delivery_failure",
  StatusComplete = "status_complete",
  StatusFailed = "status_failed",
  CxCanceled = "cx_canceled"
}

export type RenewalBundle = {
  __typename?: "RenewalBundle"
  nextBillingDate?: Maybe<Scalars["Date"]>
  pricing: Pricing
  subscriptions: Array<Subscription>
}

export type Response = {
  __typename?: "Response"
  success: Scalars["Boolean"]
}

export enum RxStatusEnum {
  Entered = "Entered",
  Printed = "Printed",
  Sending = "Sending",
  ERxSent = "eRxSent",
  FaxSent = "FaxSent",
  Error = "Error",
  Deleted = "Deleted",
  Requested = "Requested",
  Edited = "Edited",
  EpcsError = "EpcsError",
  EpcsSigned = "EpcsSigned",
  ReadyToSign = "ReadyToSign"
}

export enum SheddingEnum {
  Shower = "shower",
  Pillow = "pillow",
  Hairbrush = "hairbrush",
  LeftInHand = "left_in_hand",
  Furniture = "furniture",
  Food = "food",
  None = "none"
}

export enum ShippingMethodEnum {
  /** regular_mail */
  RegularMail = "regular_mail",
  /** priority */
  Priority = "priority",
  /** priority_signature_required */
  PrioritySignatureRequired = "priority_signature_required",
  /** two_day */
  TwoDay = "two_day",
  /** two_day_signature_required */
  TwoDaySignatureRequired = "two_day_signature_required",
  /** overnight_new */
  OvernightNew = "overnight_new",
  /** overnight_signature_required */
  OvernightSignatureRequired = "overnight_signature_required",
  /** two_day_preferred */
  TwoDayPreferred = "two_day_preferred",
  /** two_day_preferred_signature_required */
  TwoDayPreferredSignatureRequired = "two_day_preferred_signature_required",
  /** overnight_preferred */
  OvernightPreferred = "overnight_preferred",
  /** overnight_preferred_signature_required */
  OvernightPreferredSignatureRequired = "overnight_preferred_signature_required",
  /** usps_first_class */
  UspsFirstClass = "usps_first_class"
}

export enum SideEffectsEnum {
  Yes = "yes",
  No = "no",
  Sometimes = "sometimes"
}

export enum SiteEnum {
  Keeps = "keeps",
  Cove = "cove",
  Evens = "evens",
  UrgentCare = "urgent_care",
  Picnic = "picnic"
}

export type StartQuizInJourneyParams = {
  journeyKind: JourneyKindEnum
}

export type State = {
  __typename?: "State"
  label: Scalars["String"]
  value: Scalars["String"]
}

export enum StatusEnum {
  Started = "started",
  QuestionsAnswered = "questions_answered",
  Completed = "completed"
}

export enum StomachPainDescriptionEnum {
  Dull = "dull",
  Sharp = "sharp",
  Cramping = "cramping",
  Other = "other"
}

export enum StomachPainDiarrheaHasBloodEnum {
  Yes = "yes",
  No = "no",
  NotSure = "not_sure"
}

export enum StomachPainLocationEnum {
  UpperRight = "upper_right",
  UpperLeft = "upper_left",
  LowerRight = "lower_right",
  LowerLeft = "lower_left",
  Center = "center"
}

export enum StressEventsEnum {
  DeathOfALovedOne = "death_of_a_loved_one",
  MajorSurgery = "major_surgery",
  MajorIllness = "major_illness",
  LossOfAJobOrHome = "loss_of_a_job_or_home",
  Other = "other",
  None = "none"
}

export enum StressfulEventsEnum {
  DeathOfALovedOne = "death_of_a_loved_one",
  MajorSurgery = "major_surgery",
  SevereIllness = "severe_illness",
  LossOfAJobOrHome = "loss_of_a_job_or_home",
  Other = "other",
  None = "none"
}

export type StripeCard = {
  __typename?: "StripeCard"
  addressZip?: Maybe<Scalars["String"]>
  brand: Scalars["String"]
  customer: Scalars["String"]
  expMonth: Scalars["String"]
  expYear: Scalars["String"]
  id: Scalars["String"]
  last4: Scalars["String"]
  name: Scalars["String"]
}

export type SubmitForCxParams = {
  journeyKind: JourneyKindEnum
  content?: Maybe<Scalars["JSON"]>
}

export type Subscription = {
  __typename?: "Subscription"
  activeNonPackageProductsCount: Scalars["Int"]
  activePrescribableProducts: Array<Product>
  activeProducts: Array<Product>
  amountInCents?: Maybe<Scalars["Int"]>
  appliedOffer?: Maybe<Offer>
  availableOffers?: Maybe<Array<Offer>>
  cancellationDate?: Maybe<Scalars["Date"]>
  cancellationReason?: Maybe<Scalars["String"]>
  cancellationReasonDetails?: Maybe<Scalars["String"]>
  createdAt: Scalars["Date"]
  /** @deprecated Replaced by integer cycleInDays field */
  cycleDuration: Scalars["String"]
  cycleInDays: Scalars["Int"]
  eagleOrders?: Maybe<Array<EagleOrder>>
  electronicInfo?: Maybe<Scalars["Boolean"]>
  estimatedNextBillingDate?: Maybe<Scalars["Date"]>
  id: Scalars["Int"]
  nextBillingDate?: Maybe<Scalars["Date"]>
  pauseReason?: Maybe<PauseReasonEnum>
  plan?: Maybe<Scalars["String"]>
  pricing: Pricing
  productEntries: Array<ProductEntry>
  renewalCount: Scalars["Int"]
  status: SubscriptionStatusEnum
  type: Scalars["String"]
  user: User
}

export enum SubscriptionStatusEnum {
  Active = "active",
  Paused = "paused",
  RenewalInProgress = "renewal_in_progress",
  Canceled = "canceled"
}

export type SubscriptionUpdateParams = {
  subscriptionId?: Maybe<Scalars["Int"]>
  productIds: Array<Scalars["Int"]>
  nextBillingDate?: Maybe<Scalars["Date"]>
}

export enum SymptomsAtNightEnum {
  Yes = "yes",
  No = "no"
}

export enum SymptomsEnum {
  ItchingBurning = "itching_burning",
  OtherHairLoss = "other_hair_loss",
  SuddenIncreaseHairLoss = "sudden_increase_hair_loss",
  DandruffScaling = "dandruff_scaling",
  ChangesToSkin = "changes_to_skin",
  None = "none"
}

export enum SymptomsFrequencyWithMealEnum {
  YesAppearWithinFewMinutesOfMeal = "yes_appear_within_few_minutes_of_meal",
  NotRelatedToMeals = "not_related_to_meals",
  NotSure = "not_sure"
}

export enum SymptomsWorseAtLyingDownEnum {
  Yes = "yes",
  No = "no",
  NotSure = "not_sure"
}

export enum TestsEnum {
  Imaging = "imaging",
  BloodTest = "blood_test",
  SpinalTap = "spinal_tap",
  EyeExam = "eye_exam",
  Other = "other",
  None = "none"
}

export enum TimeOfDayWhenHeadachesComeEnum {
  Morning = "morning",
  Afternoon = "afternoon",
  Evening = "evening",
  NoPattern = "no_pattern"
}

export type TrackingInfo = {
  __typename?: "TrackingInfo"
  eagleShipmentConfirmation?: Maybe<EagleShipmentConfirmation>
  url: Scalars["String"]
}

export enum TreatmentProductsEnum {
  SawPalmetto = "saw_palmetto",
  ThickeningShampoo = "thickening_shampoo",
  Transplants = "transplants",
  LaserTreatment = "laser_treatment",
  PlateletRichPlasma = "platelet_rich_plasma",
  Dutasteride = "dutasteride",
  Other = "other",
  No = "no"
}

export enum TreatmentsFromDoctorEnum {
  OverTheCounterMedication = "over_the_counter_medication",
  PrescriptionMedication = "prescription_medication",
  SurgeryOrOtherMedicalProcedure = "surgery_or_other_medical_procedure",
  NoTreatmentRecommendation = "no_treatment_recommendation",
  Other = "other"
}

export type TreatmentUpdate = {
  __typename?: "TreatmentUpdate"
  addedProducts: Array<Product>
  isDowngrade: Scalars["Boolean"]
  remainingProducts: Array<Product>
  removedProducts: Array<Product>
  replacementProducts: Array<Product>
  steps: Array<TreatmentUpdateStep>
}

export enum TreatmentUpdateActionEnum {
  /** create */
  Create = "create",
  /** cancel */
  Cancel = "cancel",
  /** cancel_invoice */
  CancelInvoice = "cancel_invoice",
  /** renew */
  Renew = "renew",
  /** add_product */
  AddProduct = "add_product",
  /** remove_product */
  RemoveProduct = "remove_product"
}

export type TreatmentUpdateStep = {
  __typename?: "TreatmentUpdateStep"
  action: TreatmentUpdateActionEnum
  product?: Maybe<Product>
  subscription?: Maybe<Subscription>
}

export type UpdateCoveMigraineEventParams = {
  id: Scalars["Int"]
  startedAt?: Maybe<Scalars["ISO8601DateTime"]>
  endedAt?: Maybe<Scalars["ISO8601DateTime"]>
  ongoing?: Maybe<Scalars["Boolean"]>
  acuteMedicationTakenTimeframe?: Maybe<AcuteMedicationTakenTimeframeEnum>
  painIntencity?: Maybe<Scalars["String"]>
  medicationEffective?: Maybe<Scalars["Boolean"]>
  sideEffects?: Maybe<Scalars["Boolean"]>
  sideEffectsNotes?: Maybe<Scalars["String"]>
  pastTwoDays?: Maybe<Array<PastTwoDaysEnum>>
  additionalNotes?: Maybe<Scalars["String"]>
}

export type UpdateCoveQuizMultiSelectMedicationResponse = {
  drugName: MultiSelectMedicationsEnum
  dosage?: Maybe<Scalars["String"]>
  lastTimeUsed?: Maybe<LastTimeUsedEnum>
  startedTaking?: Maybe<Scalars["String"]>
  sideEffects?: Maybe<SideEffectsEnum>
  sideEffectsNotes?: Maybe<Scalars["String"]>
  effectiveness?: Maybe<EffectivenessEnum>
  additionalNotes?: Maybe<Scalars["String"]>
  doctorPrescribe?: Maybe<DoctorPrescribeEnum>
}

export type UpdateCoveQuizResponseParams = {
  triedRxMedicationBefore?: Maybe<Scalars["Boolean"]>
  happyWithExistingTreatment?: Maybe<Scalars["Boolean"]>
  usedProducts?: Maybe<Array<UsedProductsEnum>>
  headachesFrequency?: Maybe<HeadachesFrequencyEnum>
  headachesDuration?: Maybe<HeadachesDurationEnum>
  headachesDurationNote?: Maybe<Scalars["String"]>
  headacheAttacksCount?: Maybe<HeadacheAttacksCountEnum>
  headacheFreeBetweenAttacks?: Maybe<Scalars["Boolean"]>
  headacheGoesToMaximumIn?: Maybe<HeadacheGoesToMaximumInEnum>
  headachesChangedInLastMonths?: Maybe<Scalars["Boolean"]>
  headachesChangedInLastMonthsNotes?: Maybe<Scalars["String"]>
  headachesIntensity?: Maybe<Scalars["Int"]>
  headachesLocation?: Maybe<Array<HeadachesLocationEnum>>
  headachesLocationOther?: Maybe<Scalars["String"]>
  painDescription?: Maybe<Array<PainDescriptionEnum>>
  painDescriptionOther?: Maybe<Scalars["String"]>
  experiencedTypesOfHeadache?: Maybe<Array<ExperiencedTypesOfHeadacheEnum>>
  headacheStartsAfter?: Maybe<Array<HeadacheStartsAfterEnum>>
  headacheSymptoms?: Maybe<Array<HeadacheSymptomsEnum>>
  aurasBuildIn?: Maybe<AurasBuildInEnum>
  associationsWithAura?: Maybe<Array<AssociationsWithAuraEnum>>
  familyMembersWithHeadaches?: Maybe<Array<FamilyMembersWithHeadachesEnum>>
  familyMembersWithHeadachesNotes?: Maybe<Scalars["String"]>
  headachesWakeUpAtNight?: Maybe<Scalars["Boolean"]>
  timeOfDayWhenHeadachesCome?: Maybe<Array<TimeOfDayWhenHeadachesComeEnum>>
  lifestyleTriggers?: Maybe<Array<LifestyleTriggersEnum>>
  lifestyleTriggersOther?: Maybe<Scalars["String"]>
  environmentalTriggers?: Maybe<Array<EnvironmentalTriggersEnum>>
  environmentalTriggersOther?: Maybe<Scalars["String"]>
  visitedHealthcareDoctor?: Maybe<Array<VisitedHealthcareDoctorEnum>>
  diagnosisFromDoctor?: Maybe<Array<DiagnosisFromDoctorEnum>>
  diagnosisFromDoctorOther?: Maybe<Scalars["String"]>
  treatmentFromDoctor?: Maybe<Array<Scalars["String"]>>
  stillTakingTreatmentFromDoctor?: Maybe<Scalars["Boolean"]>
  satisfiedTreatment?: Maybe<Scalars["Boolean"]>
  stopTreatmentReason?: Maybe<Scalars["String"]>
  emergencyRoomReason?: Maybe<Array<EmergencyRoomReasonEnum>>
  emergencyRoomReasonOther?: Maybe<Scalars["String"]>
  hadTests?: Maybe<Scalars["Boolean"]>
  tests?: Maybe<Array<TestsEnum>>
  imagingNotes?: Maybe<Scalars["String"]>
  bloodTestNotes?: Maybe<Scalars["String"]>
  spinalTapNotes?: Maybe<Scalars["String"]>
  eyeExamNotes?: Maybe<Scalars["String"]>
  otherTestNotes?: Maybe<Scalars["String"]>
  everTriedMedication?: Maybe<Scalars["Boolean"]>
  multiSelectMedications?: Maybe<Array<MultiSelectMedicationsEnum>>
  takingMedicationConsistentlyAndIsSatisfied?: Maybe<Scalars["Boolean"]>
  notTakingMedicationOrUnsatisfiedNotes?: Maybe<Scalars["String"]>
  experiencingNewSideEffects?: Maybe<Scalars["Boolean"]>
  experiencingNewSideEffectsNotes?: Maybe<Scalars["String"]>
  majorHealthOrLifestyleChange?: Maybe<Scalars["Boolean"]>
  majorHealthOrLifestyleChangeNotes?: Maybe<Scalars["String"]>
  newMedicationOrAllergiesOrMedicalConditions?: Maybe<Scalars["Boolean"]>
  newMedicationOrAllergiesOrMedicalConditionsNotes?: Maybe<Scalars["String"]>
  hasQuestionForDoctor?: Maybe<Scalars["Boolean"]>
  hasQuestionForDoctorNotes?: Maybe<Scalars["String"]>
  multiSelectMedicationResponses?: Maybe<Array<UpdateCoveQuizMultiSelectMedicationResponse>>
  multiSelectMedicationResponse?: Maybe<UpdateCoveQuizMultiSelectMedicationResponse>
  usedMedications?: Maybe<Array<UsedMedicationsEnum>>
  otherUsedMedicationsNotes?: Maybe<Scalars["String"]>
  usedMedicationResponses?: Maybe<Array<UpdateCoveQuizUsedMedicationResponse>>
  otherTreatmentWays?: Maybe<Array<OtherTreatmentWaysEnum>>
  otherTreatmentWaysOther?: Maybe<Scalars["String"]>
  otherTreatmentWaysEffective?: Maybe<Scalars["Boolean"]>
  otherTreatmentWaysEffectiveNotes?: Maybe<Scalars["String"]>
  lifestyleChoices?: Maybe<Array<LifestyleChoicesEnum>>
  lifestyleChoicesNotes?: Maybe<Scalars["String"]>
  stressfulEvents?: Maybe<Array<StressfulEventsEnum>>
  stressfulEventsOther?: Maybe<Scalars["String"]>
  hasDepression?: Maybe<Scalars["Boolean"]>
  weight?: Maybe<Scalars["Int"]>
  height?: Maybe<Scalars["Int"]>
  bloodPressure?: Maybe<Scalars["Boolean"]>
  bloodPressureHigh?: Maybe<Scalars["Int"]>
  bloodPressureLow?: Maybe<Scalars["Int"]>
  lastBloodPressureTakenTime?: Maybe<LastTestedTimeEnum>
  hasPulse?: Maybe<Scalars["Boolean"]>
  pulse?: Maybe<Scalars["Int"]>
  lastPulseTakenTime?: Maybe<LastTestedTimeEnum>
  healthConditions?: Maybe<Array<HealthConditionsEnum>>
  relativesMedicalHistory?: Maybe<Array<RelativesMedicalHistoryEnum>>
  hasOtherHealthConditions?: Maybe<Scalars["Boolean"]>
  otherHealthConditions?: Maybe<Array<Scalars["String"]>>
  otherHealthConditionsDiagnosedRecently?: Maybe<Scalars["Boolean"]>
  otherHealthConditionsDiagnosedRecentlyNotes?: Maybe<Scalars["String"]>
  takingMedicationsOrSupplements?: Maybe<Scalars["Boolean"]>
  medicationsOrSupplements?: Maybe<Array<Scalars["String"]>>
  hasAllergies?: Maybe<Scalars["Boolean"]>
  allergicReactionNotes?: Maybe<Scalars["String"]>
  allergies?: Maybe<Array<Scalars["String"]>>
  hadSurgeriesOrInjuries?: Maybe<Scalars["Boolean"]>
  surgeriesOrInjuries?: Maybe<Scalars["String"]>
  lastDoctorVisitedTime?: Maybe<LastDoctorVisitedTimeEnum>
  hasAdditionalNotes?: Maybe<Scalars["Boolean"]>
  additionalNotes?: Maybe<Scalars["String"]>
  gender?: Maybe<GendersEnum>
  pregnancyOrTryingPregnantOrBreastfeeding?: Maybe<Scalars["Boolean"]>
}

export type UpdateCoveQuizUsedMedicationResponse = {
  drugName: UsedMedicationsEnum
  dosage?: Maybe<Scalars["String"]>
  lastTimeUsed?: Maybe<LastTimeUsedEnum>
  effectiveness?: Maybe<EffectivenessEnum>
  useAgain?: Maybe<Scalars["Boolean"]>
  sideEffects?: Maybe<SideEffectsEnum>
  sideEffectsNotes?: Maybe<Scalars["String"]>
  additionalNotes?: Maybe<Scalars["String"]>
}

export type UpdateEvensPasswordParams = {
  resetPasswordToken?: Maybe<Scalars["String"]>
  password: Scalars["String"]
  passwordConfirmation: Scalars["String"]
}

export type UpdateEvensQuizResponseParams = {
  frequency?: Maybe<FrequencyEnum>
  duration?: Maybe<DurationEnum>
  commonSymptoms?: Maybe<Array<CommonSymptomsEnum>>
  commonSymptomsOther?: Maybe<Scalars["String"]>
  lessCommonSymptoms?: Maybe<Array<LessCommonSymptomsEnum>>
  lessCommonSymptomsOther?: Maybe<Scalars["String"]>
  symptomsFrequencyWithMeal?: Maybe<SymptomsFrequencyWithMealEnum>
  symptomsWorseAtLyingDown?: Maybe<SymptomsWorseAtLyingDownEnum>
  symptomsAtNight?: Maybe<SymptomsAtNightEnum>
  heartburnWakeUpAtNight?: Maybe<HeartburnWakeUpAtNightEnum>
  heartburnSymptoms?: Maybe<Array<HeartburnSymptomsEnum>>
  usedMedicationResponses?: Maybe<Array<UpdateEvensQuizUsedMedicationResponse>>
  usedMedications?: Maybe<Array<UsedMedicationsDrugsEnum>>
  usedMedicationsOther?: Maybe<Scalars["String"]>
  alternativeUsedMedications?: Maybe<Array<AlternativeUsedMedicationsEnum>>
  alternativeUsedMedicationsOther?: Maybe<Scalars["String"]>
  alternativeUsedMedicationsNotes?: Maybe<Scalars["String"]>
  lifestyle?: Maybe<Array<EvensLifestyleEnum>>
  lifestyleOther?: Maybe<Scalars["String"]>
  caffeineTimesPerWeek?: Maybe<Scalars["Int"]>
  fattyFoodsTimesPerWeek?: Maybe<Scalars["Int"]>
  chocolateTimesPerWeek?: Maybe<Scalars["Int"]>
  spicyFoodsTimesPerWeek?: Maybe<Scalars["Int"]>
  carbonatedBeveragesTimesPerWeek?: Maybe<Scalars["Int"]>
  peppermintTimesPerWeek?: Maybe<Scalars["Int"]>
  pregnancyOrTryingPregnantOrBreastfeeding?: Maybe<Scalars["Boolean"]>
  acidRefluxOnPregnancy?: Maybe<Scalars["Boolean"]>
  pregnancyTrimester?: Maybe<PregnancyTrimesterEnum>
  weight?: Maybe<Scalars["Int"]>
  height?: Maybe<Scalars["Int"]>
  gender?: Maybe<EvensGendersEnum>
  visitedHealthcareDoctor?: Maybe<Array<EvensVisitedHealthcareDoctorEnum>>
  diagnosisFromDoctor?: Maybe<Array<EvensDiagnosisFromDoctorEnum>>
  diagnosisFromDoctorOther?: Maybe<Scalars["String"]>
  treatmentFromDoctor?: Maybe<Array<TreatmentsFromDoctorEnum>>
  treatmentFromDoctorOther?: Maybe<Scalars["String"]>
  satisfiedTreatment?: Maybe<Scalars["String"]>
  hadTests?: Maybe<Scalars["Boolean"]>
  tests?: Maybe<Array<EvensTestsEnum>>
  testsOther?: Maybe<Scalars["String"]>
  healthConditions?: Maybe<Array<EvensHealthConditionsEnum>>
  hasOtherHealthConditions?: Maybe<Scalars["Boolean"]>
  relativesHealthCondition?: Maybe<EvensRelativesMedicalHistoryEnum>
  otherHealthConditionsDiagnosedRecently?: Maybe<Scalars["Boolean"]>
  otherHealthConditionsDiagnosedRecentlyNotes?: Maybe<Scalars["String"]>
  medicationsOrSupplements?: Maybe<Array<Scalars["String"]>>
  allergies?: Maybe<Array<Scalars["String"]>>
  additionalNotes?: Maybe<Scalars["String"]>
  combinedMedicationsDosage?: Maybe<Scalars["String"]>
  combinedMedicationsLastTimeUsed?: Maybe<UsedMedicationsLastTimeUsedEnum>
  combinedMedicationsEffectiveness?: Maybe<UsedMedicationsEffectivenessEnum>
  combinedMedicationsSideEffects?: Maybe<UsedMedicationsSideEffectsEnum>
  combinedMedicationsSideEffectsNotes?: Maybe<Scalars["String"]>
  combinedMedicationsDoctorPrescribe?: Maybe<UsedMedicationsDoctorPrescribeEnum>
  combinedMedicationsAdditionalNotes?: Maybe<Scalars["String"]>
}

export type UpdateEvensQuizUsedMedicationResponse = {
  drugName: UsedMedicationsDrugsEnum
  dosage?: Maybe<Scalars["String"]>
  lastTimeUsed?: Maybe<UsedMedicationsLastTimeUsedEnum>
  effectiveness?: Maybe<UsedMedicationsEffectivenessEnum>
  sideEffects?: Maybe<UsedMedicationsSideEffectsEnum>
  sideEffectsNotes?: Maybe<Scalars["String"]>
  doctorPrescribe?: Maybe<UsedMedicationsDoctorPrescribeEnum>
  drugNameOther?: Maybe<Scalars["String"]>
  additionalNotes?: Maybe<Scalars["String"]>
}

export type UpdateEvensRefluxEventParams = {
  id: Scalars["Int"]
  status: EventStatusEnum
  symptomsStart: Scalars["ISO8601DateTime"]
  symptomsEnd?: Maybe<Scalars["ISO8601DateTime"]>
  symptomsOngoing?: Maybe<Scalars["String"]>
  symptomsIntensity?: Maybe<Scalars["String"]>
  symptomsLocation?: Maybe<Scalars["String"]>
  symptomsAssociations?: Maybe<Array<Scalars["String"]>>
  symptomsAssociationsMoreInformation?: Maybe<Scalars["String"]>
  symptomsAssociationsOther?: Maybe<Scalars["String"]>
  triedMedication?: Maybe<Scalars["String"]>
  medicationTaken?: Maybe<Array<Scalars["String"]>>
  medicationTakenOther?: Maybe<Scalars["String"]>
  whenMedicationTaken?: Maybe<Scalars["String"]>
  wasMedicationEffective?: Maybe<Scalars["String"]>
  medicationMoreInformation?: Maybe<Scalars["String"]>
  medicationSideEffects?: Maybe<Scalars["String"]>
  medicationSideEffectsMoreInformation?: Maybe<Scalars["String"]>
  otherSymptoms?: Maybe<Scalars["String"]>
  otherTreatment?: Maybe<Scalars["String"]>
  otherInformation?: Maybe<Scalars["String"]>
}

export type UpdateEvensSubscriptionParams = {
  subscriptionId: Scalars["Int"]
  productId?: Maybe<Scalars["Int"]>
  nextBillingDate?: Maybe<Scalars["Date"]>
}

export type UpdateInsuranceParams = {
  cardholderFirstName?: Maybe<Scalars["String"]>
  cardholderLastName?: Maybe<Scalars["String"]>
  cardholderId: Scalars["String"]
  bin: Scalars["String"]
  pcn?: Maybe<Scalars["String"]>
  groupNumber?: Maybe<Scalars["String"]>
  relationshipCode?: Maybe<Scalars["String"]>
  personCode?: Maybe<Scalars["String"]>
}

export type UpdateJourneyQuizResponseParams = {
  journeyKind: JourneyKindEnum
  content: Scalars["JSON"]
}

export type UpdateKeepsConsultationsJourneyParams = {
  skipImages?: Maybe<Scalars["Boolean"]>
  finishQuiz?: Maybe<Scalars["Boolean"]>
}

export type UpdateKeepsQuizResponseParams = {
  hairLossTimeFrame?: Maybe<HairLossTimeFrameEnum>
  hairLossLoc?: Maybe<HairLossLocEnum>
  shedding?: Maybe<Array<SheddingEnum>>
  symptoms?: Maybe<Array<SymptomsEnum>>
  pastResultsSatisfaction?: Maybe<NestedQuestionEnum>
  pastResultsNotes?: Maybe<Scalars["String"]>
  hasHealthConditions?: Maybe<NestedQuestionEnum>
  healthConditions?: Maybe<Array<Scalars["String"]>>
  healthConditionsNotes?: Maybe<Scalars["String"]>
  familyHistory?: Maybe<Array<FamilyMedicalHistoryEnum>>
  pastTreatments?: Maybe<Array<PastTreatmentsEnum>>
  usedTreatmentProducts?: Maybe<NestedQuestionEnum>
  treatmentProducts?: Maybe<Array<TreatmentProductsEnum>>
  treatmentProductsOther?: Maybe<Scalars["String"]>
  treatmentProductNotes?: Maybe<Scalars["String"]>
  lifestyle?: Maybe<Array<LifestyleEnum>>
  lifestyleNotes?: Maybe<Scalars["String"]>
  stressEvents?: Maybe<Array<StressEventsEnum>>
  stressEventsOther?: Maybe<Scalars["String"]>
  erectileDysfunction?: Maybe<NestedQuestionEnum>
  priorHealthcareProfessional?: Maybe<PriorHealthcareProfessionalEnum>
  takesMedicationsOrSupplements?: Maybe<NestedQuestionEnum>
  medicationsOrSupplements?: Maybe<Array<Scalars["String"]>>
  hasAllergies?: Maybe<NestedQuestionEnum>
  allergies?: Maybe<Array<Scalars["String"]>>
  allergiesNotes?: Maybe<Scalars["String"]>
  hasAdditionalNotes?: Maybe<NestedQuestionEnum>
  additionalNotes?: Maybe<Scalars["String"]>
  satisfiedWithKeeps?: Maybe<Scalars["Boolean"]>
  satisfiedWithKeepsNotes?: Maybe<Scalars["String"]>
  hasSideEffects?: Maybe<Scalars["Boolean"]>
  sideEffects?: Maybe<Scalars["String"]>
  hasChangesInLife?: Maybe<Scalars["Boolean"]>
  changesInLife?: Maybe<Scalars["String"]>
  nextSection?: Maybe<Scalars["String"]>
}

export type UpdatePatientParams = {
  firstName?: Maybe<Scalars["String"]>
  lastName?: Maybe<Scalars["String"]>
  dob: Scalars["Date"]
}

export type UpdateQuizResponseParams = {
  id: Scalars["Int"]
  content: Scalars["JSON"]
  finalize?: Maybe<Scalars["Boolean"]>
  result?: Maybe<Scalars["JSON"]>
}

export type UpdateQuizResponseResponse = {
  __typename?: "UpdateQuizResponseResponse"
  error?: Maybe<QuizResponseError>
  quizResponse?: Maybe<QuizResponse>
}

export type UpdateUrgentCareQuizResponseParams = {
  conditionType?: Maybe<ConditionTypeEnum>
  hasMedicationForSymptoms?: Maybe<Scalars["Boolean"]>
  medicationForSymptomsNote?: Maybe<Scalars["String"]>
  covid19Symptoms?: Maybe<Array<Covid19SymptomsEnum>>
  gender?: Maybe<UrgentCareGendersEnum>
  weight?: Maybe<Scalars["Int"]>
  height?: Maybe<Scalars["Int"]>
  temperature?: Maybe<Scalars["Float"]>
  hasTemperature?: Maybe<Scalars["Boolean"]>
  pulse?: Maybe<Scalars["Int"]>
  hasPulse?: Maybe<Scalars["Boolean"]>
  lastPulseTakenTime?: Maybe<UrgentCareLastTakenTimeEnum>
  breaths?: Maybe<Scalars["Int"]>
  hasBreaths?: Maybe<Scalars["Boolean"]>
  lastBreathsTakenTime?: Maybe<UrgentCareLastTakenTimeEnum>
  bloodPressure?: Maybe<Scalars["Boolean"]>
  bloodPressureHigh?: Maybe<Scalars["Int"]>
  bloodPressureLow?: Maybe<Scalars["Int"]>
  lastBloodPressureTakenTime?: Maybe<UrgentCareLastTakenTimeEnum>
  healthConditions?: Maybe<Array<Scalars["String"]>>
  hasOtherHealthConditions?: Maybe<Scalars["Boolean"]>
  otherHealthConditionsDiagnosedRecently?: Maybe<Scalars["Boolean"]>
  otherHealthConditionsDiagnosedRecentlyNotes?: Maybe<Scalars["String"]>
  takingMedicationsOrSupplements?: Maybe<Scalars["Boolean"]>
  medicationsOrSupplements?: Maybe<Array<Scalars["String"]>>
  hadSurgeriesOrInjuries?: Maybe<Scalars["Boolean"]>
  surgeriesOrInjuries?: Maybe<Scalars["String"]>
  hasAllergies?: Maybe<Scalars["Boolean"]>
  allergies?: Maybe<Array<Scalars["String"]>>
  allergicReactionNotes?: Maybe<Scalars["String"]>
  lastDoctorVisitedTime?: Maybe<Scalars["String"]>
  hasAdditionalNotes?: Maybe<Scalars["Boolean"]>
  additionalNotes?: Maybe<Scalars["String"]>
  hasAppendicitis?: Maybe<Scalars["Boolean"]>
  stomachPainStartTime?: Maybe<HealthConditionsStartTimeEnum>
  stomachPainSeverity?: Maybe<Scalars["Int"]>
  stomachPainLocation?: Maybe<Array<StomachPainLocationEnum>>
  stomachPainHasConsistency?: Maybe<Scalars["Boolean"]>
  stomachPainConsistencyNote?: Maybe<Scalars["String"]>
  stomachPainDescription?: Maybe<Array<StomachPainDescriptionEnum>>
  stomachPainDescriptionNote?: Maybe<Scalars["String"]>
  stomachPainHurtsOnPress?: Maybe<Scalars["Boolean"]>
  stomachPainHasBetterWorse?: Maybe<Scalars["Boolean"]>
  stomachPainBetterWorseNote?: Maybe<Scalars["String"]>
  stomachPainHasExtraordinaryEvents?: Maybe<Scalars["Boolean"]>
  stomachPainExtraordinaryEventNote?: Maybe<Scalars["String"]>
  stomachPainHasDiarrhea?: Maybe<Scalars["Boolean"]>
  stomachPainDiarrheaStartTime?: Maybe<HealthConditionsStartTimeEnum>
  stomachPainDiarrheaFrequency?: Maybe<Scalars["Int"]>
  stomachPainDiarrheaHasBlood?: Maybe<StomachPainDiarrheaHasBloodEnum>
  stomachPainHasNausea?: Maybe<Scalars["Boolean"]>
  stomachPainNauseaSeverity?: Maybe<Scalars["Int"]>
  stomachPainNauseaStartTime?: Maybe<HealthConditionsStartTimeEnum>
  stomachPainNauseaFrequency?: Maybe<Scalars["Int"]>
  stomachPainNauseaHasBlood?: Maybe<Scalars["Boolean"]>
  stomachPainHasBurping?: Maybe<Scalars["Boolean"]>
  stomachPainHasGas?: Maybe<Scalars["Boolean"]>
  stomachPainFeelingFaint?: Maybe<Scalars["Boolean"]>
  utiHasLowerAbPain?: Maybe<Scalars["Boolean"]>
  utiLowerAbPainSeverity?: Maybe<Scalars["Int"]>
  utiLowerAbPainStartTime?: Maybe<HealthConditionsStartTimeEnum>
  utiHasUrinationPain?: Maybe<Scalars["Boolean"]>
  utiUrinationPainSeverity?: Maybe<Scalars["Int"]>
  utiUrinationPainStartTime?: Maybe<HealthConditionsStartTimeEnum>
  utiUrinationPainBurning?: Maybe<Scalars["Boolean"]>
  utiHasFrequentUrination?: Maybe<Scalars["Boolean"]>
  utiFrequentUrinationFrequency?: Maybe<UtiUrinationFrequencyEnum>
  utiHasUrgentUrination?: Maybe<Scalars["Boolean"]>
  utiHasPastDiagnosis?: Maybe<Scalars["Boolean"]>
  utiPastDiagnosisCount?: Maybe<Scalars["Int"]>
  utiPastDiagnosisLastTime?: Maybe<HealthConditionsLastTimeEnum>
  utiPastDiagnosisNote?: Maybe<Scalars["String"]>
  utiHasSexuallyActive?: Maybe<Scalars["Boolean"]>
  utiSexuallyActiveHasUsedProtection?: Maybe<Scalars["Boolean"]>
  utiSexuallyActiveHasStd?: Maybe<Scalars["Boolean"]>
  utiSymptoms?: Maybe<Array<UtiSymptomsEnum>>
  utiHasSurgery?: Maybe<Scalars["Boolean"]>
  utiHasKidneyStones?: Maybe<Scalars["Boolean"]>
  utiKidneyStonesNotes?: Maybe<Scalars["String"]>
  utiHasDiabetes?: Maybe<Scalars["Boolean"]>
  utiHasPregnancy?: Maybe<Scalars["Boolean"]>
  eyeInfectionSide?: Maybe<EyeInfectionSideEnum>
  eyeInfectionHasPain?: Maybe<Scalars["Boolean"]>
  eyeInfectionPainStartTime?: Maybe<HealthConditionsStartTimeEnum>
  eyeInfectionPainSeverity?: Maybe<Scalars["Int"]>
  eyeInfectionPainHasConsistency?: Maybe<Scalars["Boolean"]>
  eyeInfectionPainConsistencyNote?: Maybe<Scalars["String"]>
  eyeInfectionPainDescription?: Maybe<Array<EyeInfectionPainDescriptionEnum>>
  eyeInfectionPainDescriptionNote?: Maybe<Scalars["String"]>
  eyeInfectionSymptoms?: Maybe<Array<EyeInfectionSymptomsEnum>>
  eyeInfectionHasVisionAffected?: Maybe<Scalars["Boolean"]>
  eyeInfectionVisionAffectedNote?: Maybe<Scalars["String"]>
  eyeInfectionHasSomethingInEye?: Maybe<Scalars["Boolean"]>
  eyeInfectionSomethingInEyeNote?: Maybe<Scalars["String"]>
  eyeInfectionHasEyeTrauma?: Maybe<Scalars["Boolean"]>
  eyeInfectionEyeTraumaNote?: Maybe<Scalars["String"]>
  eyeInfectionHasPastDiagnosis?: Maybe<Scalars["Boolean"]>
  eyeInfectionPastDiagnosisCount?: Maybe<Scalars["Int"]>
  eyeInfectionPastDiagnosisLastTime?: Maybe<HealthConditionsLastTimeEnum>
  eyeInfectionPastDiagnosisNote?: Maybe<Scalars["String"]>
  eyeInfectionHasContacts?: Maybe<Scalars["Boolean"]>
  eyeInfectionContactsHasMisuse?: Maybe<Scalars["Boolean"]>
  backPainStartTime?: Maybe<HealthConditionsHowLongEnum>
  backPainSeverity?: Maybe<Scalars["Int"]>
  backPainLocation?: Maybe<Array<BackPainLocationEnum>>
  backPainHasConsistency?: Maybe<Scalars["Boolean"]>
  backPainConsistencyNote?: Maybe<Scalars["String"]>
  backPainDescription?: Maybe<Array<BackPainDescriptionEnum>>
  backPainDescriptionNote?: Maybe<Scalars["String"]>
  backPainHasPosition?: Maybe<Scalars["Boolean"]>
  backPainPositionNote?: Maybe<Scalars["String"]>
  backPainHasPastDiagnosis?: Maybe<Scalars["Boolean"]>
  backPainPastDiagnosisNote?: Maybe<Scalars["String"]>
  backPainSymptoms?: Maybe<Array<BackPainSymptomsEnum>>
  backPainHasHeavyLifting?: Maybe<Scalars["Boolean"]>
  uriHasShortBreath?: Maybe<Scalars["Boolean"]>
  uriHasCough?: Maybe<Scalars["Boolean"]>
  uriCoughStartTime?: Maybe<HealthConditionsHowLongEnum>
  uriCoughFrequency?: Maybe<UriCoughFrequencyEnum>
  uriCoughSeverity?: Maybe<Scalars["Int"]>
  uriCoughHasSleepDifficulty?: Maybe<Scalars["Boolean"]>
  uriCoughMucusColor?: Maybe<Array<UriCoughMucusColorEnum>>
  uriCoughMucusColorOther?: Maybe<Scalars["String"]>
  uriHasCongestion?: Maybe<Scalars["Boolean"]>
  uriCongestionStartTime?: Maybe<HealthConditionsHowLongEnum>
  uriCongestionSeverity?: Maybe<Scalars["Int"]>
  uriCongestionHasRunnyNose?: Maybe<Scalars["Boolean"]>
  uriCongestionHasPostNasalDrop?: Maybe<Scalars["Boolean"]>
  uriHasSoreThroat?: Maybe<Scalars["Boolean"]>
  uriSoreThroatStartTime?: Maybe<HealthConditionsHowLongEnum>
  uriSoreThroatSeverity?: Maybe<Scalars["Int"]>
  uriSoreThroatHasHurtsToSwallow?: Maybe<Scalars["Boolean"]>
  uriSoreThroatTonsilCondition?: Maybe<Array<UriSoreThroatTonsilsEnum>>
  uriSoreThroatHasHorse?: Maybe<Scalars["Boolean"]>
  uriHasSinusPain?: Maybe<Scalars["Boolean"]>
  uriSinusPainStartTime?: Maybe<HealthConditionsHowLongEnum>
  uriSinusPainSeverity?: Maybe<Scalars["Int"]>
  uriSinusPainLocation?: Maybe<Array<UriSinusPainLocationEnum>>
  uriSinusPainLocationNote?: Maybe<Scalars["String"]>
  uriSinusPainHasMucousBlood?: Maybe<Scalars["Boolean"]>
  uriSinusPainHasPastDiagnosis?: Maybe<Scalars["Boolean"]>
  uriSinusPainPastDiagnosisNote?: Maybe<Scalars["String"]>
  uriSinusPainHasSurgery?: Maybe<Scalars["Boolean"]>
  uriHasSneeze?: Maybe<Scalars["Boolean"]>
  uriSneezeHasAllergy?: Maybe<Scalars["Boolean"]>
  uriSneezeAllergyNote?: Maybe<Scalars["String"]>
  uriHasSwollenLymphNode?: Maybe<Scalars["Boolean"]>
  uriHasWheezing?: Maybe<Scalars["Boolean"]>
}

export type UpdateUserParams = {
  firstName?: Maybe<Scalars["String"]>
  lastName?: Maybe<Scalars["String"]>
  nameOnCard?: Maybe<Scalars["String"]>
  addressAttributes?: Maybe<AddressParams>
  email?: Maybe<Scalars["Email"]>
  phoneAttributes?: Maybe<PhoneParams>
  profileAttributes?: Maybe<ProfileParams>
}

export type UpdateUserProductsParams = {
  productIds: Array<Scalars["Int"]>
  journeyKind: JourneyKindEnum
}

export enum UrgentCareGendersEnum {
  Male = "male",
  Female = "female"
}

export enum UrgentCareLastTakenTimeEnum {
  LessThanThreeMonths = "less_than_three_months",
  MoreThanThreeMonths = "more_than_three_months"
}

export type UrgentCareQuizResponse = {
  __typename?: "UrgentCareQuizResponse"
  additionalNotes?: Maybe<Scalars["String"]>
  allergicReactionNotes?: Maybe<Scalars["String"]>
  allergies: Array<Scalars["String"]>
  backPainConsistencyNote?: Maybe<Scalars["String"]>
  backPainDescription: Array<BackPainDescriptionEnum>
  backPainDescriptionNote?: Maybe<Scalars["String"]>
  backPainHasConsistency?: Maybe<Scalars["Boolean"]>
  backPainHasHeavyLifting?: Maybe<Scalars["Boolean"]>
  backPainHasPastDiagnosis?: Maybe<Scalars["Boolean"]>
  backPainHasPosition?: Maybe<Scalars["Boolean"]>
  backPainLocation: Array<BackPainLocationEnum>
  backPainPastDiagnosisNote?: Maybe<Scalars["String"]>
  backPainPositionNote?: Maybe<Scalars["String"]>
  backPainSeverity?: Maybe<Scalars["Int"]>
  backPainStartTime?: Maybe<HealthConditionsHowLongEnum>
  backPainSymptoms: Array<BackPainSymptomsEnum>
  bloodPressure?: Maybe<Scalars["Boolean"]>
  bloodPressureHigh?: Maybe<Scalars["Int"]>
  bloodPressureLow?: Maybe<Scalars["Int"]>
  breaths?: Maybe<Scalars["Int"]>
  conditionType?: Maybe<ConditionTypeEnum>
  covid19Symptoms: Array<Covid19SymptomsEnum>
  eyeInfectionContactsHasMisuse?: Maybe<Scalars["Boolean"]>
  eyeInfectionEyeTraumaNote?: Maybe<Scalars["String"]>
  eyeInfectionHasContacts?: Maybe<Scalars["Boolean"]>
  eyeInfectionHasEyeTrauma?: Maybe<Scalars["Boolean"]>
  eyeInfectionHasPain?: Maybe<Scalars["Boolean"]>
  eyeInfectionHasPastDiagnosis?: Maybe<Scalars["Boolean"]>
  eyeInfectionHasSomethingInEye?: Maybe<Scalars["Boolean"]>
  eyeInfectionHasVisionAffected?: Maybe<Scalars["Boolean"]>
  eyeInfectionPainConsistencyNote?: Maybe<Scalars["String"]>
  eyeInfectionPainDescription: Array<EyeInfectionPainDescriptionEnum>
  eyeInfectionPainDescriptionNote?: Maybe<Scalars["String"]>
  eyeInfectionPainHasConsistency?: Maybe<Scalars["Boolean"]>
  eyeInfectionPainSeverity?: Maybe<Scalars["Int"]>
  eyeInfectionPainStartTime?: Maybe<HealthConditionsStartTimeEnum>
  eyeInfectionPastDiagnosisCount?: Maybe<Scalars["Int"]>
  eyeInfectionPastDiagnosisLastTime?: Maybe<HealthConditionsLastTimeEnum>
  eyeInfectionPastDiagnosisNote?: Maybe<Scalars["String"]>
  eyeInfectionSide?: Maybe<EyeInfectionSideEnum>
  eyeInfectionSomethingInEyeNote?: Maybe<Scalars["String"]>
  eyeInfectionSymptoms: Array<EyeInfectionSymptomsEnum>
  eyeInfectionVisionAffectedNote?: Maybe<Scalars["String"]>
  gender?: Maybe<UrgentCareGendersEnum>
  hadSurgeriesOrInjuries?: Maybe<Scalars["Boolean"]>
  hasAdditionalNotes?: Maybe<Scalars["Boolean"]>
  hasAllergies?: Maybe<Scalars["Boolean"]>
  hasAppendicitis?: Maybe<Scalars["Boolean"]>
  hasBreaths?: Maybe<Scalars["Boolean"]>
  hasMedicationForSymptoms?: Maybe<Scalars["Boolean"]>
  hasOtherHealthConditions?: Maybe<Scalars["Boolean"]>
  hasPulse?: Maybe<Scalars["Boolean"]>
  hasTemperature?: Maybe<Scalars["Boolean"]>
  healthConditions: Array<Scalars["String"]>
  height?: Maybe<Scalars["Int"]>
  id: Scalars["Int"]
  lastBloodPressureTakenTime?: Maybe<UrgentCareLastTakenTimeEnum>
  lastBreathsTakenTime?: Maybe<UrgentCareLastTakenTimeEnum>
  lastDoctorVisitedTime?: Maybe<Scalars["String"]>
  lastPulseTakenTime?: Maybe<UrgentCareLastTakenTimeEnum>
  medicationForSymptomsNote?: Maybe<Scalars["String"]>
  medicationsOrSupplements: Array<Scalars["String"]>
  otherHealthConditionsDiagnosedRecently?: Maybe<Scalars["Boolean"]>
  otherHealthConditionsDiagnosedRecentlyNotes?: Maybe<Scalars["String"]>
  pharmacy?: Maybe<Pharmacy>
  pulse?: Maybe<Scalars["Int"]>
  stomachPainBetterWorseNote?: Maybe<Scalars["String"]>
  stomachPainConsistencyNote?: Maybe<Scalars["String"]>
  stomachPainDescription: Array<StomachPainDescriptionEnum>
  stomachPainDescriptionNote?: Maybe<Scalars["String"]>
  stomachPainDiarrheaFrequency?: Maybe<Scalars["Int"]>
  stomachPainDiarrheaHasBlood?: Maybe<StomachPainDiarrheaHasBloodEnum>
  stomachPainDiarrheaStartTime?: Maybe<HealthConditionsStartTimeEnum>
  stomachPainExtraordinaryEventNote?: Maybe<Scalars["String"]>
  stomachPainFeelingFaint?: Maybe<Scalars["Boolean"]>
  stomachPainHasBetterWorse?: Maybe<Scalars["Boolean"]>
  stomachPainHasBurping?: Maybe<Scalars["Boolean"]>
  stomachPainHasConsistency?: Maybe<Scalars["Boolean"]>
  stomachPainHasDiarrhea?: Maybe<Scalars["Boolean"]>
  stomachPainHasExtraordinaryEvents?: Maybe<Scalars["Boolean"]>
  stomachPainHasGas?: Maybe<Scalars["Boolean"]>
  stomachPainHasNausea?: Maybe<Scalars["Boolean"]>
  stomachPainHurtsOnPress?: Maybe<Scalars["Boolean"]>
  stomachPainLocation: Array<StomachPainLocationEnum>
  stomachPainNauseaFrequency?: Maybe<Scalars["Int"]>
  stomachPainNauseaHasBlood?: Maybe<Scalars["Boolean"]>
  stomachPainNauseaSeverity?: Maybe<Scalars["Int"]>
  stomachPainNauseaStartTime?: Maybe<HealthConditionsStartTimeEnum>
  stomachPainSeverity?: Maybe<Scalars["Int"]>
  stomachPainStartTime?: Maybe<HealthConditionsStartTimeEnum>
  surgeriesOrInjuries?: Maybe<Scalars["String"]>
  takingMedicationsOrSupplements?: Maybe<Scalars["Boolean"]>
  temperature?: Maybe<Scalars["Float"]>
  uriCongestionHasPostNasalDrop?: Maybe<Scalars["Boolean"]>
  uriCongestionHasRunnyNose?: Maybe<Scalars["Boolean"]>
  uriCongestionSeverity?: Maybe<Scalars["Int"]>
  uriCongestionStartTime?: Maybe<HealthConditionsHowLongEnum>
  uriCoughFrequency?: Maybe<UriCoughFrequencyEnum>
  uriCoughHasSleepDifficulty?: Maybe<Scalars["Boolean"]>
  uriCoughMucusColor: Array<UriCoughMucusColorEnum>
  uriCoughMucusColorOther?: Maybe<Scalars["String"]>
  uriCoughSeverity?: Maybe<Scalars["Int"]>
  uriCoughStartTime?: Maybe<HealthConditionsHowLongEnum>
  uriHasCongestion?: Maybe<Scalars["Boolean"]>
  uriHasCough?: Maybe<Scalars["Boolean"]>
  uriHasShortBreath?: Maybe<Scalars["Boolean"]>
  uriHasSinusPain?: Maybe<Scalars["Boolean"]>
  uriHasSneeze?: Maybe<Scalars["Boolean"]>
  uriHasSoreThroat?: Maybe<Scalars["Boolean"]>
  uriHasSwollenLymphNode?: Maybe<Scalars["Boolean"]>
  uriHasWheezing?: Maybe<Scalars["Boolean"]>
  uriSinusPainHasMucousBlood?: Maybe<Scalars["Boolean"]>
  uriSinusPainHasPastDiagnosis?: Maybe<Scalars["Boolean"]>
  uriSinusPainHasSurgery?: Maybe<Scalars["Boolean"]>
  uriSinusPainLocation: Array<UriSinusPainLocationEnum>
  uriSinusPainLocationNote?: Maybe<Scalars["String"]>
  uriSinusPainPastDiagnosisNote?: Maybe<Scalars["String"]>
  uriSinusPainSeverity?: Maybe<Scalars["Int"]>
  uriSinusPainStartTime?: Maybe<HealthConditionsHowLongEnum>
  uriSneezeAllergyNote?: Maybe<Scalars["String"]>
  uriSneezeHasAllergy?: Maybe<Scalars["Boolean"]>
  uriSoreThroatHasHorse?: Maybe<Scalars["Boolean"]>
  uriSoreThroatHasHurtsToSwallow?: Maybe<Scalars["Boolean"]>
  uriSoreThroatSeverity?: Maybe<Scalars["Int"]>
  uriSoreThroatStartTime?: Maybe<HealthConditionsHowLongEnum>
  uriSoreThroatTonsilCondition: Array<UriSoreThroatTonsilsEnum>
  user: User
  utiFrequentUrinationFrequency?: Maybe<UtiUrinationFrequencyEnum>
  utiHasDiabetes?: Maybe<Scalars["Boolean"]>
  utiHasFrequentUrination?: Maybe<Scalars["Boolean"]>
  utiHasKidneyStones?: Maybe<Scalars["Boolean"]>
  utiHasLowerAbPain?: Maybe<Scalars["Boolean"]>
  utiHasPastDiagnosis?: Maybe<Scalars["Boolean"]>
  utiHasPregnancy?: Maybe<Scalars["Boolean"]>
  utiHasSexuallyActive?: Maybe<Scalars["Boolean"]>
  utiHasSurgery?: Maybe<Scalars["Boolean"]>
  utiHasUrgentUrination?: Maybe<Scalars["Boolean"]>
  utiHasUrinationPain?: Maybe<Scalars["Boolean"]>
  utiKidneyStonesNotes?: Maybe<Scalars["String"]>
  utiLowerAbPainSeverity?: Maybe<Scalars["Int"]>
  utiLowerAbPainStartTime?: Maybe<HealthConditionsStartTimeEnum>
  utiPastDiagnosisCount?: Maybe<Scalars["Int"]>
  utiPastDiagnosisLastTime?: Maybe<HealthConditionsLastTimeEnum>
  utiPastDiagnosisNote?: Maybe<Scalars["String"]>
  utiSexuallyActiveHasStd?: Maybe<Scalars["Boolean"]>
  utiSexuallyActiveHasUsedProtection?: Maybe<Scalars["Boolean"]>
  utiSymptoms: Array<UtiSymptomsEnum>
  utiUrinationPainBurning?: Maybe<Scalars["Boolean"]>
  utiUrinationPainSeverity?: Maybe<Scalars["Int"]>
  utiUrinationPainStartTime?: Maybe<HealthConditionsStartTimeEnum>
  weight?: Maybe<Scalars["Int"]>
}

export enum UriCoughFrequencyEnum {
  Seconds = "seconds",
  OneMinute = "one_minute",
  FiveMinutes = "five_minutes",
  FifteenMinutes = "fifteen_minutes",
  HourOrLess = "hour_or_less"
}

export enum UriCoughMucusColorEnum {
  Brown = "brown",
  Green = "green",
  Yellow = "yellow",
  White = "white",
  Dry = "dry",
  Other = "other"
}

export enum UriSinusPainLocationEnum {
  Forehead = "forehead",
  BetweenEyes = "between_eyes",
  BelowEyes = "below_eyes",
  Toothache = "toothache",
  Neck = "neck",
  Other = "other"
}

export enum UriSoreThroatTonsilsEnum {
  Swollen = "swollen",
  Red = "red",
  Spots = "spots",
  Normal = "normal",
  Removed = "removed"
}

export enum UsedMedicationsDoctorPrescribeEnum {
  Yes = "yes",
  NoDifferentFastReliefTreatment = "no_different_fast_relief_treatment",
  NoDifferentLongLastingTreatment = "no_different_long_lasting_treatment",
  Unsure = "unsure"
}

export enum UsedMedicationsDrugsEnum {
  TumsMylantaMaaloxRolaids = "tums_mylanta_maalox_rolaids",
  CarafateGaviscon = "carafate_gaviscon",
  ZantacRanitidine = "zantac_ranitidine",
  PepcidFamotidine = "pepcid_famotidine",
  TagametCimetidine = "tagamet_cimetidine",
  PrilosecOmeprazole = "prilosec_omeprazole",
  NexiumEsomeprazole = "nexium_esomeprazole",
  PrevacidLansoprazole = "prevacid_lansoprazole",
  DexilantDexlansoprazole = "dexilant_dexlansoprazole",
  RabeprazoleAciphex = "rabeprazole_aciphex",
  NotUsedAnyMedications = "not_used_any_medications",
  CombinedMedications = "combined_medications",
  Other = "other"
}

export enum UsedMedicationsEffectivenessEnum {
  Always = "always",
  Sometimes = "sometimes",
  Rarely = "rarely",
  Never = "never"
}

export enum UsedMedicationsEnum {
  OverTheCounterPainRelief = "over_the_counter_pain_relief",
  PrescriptionPainRelief = "prescription_pain_relief",
  Triptans = "triptans",
  BetaBlocker = "beta_blocker",
  Anticonvulsants = "anticonvulsants",
  Antidepressants = "antidepressants",
  AntiNausea = "anti_nausea",
  Botox = "botox",
  OccipitalNerveInjections = "occipital_nerve_injections",
  Opioids = "opioids",
  Other = "other",
  None = "none"
}

export enum UsedMedicationsLastTimeUsedEnum {
  CurrentlyTaking = "currently_taking",
  LessThanOneMonthAgo = "less_than_one_month_ago",
  OneToFiveMonthsAgo = "one_to_five_months_ago",
  SixToTwelveMonthsAgo = "six_to_twelve_months_ago",
  OverTwelveMonthsAgo = "over_twelve_months_ago"
}

export enum UsedMedicationsSideEffectsEnum {
  Yes = "yes",
  No = "no",
  Sometimes = "sometimes"
}

export enum UsedProductsEnum {
  Naproxen = "naproxen",
  Sumatriptan = "sumatriptan",
  Rizatriptan = "rizatriptan",
  Metoclopramide = "metoclopramide",
  Propranolol = "propranolol",
  Metoprolol = "metoprolol",
  Topiramate = "topiramate",
  Amitriptyline = "amitriptyline",
  None = "none"
}

export type User = {
  __typename?: "User"
  active: Scalars["Boolean"]
  activeJourneys: Array<Journey>
  activeSubscriptions: Array<Subscription>
  activeSubscriptionsCount: Scalars["Int"]
  address?: Maybe<Address>
  availableProductsToAdd: Array<Product>
  bundledSubscriptions: Array<Array<Subscription>>
  cohort?: Maybe<Scalars["String"]>
  consultation?: Maybe<Consultation>
  couponAvailable: Scalars["Boolean"]
  coveMigraineEvents: Array<CoveMigraineEvent>
  coveMigraineEventsThisMonthCount: Scalars["Int"]
  coveQuizResponse?: Maybe<CoveQuizResponse>
  coveRecommendedProduct: Product
  /** @deprecated Multiple journeys are now possible, use activeJourneys field instead */
  currentJourney?: Maybe<Journey>
  currentUserPrescriptions?: Maybe<Array<UserPrescription>>
  daysUntilFirstRefill: Scalars["Int"]
  dob?: Maybe<Scalars["Date"]>
  doctorId?: Maybe<Scalars["Int"]>
  doseSpotId?: Maybe<Scalars["String"]>
  eCommerceUser?: Maybe<Scalars["Boolean"]>
  eaglePatientId?: Maybe<Scalars["Int"]>
  email: Scalars["String"]
  evensQuizResponse?: Maybe<EvensQuizResponse>
  evensRefluxEvents: Array<EvensRefluxEvent>
  evensRefluxEventsThisWeekCount: Scalars["Int"]
  firstName: Scalars["String"]
  fullName: Scalars["String"]
  getStartedOffers: Array<GetStartedOffer>
  hasActiveSubscription?: Maybe<Scalars["Boolean"]>
  hasDoctorTreatmentChange: Scalars["Boolean"]
  hasEaglePatientId: Scalars["Boolean"]
  hasPassword?: Maybe<Scalars["Boolean"]>
  id: Scalars["Int"]
  insurances?: Maybe<Array<Insurance>>
  invoices: Array<Invoice>
  isImpersonated: Scalars["Boolean"]
  journeys: Array<Journey>
  keepsQuizResponse?: Maybe<KeepsQuizResponse>
  keepsQuizType?: Maybe<KeepsJourneyFlowTypeEnum>
  lastName: Scalars["String"]
  mediaSetEligibleForUpload?: Maybe<MediaSet>
  mediaSets: Array<MediaSet>
  messages?: Maybe<Array<GenericMessage>>
  nameOnCard: Scalars["String"]
  offer?: Maybe<Offer>
  outOfState: Scalars["Boolean"]
  outsidePharmacy?: Maybe<Scalars["Boolean"]>
  pharmacy?: Maybe<Pharmacy>
  phone?: Maybe<Phone>
  pricing: Pricing
  profile?: Maybe<Profile>
  progressImages: Array<ProgressImage>
  /** @deprecated Renamed to keepsQuizResponse */
  quizResponse?: Maybe<KeepsQuizResponse>
  quizResponses: Array<QuizResponse>
  refillSubscription?: Maybe<Subscription>
  renewalPricing: Array<RenewalBundle>
  requiresIdPhoto?: Maybe<Scalars["Boolean"]>
  requiresPhoneCall: Scalars["Boolean"]
  site: SiteEnum
  stripeCards?: Maybe<Array<StripeCard>>
  stripeCustomerId?: Maybe<Scalars["String"]>
  subscription?: Maybe<Subscription>
  subscriptions: Array<Subscription>
  treatmentUpdate: TreatmentUpdate
  userJourneyStatus: UserJourneyStatus
  userPrescriptions?: Maybe<Array<UserPrescription>>
  userSetPassword?: Maybe<Scalars["Boolean"]>
  utmParams: Array<UtmParam>
  videos: Array<Video>
}

export type UserCouponAvailableArgs = {
  code: Scalars["String"]
}

export type UserGetStartedOffersArgs = {
  productIds: Array<Scalars["Int"]>
}

export type UserMediaSetEligibleForUploadArgs = {
  setType: MediaSetTypeEnum
}

export type UserPricingArgs = {
  productIds: Array<Scalars["Int"]>
  journeyKind?: Maybe<JourneyKindEnum>
  couponCode?: Maybe<Scalars["String"]>
  applyCredits?: Maybe<Scalars["Boolean"]>
  applyOffer?: Maybe<Scalars["Boolean"]>
}

export type UserQuizResponsesArgs = {
  configName: Scalars["String"]
  configVersion?: Maybe<Scalars["Int"]>
}

export type UserSubscriptionArgs = {
  id: Scalars["Int"]
}

export type UserTreatmentUpdateArgs = {
  productIds: Array<Scalars["Int"]>
}

export type UserCredit = {
  __typename?: "UserCredit"
  amountInCents: Scalars["Int"]
  createdAt: Scalars["DateTime"]
  creditReason: Scalars["String"]
  creditType: Scalars["String"]
  description?: Maybe<Scalars["String"]>
  id: Scalars["Int"]
  invoiceId?: Maybe<Scalars["Int"]>
  orderId?: Maybe<Scalars["Int"]>
  site: Scalars["String"]
  updatedAt: Scalars["DateTime"]
  userId: Scalars["Int"]
}

export type UserJourneyStatus = {
  __typename?: "UserJourneyStatus"
  doctorSelected: Scalars["Boolean"]
  id: Scalars["Int"]
  imagesFinished: Scalars["Boolean"]
  paymentFinished: Scalars["Boolean"]
  quizFinished: Scalars["Boolean"]
  skippedImages: Scalars["Boolean"]
}

export type UserPrescription = {
  __typename?: "UserPrescription"
  expiresAt?: Maybe<Scalars["DateTime"]>
  id: Scalars["Int"]
  prescribedAt?: Maybe<Scalars["DateTime"]>
  prescriptionId?: Maybe<Scalars["Int"]>
  product: Product
  productId?: Maybe<Scalars["Int"]>
  refillsRemaining?: Maybe<Scalars["Int"]>
  refillsTotal?: Maybe<Scalars["Int"]>
  user: User
}

export type UserUpdatePasswordParams = {
  resetPasswordToken?: Maybe<Scalars["String"]>
  password: Scalars["String"]
  passwordConfirmation: Scalars["String"]
}

export enum UtiSymptomsEnum {
  BackOrSidePain = "back_or_side_pain",
  BloodInUrine = "blood_in_urine",
  UnfamiliarUrineSmell = "unfamiliar_urine_smell",
  GenitalDischarge = "genital_discharge",
  Nausea = "nausea",
  None = "none"
}

export enum UtiUrinationFrequencyEnum {
  TwoOrLess = "two_or_less",
  ThreeToFive = "three_to_five",
  SixToEight = "six_to_eight",
  NineOrMore = "nine_or_more"
}

export type UtmParam = {
  __typename?: "UtmParam"
  campaign?: Maybe<Scalars["String"]>
  id: Scalars["Int"]
  medium?: Maybe<Scalars["String"]>
  source?: Maybe<Scalars["String"]>
}

export type VanityUrl = {
  __typename?: "VanityUrl"
  active: Scalars["Boolean"]
  bannerText: Scalars["String"]
  campaignName: Scalars["String"]
  checkoutSentence: Scalars["String"]
  id: Scalars["Int"]
  isMisspelling: Scalars["Boolean"]
  promoSentence: Scalars["String"]
  redirectPath: Scalars["String"]
  topBannerText: Scalars["String"]
  utmCampaign: Scalars["String"]
  utmMedium: Scalars["String"]
  utmSource: Scalars["String"]
  vanityUrl: Scalars["String"]
}

export type Video = {
  __typename?: "Video"
  consultation?: Maybe<Consultation>
  contentType: ContentTypeEnum
  id: Scalars["Int"]
  mediaSet?: Maybe<MediaSet>
  updatedAt: Scalars["DateTimeWithZone"]
  user?: Maybe<User>
  videoType: VideoTypeEnum
  videoUrl: Scalars["String"]
}

export enum VideoTypeEnum {
  VideoOne = "video_one",
  VideoTwo = "video_two"
}

export enum VisitedHealthcareDoctorEnum {
  PrimaryCareDoctor = "primary_care_doctor",
  Neurologist = "neurologist",
  UrgentCareCenter = "urgent_care_center",
  EmergencyRoom = "emergency_room",
  OtherHealthcareProfessional = "other_healthcare_professional",
  No = "no"
}

export type AcceptStartQuizAgreementsMutationVariables = Exact<{
  params: AcceptStartQuizAgreementsParams
}>

export type AcceptStartQuizAgreementsMutation = {
  __typename?: "Mutation"
  acceptStartQuizAgreements: { __typename?: "User" } & StartJourneyUserFragment
}

export type ApproveTreatmentPlanMutationVariables = Exact<{
  params?: Maybe<ApproveTreatmentParams>
}>

export type ApproveTreatmentPlanMutation = {
  __typename?: "Mutation"
  approveTreatment: Array<{
    __typename?: "Subscription"
    id: number
    status: SubscriptionStatusEnum
    nextBillingDate?: Maybe<any>
    estimatedNextBillingDate?: Maybe<any>
    activeProducts: Array<{ __typename?: "Product"; id: number }>
    user: { __typename?: "User" } & RootQueryUserFragment
  }>
}

export type CoveChangePasswordMutationVariables = Exact<{
  password: Scalars["String"]
  resetPasswordToken: Scalars["String"]
}>

export type CoveChangePasswordMutation = { __typename?: "Mutation"; user?: Maybe<{ __typename?: "User"; id: number }> }

export type CheckoutMutationVariables = Exact<{
  params: CheckoutParams
}>

export type CheckoutMutation = { __typename?: "Mutation"; user: { __typename?: "User" } & RootQueryUserFragment }

export type CreateEmailListMutationVariables = Exact<{
  emailList: CreateEmailListParams
}>

export type CreateEmailListMutation = {
  __typename?: "Mutation"
  createEmailList: { __typename?: "EmailList"; id: number }
}

export type CoveCreateUserMutationVariables = Exact<{
  user: CreateUserParams
}>

export type CoveCreateUserMutation = { __typename?: "Mutation"; user: { __typename?: "User" } & RootQueryUserFragment }

export type CreateCoveMigraineEventMutationVariables = Exact<{
  params: CreateCoveMigraineEventParams
}>

export type CreateCoveMigraineEventMutation = {
  __typename?: "Mutation"
  coveResponse: { __typename?: "CoveMigraineEvent" } & MigraineEventResponseFieldsFragment
}

export type FinishQuizMutationVariables = Exact<{
  params?: Maybe<FinishQuizParams>
}>

export type FinishQuizMutation = {
  __typename?: "Mutation"
  finishQuiz: {
    __typename?: "User"
    id: number
    activeJourneys: Array<{
      __typename?: "Journey"
      nextActions: Array<NextActionEnum>
      status: string
      user: { __typename?: "User" } & RootQueryUserFragment
    }>
  }
}

export type FinishRetakeMediaMutationVariables = Exact<{
  mediaSetId: Scalars["Int"]
}>

export type FinishRetakeMediaMutation = {
  __typename?: "Mutation"
  finishRetakeMedia?: Maybe<{ __typename?: "MediaSet"; id: number }>
}

export type CoveSendResetPasswordInstructionsMutationVariables = Exact<{
  email: Scalars["Email"]
}>

export type CoveSendResetPasswordInstructionsMutation = {
  __typename?: "Mutation"
  sendResetPasswordInstructions?: Maybe<{ __typename?: "User"; id: number }>
}

export type InsuranceUpdateMutationVariables = Exact<{
  insurance: UpdateInsuranceParams
}>

export type InsuranceUpdateMutation = {
  __typename?: "Mutation"
  insuranceUpdate: {
    __typename?: "Insurance"
    id: number
    user?: Maybe<{
      __typename?: "User"
      activeJourneys: Array<{ __typename?: "Journey"; id: number; nextActions: Array<NextActionEnum> }>
    }>
  }
}

export type CreatePharmacyMutationVariables = Exact<{
  pharmacy: CreatePharmacyParams
}>

export type CreatePharmacyMutation = {
  __typename?: "Mutation"
  pharmacy: {
    __typename?: "Pharmacy"
    user?: Maybe<{
      __typename?: "User"
      id: number
      activeJourneys: Array<{ __typename?: "Journey"; id: number; nextActions: Array<NextActionEnum> }>
    }>
  } & PharmacyAttributesFragment
}

export type ReadDoctorMessagesMutationVariables = Exact<{
  consultationId: Scalars["Int"]
}>

export type ReadDoctorMessagesMutation = {
  __typename?: "Mutation"
  readDoctorMessages: {
    __typename?: "Consultation"
    id: number
    unreadDoctorMessagesCount: number
    consultationMessages: Array<{ __typename?: "ConsultationMessage"; id: number } & DoctorMessageFragment>
  }
}

export type CoveRegisterUserMutationVariables = Exact<{
  user: RegisterUserParams
}>

export type CoveRegisterUserMutation = {
  __typename?: "Mutation"
  registerUser: { __typename?: "User" } & AccountCreationUserFragment & CheckoutUserFragment
}

export type SendConsultationMessageToDoctorMutationVariables = Exact<{
  consultationId: Scalars["Int"]
  body: Scalars["String"]
  from: ConsultationMessageFromEnum
}>

export type SendConsultationMessageToDoctorMutation = {
  __typename?: "Mutation"
  sendConsultationMessage: {
    __typename?: "Consultation"
    id: number
    consultationMessages: Array<{ __typename?: "ConsultationMessage" } & DoctorMessageFragment>
  }
}

export type SetCurrentVanityUrlMutationVariables = Exact<{
  id: Scalars["Int"]
}>

export type SetCurrentVanityUrlMutation = {
  __typename?: "Mutation"
  vanityUrl: { __typename?: "VanityUrl"; id: number } & VanityUrlAttributesFragment
}

export type CoveSignInMutationVariables = Exact<{
  email: Scalars["Email"]
  password: Scalars["String"]
}>

export type CoveSignInMutation = {
  __typename?: "Mutation"
  loggedInUser?: Maybe<{ __typename?: "User" } & RootQueryUserFragment>
}

export type CoveSignInViaReturningHashMutationVariables = Exact<{
  returningHash: Scalars["String"]
}>

export type CoveSignInViaReturningHashMutation = {
  __typename?: "Mutation"
  user?: Maybe<{ __typename?: "User" } & RootQueryUserFragment>
}

export type CoveSignOutMutationVariables = Exact<{ [key: string]: never }>

export type CoveSignOutMutation = { __typename?: "Mutation"; signOut: { __typename?: "Response"; success: boolean } }

export type StartQuizMutationVariables = Exact<{
  params: StartQuizInJourneyParams
}>

export type StartQuizMutation = {
  __typename?: "Mutation"
  startQuizInJourney: { __typename?: "User" } & StartJourneyUserFragment
}

export type SubscriptionUpdateMutationVariables = Exact<{
  subscriptions: Array<SubscriptionUpdateParams>
}>

export type SubscriptionUpdateMutation = {
  __typename?: "Mutation"
  subscriptionUpdate?: Maybe<
    Array<{
      __typename?: "Subscription"
      id: number
      status: SubscriptionStatusEnum
      nextBillingDate?: Maybe<any>
      estimatedNextBillingDate?: Maybe<any>
      activeProducts: Array<{ __typename?: "Product"; id: number }>
    }>
  >
}

export type UpdateLegalsAcceptedMutationVariables = Exact<{
  agreementNames: Array<AgreementNameEnum>
  accepted: Scalars["Boolean"]
}>

export type UpdateLegalsAcceptedMutation = {
  __typename?: "Mutation"
  updateLegals: Array<{ __typename?: "Legal"; id: number; agreementName: AgreementNameEnum }>
}

export type UpdateCoveMigraineEventMutationVariables = Exact<{
  params: UpdateCoveMigraineEventParams
}>

export type UpdateCoveMigraineEventMutation = {
  __typename?: "Mutation"
  coveResponse: { __typename?: "CoveMigraineEvent" } & MigraineEventResponseFieldsFragment
}

export type UpdateQuizResponseMutationVariables = Exact<{
  response: UpdateCoveQuizResponseParams
  journeyKind: JourneyKindEnum
}>

export type UpdateQuizResponseMutation = {
  __typename?: "Mutation"
  response: { __typename?: "CoveQuizResponse"; id: number; user: { __typename?: "User" } & RootQueryUserFragment }
}

export type UpdateSubscriptionsMutationVariables = Exact<{
  expectedPrice: Scalars["Int"]
}>

export type UpdateSubscriptionsMutation = {
  __typename?: "Mutation"
  updateSubscriptions: { __typename?: "User"; id: number } & SubscriptionsFragment &
    ActiveSubscriptionsFragment &
    ConsultationFragment &
    StartJourneyUserFragment
}

export type UpdateUserMutationVariables = Exact<{
  params: UpdateUserParams
  stripeToken?: Maybe<Scalars["String"]>
}>

export type UpdateUserMutation = {
  __typename?: "Mutation"
  updateUser: { __typename?: "User" } & RootQueryUserFragment
}

export type UpdateUserProductsMutationVariables = Exact<{
  params: UpdateUserProductsParams
}>

export type UpdateUserProductsMutation = {
  __typename?: "Mutation"
  updateUserProducts: { __typename?: "User" } & RootQueryUserFragment
}

export type UploadProgressImageMutationVariables = Exact<{
  fileUrl: Scalars["String"]
  imageType: ImageTypeEnum
  mediaSetId: Scalars["Int"]
  actionType: MediaUploadActionTypeEnum
  quizUpload: Scalars["Boolean"]
  journeyKind?: Maybe<JourneyKindEnum>
}>

export type UploadProgressImageMutation = {
  __typename?: "Mutation"
  uploadProgressImage: {
    __typename?: "ProgressImage"
    user?: Maybe<{
      __typename?: "User"
      id: number
      activeJourneys: Array<{ __typename?: "Journey"; id: number; nextActions: Array<NextActionEnum> }>
    }>
  }
}

export type UploadVideoMutationVariables = Exact<{
  videoUrl: Scalars["String"]
  videoType: VideoTypeEnum
  mediaSetId: Scalars["Int"]
  actionType: MediaUploadActionTypeEnum
  quizUpload: Scalars["Boolean"]
  journeyKind?: Maybe<JourneyKindEnum>
  contentType: ContentTypeEnum
}>

export type UploadVideoMutation = {
  __typename?: "Mutation"
  uploadVideo: {
    __typename?: "Video"
    id: number
    videoType: VideoTypeEnum
    videoUrl: string
    mediaSet?: Maybe<{ __typename?: "MediaSet" } & MediaSetAttributesFragment>
  }
}

export type MediaSetAttributesFragment = {
  __typename?: "MediaSet"
  id: number
  videos: Array<{ __typename?: "Video"; videoType: VideoTypeEnum; videoUrl: string }>
  progressImages: Array<{ __typename?: "ProgressImage"; imageType: ImageTypeEnum; originalImageUrl: string }>
}

export type MediaSetFragment = {
  __typename?: "User"
  id: number
  eCommerceUser?: Maybe<boolean>
  activeJourneys: Array<{
    __typename?: "Journey"
    kind: JourneyKindEnum
    mediaSet?: Maybe<{ __typename?: "MediaSet" } & MediaSetAttributesFragment>
  }>
}

export type GetJourneyPricingQueryVariables = Exact<{
  productIds: Array<Scalars["Int"]>
  journeyKind?: Maybe<JourneyKindEnum>
  applyOffer?: Maybe<Scalars["Boolean"]>
}>

export type GetJourneyPricingQuery = {
  __typename?: "Query"
  currentLead?: Maybe<{
    __typename?: "User"
    id: number
    pricing: {
      __typename?: "Pricing"
      total: number
      totalWithDiscount: number
      subtotal: number
      subtotalWithDiscount: number
      shipping: number
      consultation?: Maybe<number>
      discount: number
      lineItems: Array<{
        __typename?: "LineItem"
        description: string
        amount: number
        amountWithDiscount: number
        isDiscount: boolean
        group: number
        kind: LineItemKindEnum
        product?: Maybe<{
          __typename?: "Product"
          id: number
          needsPrescription: boolean
          drugCategory?: Maybe<DrugCategoryEnum>
          drugType: DrugTypeEnum
          dosageType?: Maybe<DosageTypeEnum>
          displayedAmount?: Maybe<string>
          displayedDosage?: Maybe<string>
          price?: Maybe<number>
          supplyInDays?: Maybe<number>
          instructions?: Maybe<string>
          daysUntilFirstRefill: number
          recurringProduct?: Maybe<{ __typename?: "Product"; id: number; price?: Maybe<number> }>
        }>
      }>
    }
  }>
  currentOffer?: Maybe<{ __typename?: "Offer"; checkoutSentence?: Maybe<string> }>
}

export type GetDisplayedProductsFragment = {
  __typename?: "Product"
  id: number
  drugType: DrugTypeEnum
  drugClass?: Maybe<DrugClassEnum>
  drugCategory?: Maybe<DrugCategoryEnum>
  needsPrescription: boolean
  supplyInDays?: Maybe<number>
  price?: Maybe<number>
  genericName?: Maybe<string>
  description?: Maybe<string>
  dosageType?: Maybe<DosageTypeEnum>
  dosageValue?: Maybe<number>
  amountType?: Maybe<AmountTypeEnum>
  amountValue?: Maybe<number>
  displayedAmount?: Maybe<string>
  displayedDosage?: Maybe<string>
  userSelectable?: Maybe<boolean>
  recurringProduct?: Maybe<{ __typename?: "Product"; id: number; price?: Maybe<number> }>
}

export type GetDisplayedProductsQueryVariables = Exact<{ [key: string]: never }>

export type GetDisplayedProductsQuery = {
  __typename?: "Query"
  displayedProducts: Array<{ __typename?: "Product" } & GetDisplayedProductsFragment>
}

export type CoveQuizResponseFragment = {
  __typename?: "CoveQuizResponse"
  id: number
  headachesFrequency?: Maybe<HeadachesFrequencyEnum>
  headachesDuration?: Maybe<HeadachesDurationEnum>
  headachesDurationNote?: Maybe<string>
  headacheAttacksCount?: Maybe<HeadacheAttacksCountEnum>
  headacheFreeBetweenAttacks?: Maybe<boolean>
  headacheGoesToMaximumIn?: Maybe<HeadacheGoesToMaximumInEnum>
  headachesChangedInLastMonths?: Maybe<boolean>
  headachesChangedInLastMonthsNotes?: Maybe<string>
  headachesIntensity?: Maybe<number>
  headachesLocation: Array<HeadachesLocationEnum>
  headachesLocationOther?: Maybe<string>
  painDescription: Array<PainDescriptionEnum>
  painDescriptionOther?: Maybe<string>
  experiencedTypesOfHeadache: Array<ExperiencedTypesOfHeadacheEnum>
  headacheStartsAfter: Array<HeadacheStartsAfterEnum>
  headacheSymptoms: Array<HeadacheSymptomsEnum>
  aurasBuildIn?: Maybe<AurasBuildInEnum>
  associationsWithAura: Array<AssociationsWithAuraEnum>
  familyMembersWithHeadaches: Array<FamilyMembersWithHeadachesEnum>
  familyMembersWithHeadachesNotes?: Maybe<string>
  headachesWakeUpAtNight?: Maybe<boolean>
  timeOfDayWhenHeadachesCome: Array<TimeOfDayWhenHeadachesComeEnum>
  lifestyleTriggers: Array<LifestyleTriggersEnum>
  lifestyleTriggersOther?: Maybe<string>
  environmentalTriggers: Array<EnvironmentalTriggersEnum>
  environmentalTriggersOther?: Maybe<string>
  visitedHealthcareDoctor: Array<VisitedHealthcareDoctorEnum>
  diagnosisFromDoctor: Array<DiagnosisFromDoctorEnum>
  diagnosisFromDoctorOther?: Maybe<string>
  treatmentFromDoctor: Array<string>
  stillTakingTreatmentFromDoctor?: Maybe<boolean>
  satisfiedTreatment?: Maybe<boolean>
  stopTreatmentReason?: Maybe<string>
  emergencyRoomReason: Array<EmergencyRoomReasonEnum>
  emergencyRoomReasonOther?: Maybe<string>
  hadTests?: Maybe<boolean>
  tests: Array<TestsEnum>
  imagingNotes?: Maybe<string>
  bloodTestNotes?: Maybe<string>
  spinalTapNotes?: Maybe<string>
  eyeExamNotes?: Maybe<string>
  otherTestNotes?: Maybe<string>
  everTriedMedication?: Maybe<boolean>
  multiSelectMedications: Array<MultiSelectMedicationsEnum>
  otherTreatmentWays: Array<OtherTreatmentWaysEnum>
  otherTreatmentWaysOther?: Maybe<string>
  otherTreatmentWaysEffective?: Maybe<boolean>
  otherTreatmentWaysEffectiveNotes?: Maybe<string>
  lifestyleChoices: Array<LifestyleChoicesEnum>
  lifestyleChoicesNotes?: Maybe<string>
  stressfulEvents: Array<StressfulEventsEnum>
  stressfulEventsOther?: Maybe<string>
  hasDepression?: Maybe<boolean>
  weight?: Maybe<number>
  height?: Maybe<number>
  bloodPressure?: Maybe<boolean>
  bloodPressureHigh?: Maybe<number>
  bloodPressureLow?: Maybe<number>
  lastBloodPressureTakenTime?: Maybe<LastTestedTimeEnum>
  hasPulse?: Maybe<boolean>
  pulse?: Maybe<number>
  lastPulseTakenTime?: Maybe<LastTestedTimeEnum>
  healthConditions: Array<HealthConditionsEnum>
  relativesMedicalHistory: Array<RelativesMedicalHistoryEnum>
  hasOtherHealthConditions?: Maybe<boolean>
  otherHealthConditions: Array<string>
  otherHealthConditionsDiagnosedRecently?: Maybe<boolean>
  otherHealthConditionsDiagnosedRecentlyNotes?: Maybe<string>
  takingMedicationsOrSupplements?: Maybe<boolean>
  medicationsOrSupplements: Array<string>
  hasAllergies?: Maybe<boolean>
  allergicReactionNotes?: Maybe<string>
  allergies: Array<string>
  hadSurgeriesOrInjuries?: Maybe<boolean>
  surgeriesOrInjuries?: Maybe<string>
  lastDoctorVisitedTime?: Maybe<LastDoctorVisitedTimeEnum>
  hasAdditionalNotes?: Maybe<boolean>
  additionalNotes?: Maybe<string>
  gender?: Maybe<GendersEnum>
  pregnancyOrTryingPregnantOrBreastfeeding?: Maybe<boolean>
  takingMedicationConsistentlyAndIsSatisfied?: Maybe<boolean>
  notTakingMedicationOrUnsatisfiedNotes?: Maybe<string>
  experiencingNewSideEffects?: Maybe<boolean>
  experiencingNewSideEffectsNotes?: Maybe<string>
  majorHealthOrLifestyleChange?: Maybe<boolean>
  majorHealthOrLifestyleChangeNotes?: Maybe<string>
  newMedicationOrAllergiesOrMedicalConditions?: Maybe<boolean>
  newMedicationOrAllergiesOrMedicalConditionsNotes?: Maybe<string>
  hasQuestionForDoctor?: Maybe<boolean>
  hasQuestionForDoctorNotes?: Maybe<string>
  multiSelectMedicationResponses: Array<{
    __typename?: "CoveQuizMultiSelectMedicationResponse"
    drugName: MultiSelectMedicationsEnum
    dosage?: Maybe<string>
    lastTimeUsed?: Maybe<LastTimeUsedEnum>
    effectiveness?: Maybe<EffectivenessEnum>
    sideEffects?: Maybe<SideEffectsEnum>
    sideEffectsNotes?: Maybe<string>
    additionalNotes?: Maybe<string>
    doctorPrescribe?: Maybe<DoctorPrescribeEnum>
    startedTaking?: Maybe<string>
  }>
}

export type CurrentLeadQuizResponseQueryVariables = Exact<{ [key: string]: never }>

export type CurrentLeadQuizResponseQuery = {
  __typename?: "Query"
  user?: Maybe<{
    __typename?: "User"
    id: number
    activeJourneys: Array<{
      __typename?: "Journey"
      id: number
      coveQuizResponse?: Maybe<{ __typename?: "CoveQuizResponse"; id: number } & CoveQuizResponseFragment>
    }>
  }>
}

export type GetSignedUrlQueryVariables = Exact<{ [key: string]: never }>

export type GetSignedUrlQuery = { __typename?: "Query"; signedUrl?: Maybe<string> }

export type StatesQueryVariables = Exact<{ [key: string]: never }>

export type StatesQuery = {
  __typename?: "Query"
  states: Array<{ __typename?: "State"; label: string; value: string }>
  allowedStates: Array<{ __typename?: "State"; value: string }>
  pillpackAllowedStates: Array<{ __typename?: "State"; label: string; value: string }>
}

export type GetSubscriptionPricingQueryVariables = Exact<{ [key: string]: never }>

export type GetSubscriptionPricingQuery = {
  __typename?: "Query"
  currentUser?: Maybe<{
    __typename?: "User"
    id: number
    activeSubscriptions: Array<{
      __typename?: "Subscription"
      id: number
      status: SubscriptionStatusEnum
      nextBillingDate?: Maybe<any>
      estimatedNextBillingDate?: Maybe<any>
      pricing: {
        __typename?: "Pricing"
        total: number
        totalWithDiscount: number
        subtotal: number
        subtotalWithDiscount: number
        shipping: number
        consultation?: Maybe<number>
        discount: number
        lineItems: Array<{
          __typename?: "LineItem"
          description: string
          amount: number
          amountWithDiscount: number
          isDiscount: boolean
          group: number
          kind: LineItemKindEnum
          product?: Maybe<{
            __typename?: "Product"
            id: number
            needsPrescription: boolean
            drugCategory?: Maybe<DrugCategoryEnum>
            supplyInDays?: Maybe<number>
            drugType: DrugTypeEnum
            dosageType?: Maybe<DosageTypeEnum>
            genericName?: Maybe<string>
            instructions?: Maybe<string>
            daysUntilFirstRefill: number
            recurringProduct?: Maybe<{ __typename?: "Product"; id: number; price?: Maybe<number> }>
          }>
        }>
      }
    }>
  }>
}

export type GetCurrentOfferFragment = {
  __typename?: "Offer"
  topBannerText?: Maybe<string>
  discountPercentage?: Maybe<number>
}

export type LeadCreationUserFragment = {
  __typename?: "User"
  id: number
  eCommerceUser?: Maybe<boolean>
  email: string
  firstName: string
  lastName: string
  fullName: string
  active: boolean
}

export type AccountCreationUserFragment = {
  __typename?: "User"
  id: number
  email: string
  firstName: string
  nameOnCard: string
  fullName: string
  eCommerceUser?: Maybe<boolean>
  active: boolean
  hasEaglePatientId: boolean
  address?: Maybe<{
    __typename?: "Address"
    id: number
    streetAddress1?: Maybe<string>
    streetAddress2?: Maybe<string>
    city?: Maybe<string>
    zipCode?: Maybe<string>
    state?: Maybe<string>
  }>
  phone?: Maybe<{ __typename?: "Phone"; id: number; phoneAreaCode?: Maybe<string>; phoneNumber?: Maybe<string> }>
  profile?: Maybe<{
    __typename?: "Profile"
    id: number
    dob?: Maybe<any>
    gender?: Maybe<string>
    termsAccepted?: Maybe<boolean>
    hearAboutUs?: Maybe<string>
  }>
  stripeCards?: Maybe<Array<{ __typename?: "StripeCard"; brand: string; last4: string; addressZip?: Maybe<string> }>>
}

export type PharmacyAttributesFragment = {
  __typename?: "Pharmacy"
  id: number
  name?: Maybe<string>
  externalId: string
  phoneNumber?: Maybe<string>
  faxNumber?: Maybe<string>
  address?: Maybe<{
    __typename?: "Address"
    id: number
    streetAddress1?: Maybe<string>
    streetAddress2?: Maybe<string>
    city?: Maybe<string>
    state?: Maybe<string>
    zipCode?: Maybe<string>
  }>
  user?: Maybe<{ __typename?: "User"; id: number }>
}

export type JourneyProductAttributesFragment = {
  __typename?: "Product"
  id: number
  displayedDosage?: Maybe<string>
  daysUntilFirstRefill: number
  drugType: DrugTypeEnum
  drugCategory?: Maybe<DrugCategoryEnum>
  dosageType?: Maybe<DosageTypeEnum>
  displayedAmount?: Maybe<string>
  supplyInDays?: Maybe<number>
  price?: Maybe<number>
  needsPrescription: boolean
  variations: Array<{
    __typename?: "Product"
    id: number
    displayedCadence?: Maybe<string>
    drugType: DrugTypeEnum
    dosageType?: Maybe<DosageTypeEnum>
    dosageValue?: Maybe<number>
    supplyInDays?: Maybe<number>
    userSelectable?: Maybe<boolean>
  }>
}

export type JourneyAttributesFragment = {
  __typename?: "Journey"
  id: number
  kind: JourneyKindEnum
  nextActions: Array<NextActionEnum>
  mediaSet?: Maybe<{ __typename?: "MediaSet" } & MediaSetAttributesFragment>
  finalProducts: Array<{ __typename?: "Product"; id: number }>
  userProducts: Array<{ __typename?: "Product"; id: number } & JourneyProductAttributesFragment>
  doctorProducts: Array<{ __typename?: "Product"; id: number } & JourneyProductAttributesFragment>
}

export type StartJourneyUserFragment = {
  __typename?: "User"
  id: number
  activeJourneys: Array<{ __typename?: "Journey" } & JourneyAttributesFragment>
  journeys: Array<{ __typename?: "Journey" } & JourneyAttributesFragment>
}

export type InsurancesUserFragment = {
  __typename?: "User"
  insurances?: Maybe<
    Array<{
      __typename?: "Insurance"
      cardholderId: string
      cardholderFirstName?: Maybe<string>
      bin: string
      pcn?: Maybe<string>
      personCode?: Maybe<string>
    }>
  >
}

export type CheckoutUserFragment = {
  __typename?: "User"
  id: number
  email: string
  nameOnCard: string
  eCommerceUser?: Maybe<boolean>
  activeJourneys: Array<{ __typename?: "Journey"; id: number; kind: JourneyKindEnum }>
  address?: Maybe<{
    __typename?: "Address"
    id: number
    streetAddress1?: Maybe<string>
    streetAddress2?: Maybe<string>
    city?: Maybe<string>
    state?: Maybe<string>
    zipCode?: Maybe<string>
  }>
  phone?: Maybe<{ __typename?: "Phone"; phoneAreaCode?: Maybe<string>; phoneNumber?: Maybe<string> }>
  stripeCards?: Maybe<Array<{ __typename?: "StripeCard"; brand: string; last4: string; addressZip?: Maybe<string> }>>
}

export type ConsultationQuizUserFragment = {
  __typename?: "User"
  id: number
  activeJourneys: Array<{
    __typename?: "Journey"
    id: number
    kind: JourneyKindEnum
    nextActions: Array<NextActionEnum>
    coveQuizResponse?: Maybe<{ __typename?: "CoveQuizResponse"; id: number } & CoveQuizResponseFragment>
  }>
}

export type DoctorMessageFragment = {
  __typename?: "ConsultationMessage"
  id: number
  body: string
  authorType: ConsultationMessageFromEnum
  authorName: string
  createdAt: any
  unreadForPatient: boolean
}

export type ConsultationFragment = {
  __typename?: "User"
  id: number
  hasDoctorTreatmentChange: boolean
  consultation?: Maybe<{
    __typename?: "Consultation"
    id: number
    status: StatusEnum
    notAMatch: boolean
    unreadDoctorMessagesCount: number
    activeDoctorSelectedProductsCount: number
    consultationMessages: Array<{ __typename?: "ConsultationMessage"; id: number } & DoctorMessageFragment>
    doctor?: Maybe<{
      __typename?: "Doctor"
      id: number
      fullName: string
      medicalSchool?: Maybe<string>
      residency?: Maybe<string>
      qualification?: Maybe<string>
      photoUrl?: Maybe<string>
    }>
    doctorMessageDisplayed?: Maybe<{
      __typename?: "ConsultationMessage"
      id: number
      body: string
      approvedByUser: boolean
      unreadForPatient: boolean
      prescriptionStatus: ConsultationMessagePrescriptionStatusEnum
      activeProducts: Array<{ __typename?: "Product"; id: number; displayedName: string; price?: Maybe<number> }>
    }>
  }>
}

export type SubscriptionsFragment = {
  __typename?: "User"
  id: number
  subscriptions: Array<{
    __typename?: "Subscription"
    id: number
    status: SubscriptionStatusEnum
    cycleInDays: number
    nextBillingDate?: Maybe<any>
    estimatedNextBillingDate?: Maybe<any>
    activeProducts: Array<{
      __typename?: "Product"
      id: number
      drugType: DrugTypeEnum
      drugCategory?: Maybe<DrugCategoryEnum>
      dosageType?: Maybe<DosageTypeEnum>
    }>
  }>
}

export type ActiveSubscriptionsFragment = {
  __typename?: "User"
  id: number
  activeSubscriptions: Array<{
    __typename?: "Subscription"
    id: number
    status: SubscriptionStatusEnum
    nextBillingDate?: Maybe<any>
    estimatedNextBillingDate?: Maybe<any>
    cycleInDays: number
    activeProducts: Array<{
      __typename?: "Product"
      id: number
      drugType: DrugTypeEnum
      drugCategory?: Maybe<DrugCategoryEnum>
      dosageType?: Maybe<DosageTypeEnum>
    }>
  }>
}

export type MigraineEventResponseFieldsFragment = {
  __typename?: "CoveMigraineEvent"
  id: number
  startedAt?: Maybe<any>
  endedAt?: Maybe<any>
  ongoing: boolean
  acuteMedicationTakenTimeframe?: Maybe<AcuteMedicationTakenTimeframeEnum>
  painIntencity?: Maybe<string>
  medicationEffective?: Maybe<boolean>
  sideEffects?: Maybe<boolean>
  sideEffectsNotes?: Maybe<string>
  pastTwoDays?: Maybe<Array<PastTwoDaysEnum>>
  additionalNotes?: Maybe<string>
  user: {
    __typename?: "User"
    id: number
    coveMigraineEventsThisMonthCount: number
    coveMigraineEvents: Array<{ __typename?: "CoveMigraineEvent"; id: number }>
  }
}

export type GetPricingFragment = {
  __typename?: "Pricing"
  lineItems: Array<{
    __typename?: "LineItem"
    kind: LineItemKindEnum
    amount: number
    amountWithDiscount: number
    product?: Maybe<{ __typename?: "Product"; id: number }>
  }>
}

export type GetPharmacyIdConstantsFragment = { __typename?: "PharmacyIdConstants"; eagle: string; pillpack: string }

export type VanityUrlAttributesFragment = {
  __typename?: "VanityUrl"
  id: number
  vanityUrl: string
  topBannerText: string
  utmSource: string
  utmMedium: string
  utmCampaign: string
  redirectPath: string
  active: boolean
}

export type RootQueryUserFragment = {
  __typename?: "User"
  id: number
  email: string
  firstName: string
  lastName: string
  fullName: string
  active: boolean
  isImpersonated: boolean
  eCommerceUser?: Maybe<boolean>
  hasDoctorTreatmentChange: boolean
  coveMigraineEventsThisMonthCount: number
  pharmacy?: Maybe<{ __typename?: "Pharmacy" } & PharmacyAttributesFragment>
  activeJourneys: Array<{ __typename?: "Journey"; id: number }>
  coveMigraineEvents: Array<{ __typename?: "CoveMigraineEvent" } & MigraineEventResponseFieldsFragment>
} & LeadCreationUserFragment &
  AccountCreationUserFragment &
  CheckoutUserFragment &
  StartJourneyUserFragment &
  ConsultationQuizUserFragment &
  MediaSetFragment &
  ConsultationFragment &
  SubscriptionsFragment &
  ActiveSubscriptionsFragment &
  InsurancesUserFragment

export type RootQueryVariables = Exact<{ [key: string]: never }>

export type RootQuery = {
  __typename?: "Query"
  user?: Maybe<{ __typename?: "User" } & RootQueryUserFragment>
  currentOffer?: Maybe<{ __typename?: "Offer" } & GetCurrentOfferFragment>
  displayedProducts: Array<{ __typename?: "Product" } & GetDisplayedProductsFragment>
  pricing: { __typename?: "Pricing" } & GetPricingFragment
  flipperFlags: { __typename?: "FlipperFlag"; showEditNbdLink: boolean }
  pharmacyIdConstants: { __typename?: "PharmacyIdConstants" } & GetPharmacyIdConstantsFragment
  currentVanityUrl?: Maybe<{ __typename?: "VanityUrl" } & VanityUrlAttributesFragment>
  vanityUrls: Array<{ __typename?: "VanityUrl" } & VanityUrlAttributesFragment>
}
